export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateOnly: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type Acl = {
  __typename?: 'ACL';
  basket?: Maybe<Basket>;
  contract?: Maybe<Contract>;
  createdAt: Scalars['Date']['output'];
  crossReferenceList?: Maybe<CrossReferenceList>;
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  level: AcLevelEnum;
  offer?: Maybe<Offer>;
  organization?: Maybe<Organization>;
  owningCustomer: Customer;
  part?: Maybe<Part>;
  type: AcTypeEnum;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
};

export enum AcLevelEnum {
  Customer = 'customer',
  Global = 'global',
  Organization = 'organization',
  User = 'user'
}

export enum AcTypeEnum {
  Admin = 'admin',
  Read = 'read',
  Restrict = 'restrict',
  Write = 'write'
}

export type Activate = {
  __typename?: 'Activate';
  getSourcingPlan: SourcingPlan;
  startSourcingPlan: SourcingPlan;
};


export type ActivateGetSourcingPlanArgs = {
  id: Scalars['String']['input'];
};


export type ActivateStartSourcingPlanArgs = {
  input: StartSourcingPlanInput;
};

export type AddContractAttachmentInput = {
  contractId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AddCrossReferencePairInput = {
  contractItem: CrossReferencePairItemInput;
  crossItem: CrossReferencePairItemInput;
  listId: Scalars['ID']['input'];
};

export type AddedCrossReferencePair = {
  __typename?: 'AddedCrossReferencePair';
  /** No crosses the contract item had, removed because it now has a cross (D11). */
  noCrossReversed: Scalars['Int']['output'];
  pair: HospitalCrossReferencePair;
};

export type AddNetworkMemberInput = {
  networkId: Scalars['String']['input'];
  users: Array<InvitedUserInput>;
};

export type AddOrganizationToCustomerInput = {
  bypassEditableCheck?: InputMaybe<Scalars['Boolean']['input']>;
  customerId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type AddSourcingPlanBasketInput = {
  basketId: Scalars['String']['input'];
  /** By pass checking if this Basket is already used in other in-process Sourcing Plans */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  sourcingPlanId: Scalars['String']['input'];
  targetSavings?: InputMaybe<Scalars['Float']['input']>;
  targetSpend?: InputMaybe<Scalars['Float']['input']>;
};

export type AddSourcingPlanBasketsStakeholdersInput = {
  basketId: Scalars['String']['input'];
  /** This Contact ID could be `User`.`id` or `Contact`.`id`, set this to `null` and use `contactInput` field, if you want to create new contact */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** Manually input Contact information, `contactId` should be `null` when using this field */
  contactInput?: InputMaybe<CreateContactInput>;
  role: SourcingPlanStakeholderRole;
  sourcingPlanId: Scalars['String']['input'];
};

export type AddSourcingPlanStakeholderInput = {
  /** This Contact ID could be `User`.`id` or `Contact`.`id`, set this to `null` and use `contactInput` field, if you want to create new contact */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** Manually input Contact information, `contactId` should be `null` when using this field */
  contactInput?: InputMaybe<CreateContactInput>;
  role: SourcingPlanStakeholderRole;
  sourcingPlanId: Scalars['String']['input'];
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  keyContact?: Maybe<OpportunityKeyContact>;
  provider?: Maybe<OpportunityProvider>;
};

export type AdminRedeemOpportunityInput = {
  customerId: Scalars['String']['input'];
  invitationId?: InputMaybe<Scalars['String']['input']>;
  secretCode: Scalars['String']['input'];
};

export type AdvancedSearchGroup = {
  children?: InputMaybe<Array<AdvancedSearchGroup>>;
  field?: InputMaybe<Scalars['String']['input']>;
  isNegated?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdvancedSearchGroupObj = {
  __typename?: 'AdvancedSearchGroupObj';
  children?: Maybe<Array<AdvancedSearchGroupObj>>;
  field?: Maybe<Scalars['String']['output']>;
  isNegated?: Maybe<Scalars['Boolean']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type AggregatedItemCommodityType = {
  __typename?: 'AggregatedItemCommodityType';
  description: Scalars['String']['output'];
  gtin: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  materialCode?: Maybe<Scalars['String']['output']>;
  medId?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type AggregatedItemSpend = {
  __typename?: 'AggregatedItemSpend';
  actualImpact?: Maybe<Scalars['Float']['output']>;
  benchmarks?: Maybe<Benchmark>;
  commodity?: Maybe<AggregatedItemCommodityType>;
  contract?: Maybe<Scalars['String']['output']>;
  currentPrice?: Maybe<Scalars['Float']['output']>;
  curvo25?: Maybe<Scalars['Float']['output']>;
  curvo50?: Maybe<Scalars['Float']['output']>;
  curvo75?: Maybe<Scalars['Float']['output']>;
  curvo90?: Maybe<Scalars['Float']['output']>;
  curvoCategory?: Maybe<Scalars['String']['output']>;
  datepurchase?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  esDescription?: Maybe<Scalars['String']['output']>;
  esProductNormalized?: Maybe<Scalars['String']['output']>;
  esProductStripped?: Maybe<Scalars['String']['output']>;
  esSupplierName?: Maybe<Scalars['String']['output']>;
  esSupplierNormalized?: Maybe<Scalars['String']['output']>;
  esVendorItemNormalized?: Maybe<Scalars['String']['output']>;
  esVendorNormalized?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['String']['output'];
  facilityItem?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  firstPurchaseDate?: Maybe<Scalars['Float']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gudid?: Maybe<ItemGudid>;
  id: Scalars['String']['output'];
  impact3m?: Maybe<Scalars['Float']['output']>;
  impact12m?: Maybe<Scalars['Float']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  l12mBenchmarks?: Maybe<Benchmark>;
  last12MonthsQuantity?: Maybe<Scalars['Float']['output']>;
  last12MonthsSpend?: Maybe<Scalars['Float']['output']>;
  lastPurchaseDate?: Maybe<Scalars['Date']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  markupAdjusted12MSpend?: Maybe<Scalars['Float']['output']>;
  markupAdjustedPrice?: Maybe<Scalars['Float']['output']>;
  matchId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationItem?: Maybe<Scalars['String']['output']>;
  poNum?: Maybe<Scalars['String']['output']>;
  poNums: Array<Scalars['String']['output']>;
  pricingTrends?: Maybe<Trend>;
  qty?: Maybe<Scalars['Float']['output']>;
  stan?: Maybe<AggregatedItemStanType>;
  submittedCategory?: Maybe<Scalars['String']['output']>;
  submittedSubcategory?: Maybe<Scalars['String']['output']>;
  toLastPurchaseDays?: Maybe<Scalars['Int']['output']>;
  topParentId?: Maybe<Scalars['String']['output']>;
  topParentName?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Scalars['Int']['output']>>;
  tsId?: Maybe<Scalars['String']['output']>;
  typeOne?: Maybe<Scalars['String']['output']>;
  typeTwo?: Maybe<Scalars['String']['output']>;
  unspsc?: Maybe<Scalars['String']['output']>;
  unspscClass?: Maybe<Scalars['String']['output']>;
  unspscClassCode?: Maybe<Scalars['String']['output']>;
  unspscCommodity?: Maybe<Scalars['String']['output']>;
  unspscCommodityCode?: Maybe<Scalars['String']['output']>;
  unspscFamily?: Maybe<Scalars['String']['output']>;
  unspscFamilyCode?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['Float']['output']>;
  utilization?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type AggregatedItemStanType = {
  __typename?: 'AggregatedItemStanType';
  brand?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  gicId: Scalars['Int']['output'];
  gicName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  manufacturerId: Scalars['String']['output'];
  material?: Maybe<Scalars['String']['output']>;
  partNumber: Scalars['String']['output'];
  productline?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  size1?: Maybe<Scalars['Float']['output']>;
  size2?: Maybe<Scalars['Float']['output']>;
  size3?: Maybe<Scalars['Float']['output']>;
  subSegment?: Maybe<Scalars['String']['output']>;
  typeOne?: Maybe<Scalars['String']['output']>;
  typeTwo?: Maybe<Scalars['String']['output']>;
};

export type AggregatedSearchResult = {
  __typename?: 'AggregatedSearchResult';
  fullResponse: Scalars['Boolean']['output'];
  hits: Array<AggregatedItemSpend>;
  savedSearch?: Maybe<SavedSearch>;
  searchFieldsFilterTerms: Array<SearchFieldFilterTerms>;
  totalHits: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type ApproveStudyLinkInput = {
  isGudidApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isMedApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isStanApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArchiveContractInput = {
  /** If true, archive the contract, if false, unarchive the contract */
  archive: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export enum AttachmentUploadedFrom {
  Hospital = 'hospital',
  Vendor = 'vendor'
}

export type AuditLog = {
  __typename?: 'AuditLog';
  actor?: Maybe<User>;
  actorId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  objectId: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
};

export type AwardPrioritiesInput = {
  opportunityId: Scalars['String']['input'];
};

export type AwardPrioritiesResult = {
  __typename?: 'AwardPrioritiesResult';
  data: Array<OfferScenarioPriority>;
};

export type AwardScenarioInput = {
  opportunityId: Scalars['String']['input'];
  scenarioId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};

export type BaseAclRecordInput = {
  id: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  type: AcTypeEnum;
};

export type BaseTierRuleInput = {
  /** Indicate the paramId of this rule in AdvancedRule config to apply JsonLogic. This field is not saved into database and will be replaced by rule id */
  advancedRuleParamId?: InputMaybe<Scalars['String']['input']>;
  basketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The local id of the rule. This is for using in advancedJsonLogic. It will be replaced by the final id when the rule is saved. */
  id?: InputMaybe<Scalars['String']['input']>;
  metricType: TierRuleMetricType;
  name?: InputMaybe<Scalars['String']['input']>;
  operator: TierRuleOperator;
  periodType: TierRulePeriodType;
  productTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType: TierRuleType;
  scope?: InputMaybe<TierRuleScope>;
  valueFirst: Scalars['Float']['input'];
  valueSecond?: InputMaybe<Scalars['Float']['input']>;
  vendors?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BaseUpdateCatalogPartTierInput = {
  partsTsId: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  uom: Scalars['String']['input'];
  uomConversion?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseUpdateOfferItemCross = {
  comment?: InputMaybe<OfferItemComment>;
  id: Scalars['String']['input'];
  noCross?: InputMaybe<Scalars['Boolean']['input']>;
  noCrossComment?: InputMaybe<Scalars['String']['input']>;
  offerTsId?: InputMaybe<Scalars['String']['input']>;
  pack?: InputMaybe<Array<CatalogPartPackInput>>;
};

export type BaseUpdateOfferItemLinkage = {
  createNew?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  itemTsId?: InputMaybe<Scalars['String']['input']>;
  type: CatalogPartType;
};

export type BaseUpdateOfferItemTierPrice = {
  conversion?: InputMaybe<Scalars['String']['input']>;
  /** Offer Item's ID */
  id: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  tierId: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['String']['input']>;
};

export type BaseUpdateOfferPricingItemTierPrice = {
  conversion?: InputMaybe<Scalars['String']['input']>;
  /** This ID has 2 posible meaning, `BaseUpdateOfferItemTierPrice.id` or `CatalogPart.ts_id` based on the prefix: `offerItem#...` or `catalogPart#...` */
  id: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  tierId: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['String']['input']>;
};

export type BaseUpdateOfferScenarioItemInput = {
  award?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  itemId: Scalars['String']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
};

export type BaseUpdateStudyLink = {
  description?: InputMaybe<Scalars['String']['input']>;
  gudidManufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  matchGudidId?: InputMaybe<Scalars['String']['input']>;
  matchMedId?: InputMaybe<Scalars['String']['input']>;
  matchStanId?: InputMaybe<Scalars['String']['input']>;
  medManufacturer?: InputMaybe<Scalars['String']['input']>;
  mfgitem?: InputMaybe<Scalars['String']['input']>;
  stanManufacturerId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  venitem?: InputMaybe<Scalars['String']['input']>;
};

export type Basket = {
  __typename?: 'Basket';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  calculatedDashboards: Array<Dashboard>;
  catalogId?: Maybe<Scalars['String']['output']>;
  complexity?: Maybe<Complexity>;
  context: Array<BasketContextResult>;
  contextStats?: Maybe<BasketContextStatsResult>;
  contract?: Maybe<Contract>;
  /** Contracts this basket is connected to; archiving the basket disconnects it from all of them. */
  contracts: Array<Contract>;
  contractsUsedIn: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  creator?: Maybe<User>;
  customer?: Maybe<Customer>;
  fullProducts: BasketFullProductsResponse;
  id: Scalars['ID']['output'];
  insights: BasketInsights;
  insights12m?: Maybe<BasketInsights>;
  isCatalogBasket: Scalars['Boolean']['output'];
  isContractBasket: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isSearchAll: Scalars['Boolean']['output'];
  isSmartBasket: Scalars['Boolean']['output'];
  isUploadBasket: Scalars['Boolean']['output'];
  jobMessage?: Maybe<Scalars['String']['output']>;
  jobRunAt?: Maybe<Scalars['Date']['output']>;
  likelihoods?: Maybe<BasketLikelihood>;
  name: Scalars['String']['output'];
  numItems: Scalars['Int']['output'];
  opportunitiesUsedIn: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  products?: Maybe<Array<BasketProduct>>;
  project?: Maybe<Project>;
  refreshGlueJobRunStatus?: Maybe<Scalars['String']['output']>;
  rules: Array<SmartBasketRule>;
  smartBasketConfig?: Maybe<SmartBasketConfig>;
  smartRules: Array<SmartRule>;
  sourcingPlanSuppliers?: Maybe<SourcingPlanSuppliers>;
  status: BasketStatusEnum;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  type: BasketType;
  typeLabel: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  visibility?: Maybe<BasketVisibilityEnum>;
};


export type BasketContextArgs = {
  input: GetBasketContextInput;
};


export type BasketFullProductsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type BasketInsightsArgs = {
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  includePercentiles?: InputMaybe<Scalars['Boolean']['input']>;
  spendDateRange?: InputMaybe<SpendDateRangeInput>;
};


export type BasketInsights12mArgs = {
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type BasketLikelihoodsArgs = {
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum BasketContextAggregateType {
  Customer = 'customer',
  Facility = 'facility',
  TopParent = 'topParent'
}

export type BasketContextResult = {
  __typename?: 'BasketContextResult';
  aggregateId: Scalars['String']['output'];
  aggregateName: Scalars['String']['output'];
  manufacturerTotal: Scalars['Float']['output'];
  marketShare: Scalars['Float']['output'];
  normalizedManufacturer: Scalars['String']['output'];
  percentiles: Array<Scalars['Float']['output']>;
  priceScore: Scalars['Int']['output'];
};

export type BasketContextStatsResult = {
  __typename?: 'BasketContextStatsResult';
  avgMarketShareTopVendor: Scalars['Float']['output'];
  catalogId: Scalars['String']['output'];
  pricingTrend: Scalars['Float']['output'];
  top3VendorsAvgMarketShare: Array<BasketContextStatsTop3>;
};

export type BasketContextStatsTop3 = {
  __typename?: 'BasketContextStatsTop3';
  avgMarketShare: Scalars['Float']['output'];
  normalizedManufacturer: Scalars['String']['output'];
};

export type BasketDashboard = {
  __typename?: 'BasketDashboard';
  basket?: Maybe<Basket>;
  basketId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dashboard?: Maybe<Dashboard>;
  dashboardId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BasketFacilityStat = {
  __typename?: 'BasketFacilityStat';
  basketId: Scalars['String']['output'];
  basketName: Scalars['String']['output'];
  facilityId: Scalars['Float']['output'];
  facilityName: Scalars['String']['output'];
  sumIqo25: Scalars['Float']['output'];
  sumIqo50: Scalars['Float']['output'];
  sumIqo75: Scalars['Float']['output'];
  sumIqo90: Scalars['Float']['output'];
  sumIqoByPercentile: Scalars['Float']['output'];
  sumProjectedSpend: Scalars['Float']['output'];
  sumTotalSpend: Scalars['Float']['output'];
  topParentId: Scalars['String']['output'];
  topParentName: Scalars['String']['output'];
};

export type BasketFullProductsResponse = {
  __typename?: 'BasketFullProductsResponse';
  data: Array<AggregatedItemSpend>;
  total: Scalars['Float']['output'];
};

export type BasketInsights = {
  __typename?: 'BasketInsights';
  basketId?: Maybe<Scalars['String']['output']>;
  complexity?: Maybe<Complexity>;
  facilityIds: Array<Scalars['Int']['output']>;
  iqo25?: Maybe<Scalars['Float']['output']>;
  iqo50?: Maybe<Scalars['Float']['output']>;
  iqo75?: Maybe<Scalars['Float']['output']>;
  iqo90?: Maybe<Scalars['Float']['output']>;
  normalizedVendors?: Maybe<Array<Scalars['String']['output']>>;
  numItems: Scalars['Int']['output'];
  opportunity25?: Maybe<Scalars['Float']['output']>;
  opportunity50?: Maybe<Scalars['Float']['output']>;
  opportunity75?: Maybe<Scalars['Float']['output']>;
  opportunity90?: Maybe<Scalars['Float']['output']>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  processingJobId?: Maybe<Scalars['String']['output']>;
  projectedSpend?: Maybe<Scalars['Float']['output']>;
  sourcingPlanSuppliers?: Maybe<SourcingPlanSuppliers>;
  topIncumbent?: Maybe<SourcingPlanTopIncumbent>;
  totalSpend: Scalars['Float']['output'];
};

export type BasketLikelihood = {
  __typename?: 'BasketLikelihood';
  catalogId?: Maybe<Scalars['String']['output']>;
  curvo25: Scalars['Float']['output'];
  curvo50: Scalars['Float']['output'];
  curvo75: Scalars['Float']['output'];
  curvo90: Scalars['Float']['output'];
  customerId: Scalars['ID']['output'];
  percentiles: Array<Scalars['Float']['output']>;
  priceScore: Scalars['Int']['output'];
  priceScoreLikelihoods: Array<Scalars['Float']['output']>;
  targetPriceScore: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type BasketMetricsUpdateResult = {
  __typename?: 'BasketMetricsUpdateResult';
  basket: Basket;
  error?: Maybe<Scalars['String']['output']>;
};

export type BasketPriority = {
  __typename?: 'BasketPriority';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BasketProduct = {
  __typename?: 'BasketProduct';
  basket: Basket;
  catalogId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  creator?: Maybe<User>;
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  normalizedManufacturer?: Maybe<Scalars['String']['output']>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  quantity?: Maybe<Scalars['Float']['output']>;
  strippedManufacturerItem?: Maybe<Scalars['String']['output']>;
  tsId: Scalars['String']['output'];
  uom: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BasketProductInput = {
  facilityId: Scalars['String']['input'];
  tsId: Scalars['String']['input'];
  uom: Scalars['String']['input'];
};

export type BasketSearchInput = {
  facilities?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type BasketSmartRuleInput = {
  commodityId?: InputMaybe<Scalars['String']['input']>;
  gicTypeOneTypeTwo?: InputMaybe<Scalars['String']['input']>;
  gmdnName?: InputMaybe<Scalars['String']['input']>;
  gudidBrand?: InputMaybe<Scalars['String']['input']>;
  gudidId?: InputMaybe<Scalars['String']['input']>;
  /** If null, create new rule otherwise update existing rule */
  id?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerItem?: InputMaybe<Scalars['String']['input']>;
  negative?: InputMaybe<Scalars['Boolean']['input']>;
  stanId?: InputMaybe<Scalars['String']['input']>;
  submittedCategory?: InputMaybe<Scalars['String']['input']>;
  submittedSubcategory?: InputMaybe<Scalars['String']['input']>;
  tsId?: InputMaybe<Scalars['String']['input']>;
  unspscClassTitle?: InputMaybe<Scalars['String']['input']>;
  unspscCommodityCode?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendorItem?: InputMaybe<Scalars['String']['input']>;
};

export type BasketSort = {
  dir: Scalars['String']['input'];
  field: BasketSortEnum;
};

export enum BasketSortEnum {
  Likelihood = 'likelihood',
  Name = 'name',
  NumItems = 'numItems',
  Opportunity = 'opportunity',
  TargetSavings = 'targetSavings',
  TotalSpend = 'totalSpend'
}

export type BasketSpendDateRangeInput = {
  dateRange?: InputMaybe<SpendDateRange>;
  spendDateRange: BasketSpendDateRanges;
};

export enum BasketSpendDateRanges {
  AllTime = 'AllTime',
  CustomDateRange = 'CustomDateRange',
  Last12Months = 'Last12Months'
}

export enum BasketStatusEnum {
  Active = 'active',
  Archived = 'archived',
  Draft = 'draft'
}

export enum BasketType {
  Archived = 'archived',
  Catalog = 'catalog',
  Contract = 'contract',
  Custom = 'custom',
  Public = 'public',
  Uploaded = 'uploaded'
}

export enum BasketVisibilityEnum {
  Everyone = 'everyone',
  TopUsers = 'topUsers'
}

export type BasketsFacilitiesChartFilter = {
  searchText?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BasketType>;
};

export type BasketsListItem = {
  __typename?: 'BasketsListItem';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  catalogId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  facilityIds: Array<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isCatalogBasket: Scalars['Boolean']['output'];
  isContractBasket: Scalars['Boolean']['output'];
  isSearchAll: Scalars['Boolean']['output'];
  isSmartBasket: Scalars['Boolean']['output'];
  isUploadBasket: Scalars['Boolean']['output'];
  likelihoods?: Maybe<Array<Scalars['Float']['output']>>;
  name: Scalars['String']['output'];
  numFacilities: Scalars['Int']['output'];
  numItems: Scalars['Int']['output'];
  opportunity: Scalars['Float']['output'];
  smartBasketConfig?: Maybe<SmartBasketConfig>;
  totalSpend: Scalars['Float']['output'];
  type: BasketType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BasketsListResult = {
  __typename?: 'BasketsListResult';
  hits: Array<BasketsListItem>;
  totalHits: Scalars['Int']['output'];
};

export type BasketsResult = {
  __typename?: 'BasketsResult';
  hits: Array<Basket>;
  totalHits: Scalars['Int']['output'];
};

export type Benchmark = {
  __typename?: 'Benchmark';
  averagePrice?: Maybe<Scalars['Float']['output']>;
  hospitalCount?: Maybe<Scalars['Float']['output']>;
  iqo25?: Maybe<Scalars['Float']['output']>;
  iqo50?: Maybe<Scalars['Float']['output']>;
  iqo75?: Maybe<Scalars['Float']['output']>;
  iqo90?: Maybe<Scalars['Float']['output']>;
  maxUnitPrice?: Maybe<Scalars['Float']['output']>;
  minUnitPrice?: Maybe<Scalars['Float']['output']>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  priceSpray?: Maybe<Array<PriceSpray>>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
};

export enum BenchmarkPercentiles {
  Iqo25 = 'iqo25',
  Iqo50 = 'iqo50',
  Iqo75 = 'iqo75',
  Iqo90 = 'iqo90'
}

export type BulkApproveStudyLinkInput = {
  catalog?: InputMaybe<StudyLinkCatalogEnum>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  studyId: Scalars['Int']['input'];
  tsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  update: ApproveStudyLinkInput;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateBasketSmartRulesInput = {
  basketId: Scalars['String']['input'];
  /** If true, replace all existing rules by the new input rules */
  replace: Scalars['Boolean']['input'];
  rules: Array<BasketSmartRuleInput>;
};

export type BulkUpdateCatalogPartTierInput = {
  tierId: Scalars['String']['input'];
  updates: Array<BaseUpdateCatalogPartTierInput>;
};

export type BulkUpdateHomepageFeaturedContentInput = {
  /** If customerId is null, which is global, remove existing global featured contents that are not in `updates`. Same with customer is not null, remove existing customer based featured contents which are not in `updates */
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** If true, replace all current existing FeaturedContent with the updates */
  replaceAll?: InputMaybe<Scalars['Boolean']['input']>;
  updates: Array<HomepageFeaturedContentUpdate>;
};

export type BulkUpdateOfferItemCrossInput = {
  offerId: Scalars['String']['input'];
  savingToCrossList?: InputMaybe<Scalars['Boolean']['input']>;
  updates: Array<BaseUpdateOfferItemCross>;
};

export type BulkUpdateOfferItemLinkageInput = {
  offerId: Scalars['String']['input'];
  savingToCrossList?: InputMaybe<Scalars['Boolean']['input']>;
  updates: Array<BaseUpdateOfferItemLinkage>;
  updatingCross?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpdateOfferItemTiersPriceInput = {
  offerId: Scalars['String']['input'];
  updates: Array<BaseUpdateOfferItemTierPrice>;
};

export type BulkUpdateOfferItemsUploadInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateOfferPricingItemTiersPriceInput = {
  offerId: Scalars['String']['input'];
  updates: Array<BaseUpdateOfferPricingItemTierPrice>;
};

export type BulkUpdateOfferScenarioItemsInput = {
  inputs: Array<BaseUpdateOfferScenarioItemInput>;
  scenarioId: Scalars['String']['input'];
};

export type BulkUpdateOpportunityItemsPricingTargetInput = {
  ids: Array<Scalars['String']['input']>;
  opportunityId: Scalars['String']['input'];
  pricingTarget?: InputMaybe<Scalars['Float']['input']>;
  pricingTargetType?: InputMaybe<OfferPricingTargetType>;
};

export type BulkUpdateStudyLinkInput = {
  catalog?: InputMaybe<StudyLinkCatalogEnum>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  studyId: Scalars['Int']['input'];
  tsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  update: BaseUpdateStudyLink;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUserOrganizationRoleUpdateInput = {
  organizationsId: Scalars['String']['input'];
  updates: Array<UserOrganizationRoleUpdateInputBase>;
};

export type BulkUserPermissionUpdateInput = {
  orgs: Array<UserOrganizationPermissionInput>;
};

export type CatalogItemTierInput = {
  /** Tier ID */
  id: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  uom: Scalars['String']['input'];
  uomConversion: Scalars['Int']['input'];
};

export type CatalogPart = {
  __typename?: 'CatalogPart';
  brjId?: Maybe<Scalars['Int']['output']>;
  /** Type of the `CatalogPart` item. `mine` means the item comes from a manufacturer/vendor which this customer is providing. Take a note that `mine` does not mean the item is in this customer's Catalog. `isCompetitor` means the items comes from a manufacturer/vendor that this customer is not providing items from */
  catalogPartType: CatalogPartType;
  category?: Maybe<Scalars['String']['output']>;
  commodityId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Customer;
  description?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gtin?: Maybe<Scalars['String']['output']>;
  gudId?: Maybe<Scalars['String']['output']>;
  isImplantable?: Maybe<Scalars['Boolean']['output']>;
  isNormalized: Scalars['Boolean']['output'];
  linkedItem?: Maybe<CatalogPart>;
  linkedTsId?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  normalizedManufacturer?: Maybe<Scalars['String']['output']>;
  offerItems?: Maybe<Array<OfferItem>>;
  originalDescription?: Maybe<Scalars['String']['output']>;
  pack: Array<CatalogPartPack>;
  part?: Maybe<Part>;
  partTiers?: Maybe<Array<CatalogPartTier>>;
  segmentationId?: Maybe<Scalars['String']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  sizeOne: Scalars['Float']['output'];
  sizeThree: Scalars['Float']['output'];
  sizeTwo: Scalars['Float']['output'];
  /** The source of Catalog Part, to check whether the item comes from uploading (`catalogUpload`) or generated (`spend`) as needed for Offer/Opportunity, Cross Reference features. `catalogUpload` means the item is in Vendor Catalog */
  source: CatalogPartSource;
  stanId?: Maybe<Scalars['String']['output']>;
  strippedManufacturerItem?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  suggestion?: Maybe<CatalogPartSuggestion>;
  tsId: Scalars['String']['output'];
  typeOneId?: Maybe<Scalars['String']['output']>;
  typeOneName?: Maybe<Scalars['String']['output']>;
  typeTwoId?: Maybe<Scalars['String']['output']>;
  typeTwoName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type CatalogPartPack = {
  __typename?: 'CatalogPartPack';
  catalogPart: CatalogPart;
  id: Scalars['String']['output'];
  numberPerPack: Scalars['Int']['output'];
  packId: Scalars['String']['output'];
  tsId: Scalars['String']['output'];
  uom: Scalars['String']['output'];
  uomConversion: Scalars['Int']['output'];
};

export type CatalogPartPackInput = {
  numberPerPack?: Scalars['Int']['input'];
  tsId: Scalars['String']['input'];
  uom?: Scalars['String']['input'];
  uomConversion?: Scalars['Int']['input'];
};

export type CatalogPartResult = {
  __typename?: 'CatalogPartResult';
  hits: Array<CatalogPart>;
  totalHits: Scalars['Int']['output'];
};

export enum CatalogPartSortFieldEnum {
  Category = 'category',
  Description = 'description',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  SubCategory = 'subCategory',
  UpdatedAt = 'updatedAt',
  Vendor = 'vendor',
  VendorItem = 'vendorItem'
}

export enum CatalogPartSource {
  CatalogUpload = 'catalogUpload',
  Pack = 'pack',
  Spend = 'spend'
}

export type CatalogPartSuggestion = {
  __typename?: 'CatalogPartSuggestion';
  isMine: Scalars['Boolean']['output'];
  item: CatalogPartSuggestionItem;
};

export type CatalogPartSuggestionItem = {
  __typename?: 'CatalogPartSuggestionItem';
  commodityId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gtin?: Maybe<Scalars['String']['output']>;
  gudId?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  sizeOne?: Maybe<Scalars['Float']['output']>;
  sizeTwo?: Maybe<Scalars['Float']['output']>;
  stanId?: Maybe<Scalars['String']['output']>;
  tsId: Scalars['String']['output'];
  typeOneId?: Maybe<Scalars['String']['output']>;
  typeOneName?: Maybe<Scalars['String']['output']>;
  typeTwoId?: Maybe<Scalars['String']['output']>;
  typeTwoName?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type CatalogPartTier = {
  __typename?: 'CatalogPartTier';
  averagePrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  curvo25?: Maybe<Scalars['Float']['output']>;
  curvo50?: Maybe<Scalars['Float']['output']>;
  curvo75?: Maybe<Scalars['Float']['output']>;
  curvo90?: Maybe<Scalars['Float']['output']>;
  customerId: Scalars['String']['output'];
  /** True means this price item was modified and is different from its correspondence (same parts_ts_id) parent tier */
  modifiedPrice?: Maybe<Scalars['Boolean']['output']>;
  pack?: Maybe<Array<CatalogPartTier>>;
  part: CatalogPart;
  partsTsId: Scalars['String']['output'];
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  price: Scalars['Float']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  tier: Tier;
  tiersId: Scalars['ID']['output'];
  uom: Scalars['String']['output'];
  uomConversion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CatalogPartTierResult = {
  __typename?: 'CatalogPartTierResult';
  hits: Array<CatalogPartTier>;
  totalHits: Scalars['Int']['output'];
};

export type CatalogPartTiersFilterInput = {
  priceFilter?: InputMaybe<CatalogPartTiersPricingFilterInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogPartTiersPricingFilterInput = {
  operator: TierFilterOperatorEnum;
  priceFirst?: InputMaybe<Scalars['Float']['input']>;
  priceSecond?: InputMaybe<Scalars['Float']['input']>;
};

export enum CatalogPartType {
  IsCompetitor = 'isCompetitor',
  Pack = 'pack',
  ToBeDeterminedMine = 'toBeDeterminedMine',
  VendorCatalog = 'vendorCatalog'
}

export type CatalogPartsSortInput = {
  direction?: InputMaybe<OrderDirection>;
  field: CatalogPartSortFieldEnum;
};

export type CatalogSearchInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isMasterCatalogSearch?: Scalars['Boolean']['input'];
  normalizedManufacturer?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogStats = {
  __typename?: 'CatalogStats';
  lastUpdatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CategoryConsultRequest = {
  __typename?: 'CategoryConsultRequest';
  /** a.k.a `Category` */
  basket?: Maybe<Basket>;
  basketId: Scalars['String']['output'];
  estimatedComplexity?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  stakeholderSupport?: Maybe<Scalars['Boolean']['output']>;
  status: CategoryConsultRequestStatus;
  suppliers?: Maybe<Scalars['Boolean']['output']>;
  targetSpendLikelihood?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type CategoryConsultRequestInput = {
  estimatedComplexity?: InputMaybe<Scalars['Boolean']['input']>;
  stakeholderSupport?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers?: InputMaybe<Scalars['Boolean']['input']>;
  targetSpendLikelihood?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CategoryConsultRequestStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Finished = 'finished'
}

export type Change = {
  __typename?: 'Change';
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type CheckExistVendorInput = {
  email: Scalars['String']['input'];
  opportunityId: Scalars['String']['input'];
};

export type CheckPermissionInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalStudies = {
  __typename?: 'ClinicalStudies';
  completionDate?: Maybe<Scalars['String']['output']>;
  leadSponsorName?: Maybe<Scalars['String']['output']>;
  nctId: Scalars['String']['output'];
  officialTitle?: Maybe<Scalars['String']['output']>;
  studyType?: Maybe<Scalars['String']['output']>;
};

export type ClinicalStudiesInput = {
  gudid: Scalars['String']['input'];
};

export type ClinicalStudiesResult = {
  __typename?: 'ClinicalStudiesResult';
  hits: Array<ClinicalStudies>;
  totalHit: Scalars['Int']['output'];
};

export type ClusterCatalogPart = {
  __typename?: 'ClusterCatalogPart';
  createdAt: Scalars['Date']['output'];
  crossReferenceCluster: CrossReferenceCluster;
  crossReferenceClusterId: Scalars['ID']['output'];
  customerId: Scalars['String']['output'];
  fromVendor?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  part: CatalogPart;
  partTsId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ClusterPart = {
  __typename?: 'ClusterPart';
  createdAt: Scalars['Date']['output'];
  crossReferenceCluster: CrossReferenceCluster;
  crossReferenceClusterId: Scalars['ID']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  part: Part;
  partTsId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CollectionStatusBySupplier = {
  __typename?: 'CollectionStatusBySupplier';
  collected: Scalars['Float']['output'];
  earned: Scalars['Float']['output'];
  supplier: Scalars['String']['output'];
};

export type CollectionStatusDistribution = {
  __typename?: 'CollectionStatusDistribution';
  collectionStatus: RebateCollectionStatus;
  earned: Scalars['Float']['output'];
};

export type CollectionStatusMonthly = {
  __typename?: 'CollectionStatusMonthly';
  collected: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  earned: Scalars['Float']['output'];
};

export type ColumnAttributes = {
  __typename?: 'ColumnAttributes';
  field: SearchField;
  filter?: Maybe<ColumnFilter>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  pin?: Maybe<Scalars['Boolean']['output']>;
  searchOn?: Maybe<Scalars['Boolean']['output']>;
  sortBy?: Maybe<OrderDirection>;
  type?: Maybe<ColumnDataType>;
};

export type ColumnAttributesInput = {
  field: SearchField;
  filter?: InputMaybe<ColumnFilterInput>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  searchOn?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<OrderDirection>;
  type?: InputMaybe<ColumnDataType>;
};

export enum ColumnDataType {
  Benchmark = 'benchmark',
  Date = 'date',
  Number = 'number',
  String = 'string'
}

export type ColumnFilter = {
  __typename?: 'ColumnFilter';
  benchmarkComparison?: Maybe<Comparison>;
  benchmarkPercentile?: Maybe<BenchmarkPercentiles>;
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  filterTerms?: Maybe<Array<Scalars['String']['output']>>;
  numberFrom?: Maybe<Scalars['Float']['output']>;
  numberTo?: Maybe<Scalars['Float']['output']>;
};

export type ColumnFilterInput = {
  benchmarkComparison?: InputMaybe<Comparison>;
  benchmarkPercentile?: InputMaybe<BenchmarkPercentiles>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  filterTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  numberFrom?: InputMaybe<Scalars['Float']['input']>;
  numberTo?: InputMaybe<Scalars['Float']['input']>;
};

export enum Comparison {
  Eq = 'eq',
  Gt = 'gt',
  Lt = 'lt'
}

export type Complexity = {
  __typename?: 'Complexity';
  measuredAt: Scalars['Date']['output'];
  metrics: Array<ComplexityMetrics>;
  overallLevel: ComplexityLevelEnum;
};

export enum ComplexityLevelEnum {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type ComplexityMetrics = {
  __typename?: 'ComplexityMetrics';
  level: ComplexityLevelEnum;
  name: ComplexityMetricsEnum;
  recordedMeasurement?: Maybe<Scalars['Float']['output']>;
};

export enum ComplexityMetricsEnum {
  ImplantableProductPercentage = 'implantableProductPercentage',
  Skus = 'skus',
  UniqueManufacturers = 'uniqueManufacturers'
}

export enum ConditionalStartDate {
  ComplianceActivationDate = 'complianceActivationDate',
  ContractStartDate = 'contractStartDate',
  RebateEffectiveDates = 'rebateEffectiveDates'
}

export enum ConstructMasterGroup {
  Arthroplasty = 'Arthroplasty',
  Other = 'Other',
  Spine = 'Spine',
  Trauma = 'Trauma'
}

export type Contact = {
  __typename?: 'Contact';
  customer?: Maybe<Customer>;
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** A wrapper Object for getting contacts, which are mixed of users and contacts */
export type ContactUserWrapper = {
  __typename?: 'ContactUserWrapper';
  /** Contact Information, if `user` is not null this contains `user` information */
  contact: Contact;
  user?: Maybe<User>;
};

/** A contract item no list crosses, in the "Needs a cross" queue (#8040, spec §5.6). */
export type ContractItemNeedingCross = {
  __typename?: 'ContractItemNeedingCross';
  /** The item, its UOM as priced, and the organization's contracts that carry it and need a cross for it. */
  item: HospitalCrossReferencePairItem;
};

/** A contract item logged as having no equivalent (#8040): nothing converts to it, on any contract. */
export type ContractItemNoCross = {
  __typename?: 'ContractItemNoCross';
  item: HospitalCrossReferencePairItem;
  note?: Maybe<Scalars['String']['output']>;
  /** When it was logged. */
  reviewedAt: Scalars['Date']['output'];
  /** Who logged it, by name. */
  reviewedBy?: Maybe<Scalars['String']['output']>;
};

export type ContractItemNoCrossesPage = {
  __typename?: 'ContractItemNoCrossesPage';
  hits: Array<ContractItemNoCross>;
  totalHits: Scalars['Int']['output'];
};

export type ContractItemsNeedingCrossPage = {
  __typename?: 'ContractItemsNeedingCrossPage';
  hits: Array<ContractItemNeedingCross>;
  totalHits: Scalars['Int']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  activeDue: Scalars['DateOnly']['output'];
  activeSince: Scalars['DateOnly']['output'];
  archivedAt?: Maybe<Scalars['Date']['output']>;
  attachments?: Maybe<Array<ContractAttachment>>;
  autoRenew: Scalars['Boolean']['output'];
  baskets: Array<Basket>;
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  crossReferenceList?: Maybe<CrossReferenceList>;
  crossReferenceListId?: Maybe<Scalars['String']['output']>;
  crossReferenceSettings: ContractCrossReferenceSettings;
  customer?: Maybe<Customer>;
  description: Scalars['String']['output'];
  editable: Scalars['String']['output'];
  extras?: Maybe<Scalars['JSON']['output']>;
  hasCustomEffectiveDates: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isETLContract: Scalars['Boolean']['output'];
  latestUploadJob?: Maybe<UploadJob>;
  latestXrefUploadJob?: Maybe<UploadJob>;
  manufacturers: Array<ContractUniqueNormalizedSuppliersOutput>;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  numTiers?: Maybe<Scalars['Int']['output']>;
  organizations: Array<ContractOrganization>;
  partsCount: Scalars['Int']['output'];
  rebateGroups: Array<RebateGroup>;
  rebates: Array<TierRebate>;
  reportStatus: ContractReportStatusEnum;
  sourcingOfficer: Scalars['String']['output'];
  status?: Maybe<ContractStatusEnum>;
  subCategories?: Maybe<Array<Scalars['String']['output']>>;
  supplier: Scalars['String']['output'];
  tiers?: Maybe<Array<ContractTier>>;
  updatedAt: Scalars['Date']['output'];
};

export type ContractAttachment = {
  __typename?: 'ContractAttachment';
  contractId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ContractBasketInput = {
  contractId: Scalars['String']['input'];
};

export type ContractCodeFilterTerms = {
  __typename?: 'ContractCodeFilterTerms';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ContractCrossReferenceListRef = {
  __typename?: 'ContractCrossReferenceListRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ContractCrossReferenceMode {
  All = 'all',
  None = 'none',
  Specific = 'specific'
}

export type ContractCrossReferenceSettings = {
  __typename?: 'ContractCrossReferenceSettings';
  /** How many lists "All lists" uses today for the contract owner. */
  allListsCount: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  /** The picked lists the viewer can read (specific mode). */
  lists: Array<ContractCrossReferenceListRef>;
  mode: ContractCrossReferenceMode;
};

export type ContractEnrichmentError = {
  __typename?: 'ContractEnrichmentError';
  curvoContractId: Scalars['String']['output'];
  curvoTierId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  tsId: Scalars['String']['output'];
};

export type ContractEnrichmentInput = {
  broadJumpProductId?: InputMaybe<Scalars['Int']['input']>;
  curvoContractId: Scalars['String']['input'];
  curvoTierId: Scalars['String']['input'];
  isMatched: Scalars['Boolean']['input'];
  recognizedUom?: InputMaybe<Scalars['String']['input']>;
  recognizedUomQuantity?: InputMaybe<Scalars['Int']['input']>;
  tsId: Scalars['String']['input'];
};

export enum ContractFilterStatus {
  Active = 'active',
  Archived = 'archived',
  Draft = 'draft',
  Expired = 'expired',
  ExpiringSoon = 'expiringSoon',
  Pending = 'pending'
}

export type ContractHistory = {
  __typename?: 'ContractHistory';
  descriptiveActions: Array<DescriptiveAction>;
  log: AuditLog;
};

export type ContractHistoryInput = {
  contractId: Scalars['String']['input'];
};

export type ContractHistoryResult = {
  __typename?: 'ContractHistoryResult';
  hits: Array<ContractHistory>;
  total: Scalars['Int']['output'];
};

export type ContractMappedFieldsType = {
  category?: InputMaybe<FieldLiteralMapping>;
  description?: InputMaybe<FieldLiteralMapping>;
  manufacturer?: InputMaybe<FieldLiteralMapping>;
  mfgitem?: InputMaybe<FieldLiteralMapping>;
  subCategory?: InputMaybe<FieldLiteralMapping>;
  tiers?: InputMaybe<Array<ContractTierMapping>>;
  uom?: InputMaybe<FieldLiteralMapping>;
  uomConversion?: InputMaybe<FieldLiteralMapping>;
  uomConversionSecondary?: InputMaybe<FieldLiteralMapping>;
  uomSecondary?: InputMaybe<FieldLiteralMapping>;
  vendor?: InputMaybe<FieldLiteralMapping>;
  venitem?: InputMaybe<FieldLiteralMapping>;
};

export type ContractMember = {
  __typename?: 'ContractMember';
  comment?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  currentPriceScore?: Maybe<Scalars['Int']['output']>;
  declinedBy?: Maybe<Scalars['String']['output']>;
  declinedByEmail?: Maybe<Scalars['String']['output']>;
  declinedByFirstName?: Maybe<Scalars['String']['output']>;
  declinedByLastName?: Maybe<Scalars['String']['output']>;
  declinedStatus?: Maybe<ContractOrganizationStatusEnum>;
  extendedStats: ContractMemberExtendedStats;
  /** Organization's ID */
  id: Scalars['String']['output'];
  lastPurchaseDate?: Maybe<Scalars['Date']['output']>;
  /** ContractOrganization's ID */
  memberId?: Maybe<Scalars['String']['output']>;
  /** Organization's name */
  name: Scalars['String']['output'];
  numItems?: Maybe<Scalars['Int']['output']>;
  parentManufacturersMarketShare: Array<ContractMemberManufacturerStats>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  priceActivationDate?: Maybe<Scalars['Date']['output']>;
  priceDeactivationDate?: Maybe<Scalars['Date']['output']>;
  tierDescription?: Maybe<Scalars['String']['output']>;
  /** Selected Tier's ID */
  tierId?: Maybe<Scalars['String']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  tiersInfo?: Maybe<Array<ContractMemberTierInfo>>;
  tiersStats?: Maybe<Array<ContractMemberTierStats>>;
  /** Organization's Top Parent's ID */
  topParentId: Scalars['String']['output'];
  /** Organization's Top Parent's name */
  topParentName: Scalars['String']['output'];
  totalSpend?: Maybe<Scalars['Float']['output']>;
  totalUnits?: Maybe<Scalars['Float']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type ContractMemberExtendedStats = {
  __typename?: 'ContractMemberExtendedStats';
  contractId: Scalars['String']['output'];
  /** Organization's ID */
  id: Scalars['String']['output'];
  last12MonthsSpend: Array<ContractMemberMonthlySpend>;
  lastPurchaseDate: Scalars['Date']['output'];
  manufacturersMarketShare: Array<ContractMemberManufacturerStats>;
};

export type ContractMemberInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  declinedStatus?: InputMaybe<ContractOrganizationStatusEnum>;
  id: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
  priceActivationDate?: InputMaybe<Scalars['Date']['input']>;
  priceDeactivationDate?: InputMaybe<Scalars['Date']['input']>;
  tierId?: InputMaybe<Scalars['String']['input']>;
  tiersInfo?: InputMaybe<Array<ContractMemberTierInfoInput>>;
};

export type ContractMemberManufacturerStats = {
  __typename?: 'ContractMemberManufacturerStats';
  /** Market Share in percentage */
  marketShare: Scalars['Float']['output'];
  normalizedManufacturer?: Maybe<Scalars['String']['output']>;
  totalSpend: Scalars['Float']['output'];
};

export type ContractMemberMonthlySpend = {
  __typename?: 'ContractMemberMonthlySpend';
  month: Scalars['String']['output'];
  totalSpend?: Maybe<Scalars['Float']['output']>;
};

export type ContractMemberTierAggregatedInfo = {
  __typename?: 'ContractMemberTierAggregatedInfo';
  tierComments: Array<Scalars['String']['output']>;
  tierStatuses: Array<Scalars['String']['output']>;
};

export type ContractMemberTierInfo = {
  __typename?: 'ContractMemberTierInfo';
  tierComment?: Maybe<Scalars['String']['output']>;
  tierId: Scalars['String']['output'];
  tierStatus?: Maybe<Scalars['String']['output']>;
};

export type ContractMemberTierInfoInput = {
  tierComment?: InputMaybe<Scalars['String']['input']>;
  tierId: Scalars['String']['input'];
  tierStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ContractMemberTierStats = {
  __typename?: 'ContractMemberTierStats';
  coveredTotalSpend: Scalars['Float']['output'];
  coveredUnits: Scalars['Float']['output'];
  rebateRulesPassed: Array<RebateRuleValidation>;
  targetPriceScore?: Maybe<Scalars['Int']['output']>;
  targetSpend: Scalars['Float']['output'];
  targetSpendAfterRebate: Scalars['Float']['output'];
  tierId: Scalars['String']['output'];
  tierName: Scalars['String']['output'];
  tierRulesPassed: TierRuleValidation;
};

export enum ContractMemberUploadRejectCategoryEnum {
  ApplyError = 'apply_error',
  ContractAmbiguous = 'contract_ambiguous',
  ContractNoWriteAccess = 'contract_no_write_access',
  ContractNotFound = 'contract_not_found',
  DateMissing = 'date_missing',
  DateOrder = 'date_order',
  DateOutsideContract = 'date_outside_contract',
  DateOutsideTier = 'date_outside_tier',
  DateUnreadable = 'date_unreadable',
  FacilityNotUnderTopParent = 'facility_not_under_top_parent',
  FacilityUnmapped = 'facility_unmapped',
  MemberChangedSincePreview = 'member_changed_since_preview',
  NotAMember = 'not_a_member',
  NothingToDeactivate = 'nothing_to_deactivate',
  PeriodOverlap = 'period_overlap',
  Superseded = 'superseded',
  TargetMissing = 'target_missing',
  TierMismatch = 'tier_mismatch',
  TierNotOnContract = 'tier_not_on_contract',
  TopParentNoFacilities = 'top_parent_no_facilities',
  TopParentUnmapped = 'top_parent_unmapped'
}

export enum ContractMemberUploadRowActionEnum {
  Activate = 'activate',
  Deactivate = 'deactivate'
}

export enum ContractMemberUploadRowStatusEnum {
  Applied = 'applied',
  Failed = 'failed',
  Ready = 'ready',
  Rejected = 'rejected'
}

export type ContractMembersApplyQueueEntry = {
  __typename?: 'ContractMembersApplyQueueEntry';
  /** Contracts those records are on */
  contracts: Scalars['Int']['output'];
  /** The caller's own upload */
  isMine: Scalars['Boolean']['output'];
  jobId: Scalars['ID']['output'];
  /** Member records the job writes */
  records: Scalars['Int']['output'];
  /** Records written (or failed) so far */
  recordsDone: Scalars['Int']['output'];
  /** `processing` while it writes, `queue` while it waits */
  status: UploadJobStatusEnum;
  uploaderName: Scalars['String']['output'];
};

export type ContractMembersApplySubmission = {
  __typename?: 'ContractMembersApplySubmission';
  /** The apply job */
  jobId: Scalars['ID']['output'];
  /** The customer's upload queue including this job: any entry before it runs first */
  queue: Array<ContractMembersApplyQueueEntry>;
};

export type ContractMembersMappedFields = {
  activationDate?: InputMaybe<Scalars['String']['input']>;
  contractCode: Scalars['String']['input'];
  deactivationDate?: InputMaybe<Scalars['String']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  tierCode: Scalars['String']['input'];
  topParent?: InputMaybe<Scalars['String']['input']>;
};

/** One distinct Facility Name or Top Parent value of an uploaded file */
export type ContractMembersUploadName = {
  __typename?: 'ContractMembersUploadName';
  /** Top parents only: rows with no Facility Name (every facility under it) */
  blankFacilityRows: Scalars['Int']['output'];
  /** The trimmed cell value, as the job reads it */
  name: Scalars['String']['output'];
  /** File rows with this value */
  rows: Scalars['Int']['output'];
  /** Facility names only: the Top Parent values on its rows */
  topParents: Array<Scalars['String']['output']>;
};

export type ContractMembersUploadNames = {
  __typename?: 'ContractMembersUploadNames';
  facilities: Array<ContractMembersUploadName>;
  topParents: Array<ContractMembersUploadName>;
};

export type ContractMembersUploadNamesInput = {
  /** Column mapped to Facility Name */
  facilityName?: InputMaybe<Scalars['String']['input']>;
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
  /** Column mapped to Top Parent */
  topParent?: InputMaybe<Scalars['String']['input']>;
};

export type ContractMembersUploadPreview = {
  __typename?: 'ContractMembersUploadPreview';
  hits: Array<ContractMembersUploadPreviewRow>;
  totalHits: Scalars['Int']['output'];
  totals: ContractMembersUploadPreviewTotals;
};

export enum ContractMembersUploadPreviewFilterEnum {
  Activate = 'activate',
  Applied = 'applied',
  Deactivate = 'deactivate',
  Failed = 'failed',
  /** Rejected at preview or failed at apply: the rows the user has to fix. */
  NotSaved = 'notSaved',
  Rejected = 'rejected'
}

export type ContractMembersUploadPreviewInput = {
  batchId: Scalars['ID']['input'];
  /** Omit for every row */
  filter?: InputMaybe<ContractMembersUploadPreviewFilterEnum>;
  pagination?: InputMaybe<Pagination>;
};

export type ContractMembersUploadPreviewRow = {
  __typename?: 'ContractMembersUploadPreviewRow';
  action?: Maybe<ContractMemberUploadRowActionEnum>;
  /** YYYY-MM-DD */
  activationDate?: Maybe<Scalars['String']['output']>;
  /** The resolved contract code, else the file value */
  contractCode?: Maybe<Scalars['String']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD */
  deactivationDate?: Maybe<Scalars['String']['output']>;
  /** The resolved facility name */
  facilityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The facility came from a Top Parent with a blank Facility Name */
  isExpanded: Scalars['Boolean']['output'];
  rawActivationDate?: Maybe<Scalars['String']['output']>;
  rawDeactivationDate?: Maybe<Scalars['String']['output']>;
  /** Facility Name as written in the file */
  rawFacilityName?: Maybe<Scalars['String']['output']>;
  /** Top Parent as written in the file */
  rawTopParent?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rejectCategory?: Maybe<ContractMemberUploadRejectCategoryEnum>;
  rowNumber: Scalars['Int']['output'];
  status: ContractMemberUploadRowStatusEnum;
  supersededByRow?: Maybe<Scalars['Int']['output']>;
  /** The resolved tier name, else the file value */
  tierName?: Maybe<Scalars['String']['output']>;
  /** The resolved top parent name */
  topParentName?: Maybe<Scalars['String']['output']>;
};

export type ContractMembersUploadSubmission = {
  __typename?: 'ContractMembersUploadSubmission';
  /** The batch the preview stages its rows in */
  batchId: Scalars['ID']['output'];
  /** The preview job */
  jobId: Scalars['ID']['output'];
};

export type ContractMembersUploadPreviewTotals = {
  __typename?: 'ContractMembersUploadPreviewTotals';
  activate: Scalars['Int']['output'];
  /** Rows the apply job wrote */
  applied: Scalars['Int']['output'];
  /** Applied activations */
  appliedActivate: Scalars['Int']['output'];
  /** Contracts with at least one applied row */
  appliedContracts: Scalars['Int']['output'];
  /** Applied deactivations */
  appliedDeactivate: Scalars['Int']['output'];
  /** Applied rows whose Top Parent or Facility was spelled differently in the file (a name the user matched) */
  appliedMatched: Scalars['Int']['output'];
  deactivate: Scalars['Int']['output'];
  /** Rows the apply job could not write */
  failed: Scalars['Int']['output'];
  /** Rejected plus failed: the rows the user has to fix */
  notSaved: Scalars['Int']['output'];
  /** Rejected and failed rows per reason, most common first */
  notSavedByReason: Array<ContractMembersUploadReasonCount>;
  rejected: Scalars['Int']['output'];
  /** Staged rows (a Top Parent row counts once per facility) */
  total: Scalars['Int']['output'];
};

export type ContractMembersUploadReasonCount = {
  __typename?: 'ContractMembersUploadReasonCount';
  category: ContractMemberUploadRejectCategoryEnum;
  count: Scalars['Int']['output'];
};

export type ContractOrganization = {
  __typename?: 'ContractOrganization';
  comment: Scalars['String']['output'];
  contract: Contract;
  contractsId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  facilityId: Scalars['Int']['output'];
  organization: Organization;
  organizationsId: Scalars['ID']['output'];
  tier: Tier;
  tiersId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  updator?: Maybe<User>;
};

export type ContractOrganizationHistory = {
  __typename?: 'ContractOrganizationHistory';
  comment: Scalars['String']['output'];
  contract: Contract;
  contractOrganization: ContractOrganization;
  contractOrganizationId: Scalars['ID']['output'];
  contractsId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  facilityId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationsId: Scalars['ID']['output'];
  priceActivationDate?: Maybe<Scalars['Date']['output']>;
  priceDeactivationDate?: Maybe<Scalars['Date']['output']>;
  tier: Tier;
  tiersId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  updator?: Maybe<User>;
};

export enum ContractOrganizationStatusEnum {
  Declined = 'declined',
  Pending = 'pending'
}

export enum ContractReportStatusEnum {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  Outdated = 'Outdated'
}

export enum ContractSearchFieldEnum {
  Category = 'category',
  Code = 'code',
  Description = 'description',
  Name = 'name',
  SourcingOfficer = 'sourcingOfficer',
  SubCategory = 'subCategory',
  Supplier = 'supplier'
}

export enum ContractStatusEnum {
  Active = 'active',
  Draft = 'draft',
  Expired = 'expired',
  Pending = 'pending'
}

export type ContractTier = {
  __typename?: 'ContractTier';
  contract: Contract;
  contractsId: Scalars['ID']['output'];
  extras?: Maybe<Scalars['JSON']['output']>;
  tier: Tier;
  tiersId: Scalars['ID']['output'];
};

export type ContractTierInput = {
  contractsId?: InputMaybe<Scalars['String']['input']>;
  tiersId?: InputMaybe<Scalars['String']['input']>;
};

export type ContractTierMapping = {
  /** Effective date field of the contract item */
  effectiveDate?: InputMaybe<FieldLiteralMapping>;
  /** Expiration date field of the contract item */
  expirationDate?: InputMaybe<FieldLiteralMapping>;
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type ContractTierRebate = {
  __typename?: 'ContractTierRebate';
  id: Scalars['ID']['output'];
  tier: Tier;
  tierRebate: TierRebate;
  tierRebateId: Scalars['ID']['output'];
  tiersId: Scalars['ID']['output'];
};

export type ContractUniqueNormalizedSuppliersOutput = {
  __typename?: 'ContractUniqueNormalizedSuppliersOutput';
  basketId?: Maybe<Scalars['String']['output']>;
  normalizedManufacturer: Scalars['String']['output'];
};

export type ContractXrefMappedFieldsType = {
  competitorDescription?: InputMaybe<FieldLiteralMapping>;
  competitorManufacturer?: InputMaybe<FieldLiteralMapping>;
  competitorMfgitem?: InputMaybe<FieldLiteralMapping>;
  competitorVendor?: InputMaybe<FieldLiteralMapping>;
  competitorVenitem?: InputMaybe<FieldLiteralMapping>;
  offerDescription?: InputMaybe<FieldLiteralMapping>;
  offerManufacturer?: InputMaybe<FieldLiteralMapping>;
  offerMfgitem?: InputMaybe<FieldLiteralMapping>;
  offerVendor?: InputMaybe<FieldLiteralMapping>;
  offerVenitem?: InputMaybe<FieldLiteralMapping>;
};

export type ContractXrefUploadUrlInput = {
  /** The wizard's contract; none for the cross references page's uploads (#8002, #8041). */
  contractId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  /** Bytes. */
  fileSize: Scalars['Int']['input'];
  /** Rows in the largest sheet, header excluded, as the browser counted them. */
  rowCount: Scalars['Int']['input'];
};

export type ContractsResult = {
  __typename?: 'ContractsResult';
  hits: Array<Contract>;
  totalHits: Scalars['Int']['output'];
};

export type CopyCurvoBasketInput = {
  categoryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CopyCurvoBasketResponse = {
  __typename?: 'CopyCurvoBasketResponse';
  basket: Basket;
  jobId: Scalars['String']['output'];
};

export type CreateBasketDashboardInput = {
  baskets: Array<Scalars['String']['input']>;
  dashboardId: Scalars['String']['input'];
};

export type CreateCatalogPartInput = {
  commodityId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gicId?: InputMaybe<Scalars['Float']['input']>;
  gicName?: InputMaybe<Scalars['String']['input']>;
  gmdn?: InputMaybe<Array<Scalars['String']['input']>>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  gudId?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerItem?: InputMaybe<Scalars['String']['input']>;
  partTiers?: InputMaybe<Array<PriceTierInput>>;
  stanId?: InputMaybe<Scalars['String']['input']>;
  typeOneId?: InputMaybe<Scalars['String']['input']>;
  typeOneName?: InputMaybe<Scalars['String']['input']>;
  typeTwoId?: InputMaybe<Scalars['String']['input']>;
  typeTwoName?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendorItem?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractDashboardInput = {
  contracts: Array<Scalars['String']['input']>;
  dashboardId: Scalars['String']['input'];
};

export type CreateContractInput = {
  activeDue: Scalars['Date']['input'];
  activeSince: Scalars['Date']['input'];
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  sourcingOfficer?: InputMaybe<Scalars['String']['input']>;
  subCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  supplier: Scalars['String']['input'];
};

export type CreateContractTierInput = {
  contractsId: Scalars['String']['input'];
  /** Pull rows the new tier period would leave outside back into it */
  forceOutOfWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Move part price ranges and activations that were sitting on the tier's old dates with it */
  forceSticky?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tier?: InputMaybe<TierInput>;
  tierRules?: InputMaybe<TierRuleInput>;
  /** If this tiersId is not null, then this will update existing tiers */
  tiersId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCrossReferenceListInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  broadJumpId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxUser: Scalars['Int']['input'];
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDashboardInput = {
  angleTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  arnValue?: InputMaybe<Scalars['String']['input']>;
  /** Valid CSS color value */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  basketList?: InputMaybe<Array<Scalars['String']['input']>>;
  contractList?: InputMaybe<Array<Scalars['String']['input']>>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of Ant Design Icons e.g DashboardOutlined */
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateInitiativeInput = {
  attachments?: InputMaybe<Array<InitiativeAttachmentInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  hospitalArea: Scalars['String']['input'];
  isPublic: Scalars['Boolean']['input'];
  medtech?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Date']['input']>;
  status: InitiativeStatusEnum;
  title: Scalars['String']['input'];
  valueElement?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMessageTemplateInput = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CreateNetworkWithUsersInput = {
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  users?: InputMaybe<Array<InvitedUserInput>>;
};

export type CreateOfferInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOfferScenarioInput = {
  name: Scalars['String']['input'];
  offerIds: Array<Scalars['String']['input']>;
  opportunityId: Scalars['String']['input'];
  priorities: Array<OfferScenarioPriorityInput>;
  tierIds: Array<Scalars['String']['input']>;
};

export type CreateOpportunityInput = {
  basketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimateDueDate?: InputMaybe<Scalars['Date']['input']>;
  estimateStartDate?: InputMaybe<Scalars['Date']['input']>;
  goal?: InputMaybe<Scalars['Float']['input']>;
  goalThresholdMax?: InputMaybe<Scalars['Float']['input']>;
  /** Key Contact User ID */
  keyContactId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sharedUsers?: InputMaybe<Array<BaseAclRecordInput>>;
  skipZeroQuantityItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrganizationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  bypassEditableCheck?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  classOfTradeId?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  customerIds: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  gpoFacilityId?: InputMaybe<Scalars['String']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationTypeId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateQuicksightGroupInput = {
  groupName: Scalars['String']['input'];
};

export type CreateQuicksightGroupType = {
  __typename?: 'CreateQuicksightGroupType';
  Group?: Maybe<QuicksightGroupType>;
};

export type CreateSavedMappingInput = {
  mappedFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  type: MappingTypesEnum;
};

export type CreateSavedSearchInput = {
  advancedSearchQuery?: InputMaybe<Array<AdvancedSearchGroup>>;
  grouping?: InputMaybe<Array<GroupField>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAggs?: InputMaybe<IncludeAggsEnum>;
  isRecent?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  resultCount?: InputMaybe<Scalars['Int']['input']>;
  searchFields: Array<ColumnAttributesInput>;
  searchText: Scalars['String']['input'];
  spendDateRangeInput?: InputMaybe<SpendDateRangeSearchInput>;
};

export type CreateSmartBasketInput = {
  isSearchAll: Scalars['Boolean']['input'];
  isSmartBasket?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<BasketProductInput>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  rules: Array<SmartBasketRuleInput>;
  search?: InputMaybe<CreateSavedSearchInput>;
  uploadedSearch?: InputMaybe<SearchByUploadedSearchIdInput>;
};

export type CreateTierInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTierRebateInput = {
  advancedRulesJsonLogic?: InputMaybe<Scalars['String']['input']>;
  /** JSON object of advanced rules, interchangeable with advancedRulesJsonLogic */
  advancedRulesJsonLogicObject?: InputMaybe<Scalars['JSON']['input']>;
  conditionalStartDate?: ConditionalStartDate;
  contractId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  growth: Array<RebateGrowthInput>;
  metricType?: TierRebateMetricType;
  name: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  payoutLevel?: TierRuleScope;
  periodType: TierRulePeriodType;
  productTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If this rebateId is not null, then this will update existing tier rebate */
  rebateId?: InputMaybe<Scalars['String']['input']>;
  scope: TierRuleScope;
  tierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tierRules?: InputMaybe<TierRuleInput>;
  /** Rebate type (e.g. rebate, admin fee, etc.) */
  type: Scalars['String']['input'];
  vendors?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateUserInput = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateVendorInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorFeatures?: InputMaybe<VendorFeaturesInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVendorUserInput = {
  appianId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isCurvoAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export enum CrossListOperationEnum {
  ApplyOnNonCrossed = 'applyOnNonCrossed',
  ResetAndApply = 'resetAndApply'
}

export type CrossReferenceCluster = {
  __typename?: 'CrossReferenceCluster';
  clusterCatalogParts: Array<ClusterCatalogPart>;
  clusterParts: Array<ClusterPart>;
  createdAt: Scalars['Date']['output'];
  crossReferenceList?: Maybe<CrossReferenceList>;
  crossReferenceListId?: Maybe<Scalars['ID']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CrossReferenceClustersResult = {
  __typename?: 'CrossReferenceClustersResult';
  hits: Array<CrossReferenceCluster>;
  totalHits: Scalars['Int']['output'];
};

export type CrossReferenceList = {
  __typename?: 'CrossReferenceList';
  contract?: Maybe<Contract>;
  createdAt: Scalars['Date']['output'];
  crossReferenceClusters: Array<CrossReferenceCluster>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offerCrossStats: OfferCrossStats;
  plainCrossReferences: PlainCrossReferenceList;
  supplierCrossReference?: Maybe<SupplierCrossReference>;
  supplierCrossReferences: SupplierCrossReferenceResult;
  /** Typeahead terms query for `supplierCrossReferences` */
  supplierCrossReferencesTypeAhead: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
};


export type CrossReferenceListOfferCrossStatsArgs = {
  offerId: Scalars['String']['input'];
};


export type CrossReferenceListPlainCrossReferencesArgs = {
  crossStatus?: InputMaybe<Scalars['Boolean']['input']>;
  itemCrossStatuses?: InputMaybe<Array<OfferItemCrossStatus>>;
  matchType?: InputMaybe<CrossReferenceType>;
  pagination?: InputMaybe<Pagination>;
  searchOnFields?: InputMaybe<Array<SupplierCrossReferenceSearchOnField>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SupplierCrossReferencesSortInput>>;
  tsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  xrefTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CrossReferenceListSupplierCrossReferenceArgs = {
  xrefTsId: Scalars['String']['input'];
};


export type CrossReferenceListSupplierCrossReferencesArgs = {
  crossStatus?: InputMaybe<Scalars['Boolean']['input']>;
  itemCrossStatuses?: InputMaybe<Array<OfferItemCrossStatus>>;
  mappingsLimit?: InputMaybe<Scalars['Float']['input']>;
  matchType?: InputMaybe<CrossReferenceType>;
  pagination?: InputMaybe<Pagination>;
  searchOnFields?: InputMaybe<Array<SupplierCrossReferenceSearchOnField>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SupplierCrossReferencesSortInput>>;
  tsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  xrefTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type CrossReferenceListSupplierCrossReferencesTypeAheadArgs = {
  crossStatus?: InputMaybe<Scalars['Boolean']['input']>;
  itemCrossStatuses?: InputMaybe<Array<OfferItemCrossStatus>>;
  searchOnFields: Array<SupplierCrossReferenceSearchOnField>;
  termsOnField: SupplierCrossReferenceSearchField;
  xrefTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrossReferenceListResult = {
  __typename?: 'CrossReferenceListResult';
  hits: Array<CrossReferenceList>;
  totalHits: Scalars['Int']['output'];
};

export type CrossReferenceMap = {
  __typename?: 'CrossReferenceMap';
  catalogPart?: Maybe<CatalogPart>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crossReferenceList?: Maybe<CrossReferenceList>;
  crossReferenceListId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  noCross?: Maybe<OfferItemComment>;
  tsId: Scalars['String']['output'];
  type?: Maybe<CrossReferenceType>;
  updatedAt: Scalars['Date']['output'];
  xrefCatalogPart?: Maybe<CatalogPart>;
  xrefTsId?: Maybe<Scalars['String']['output']>;
};

export type CrossReferenceMapStats = {
  __typename?: 'CrossReferenceMapStats';
  lastUpdatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CrossReferenceOfferItemInput = {
  crossReferenceListIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  operationType?: InputMaybe<CrossListOperationEnum>;
};

/**
 * One side of a cross typed into a list (spec §5.7 `PartRefInput`): an item the organization knows, by
 * `tsId`, or typed in, by manufacturer and item #. A typed item is found or created the way the upload
 * does it.
 */
export type CrossReferencePairItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer's item #. */
  manufacturerItem?: InputMaybe<Scalars['String']['input']>;
  /** An item already in a list the organization reads. */
  tsId?: InputMaybe<Scalars['String']['input']>;
};

/** Where an upload's crosses go (#8002, spec §5.5). */
export enum CrossRefUploadMode {
  /** New rows are added and matching rows updated. Nothing is removed. */
  Add = 'add',
  /** The file becomes a list of its own. No existing list is changed. */
  New = 'new',
  /** The list becomes exactly what's in the file. Crosses not in the file are removed. */
  Overwrite = 'overwrite'
}

export type CrossRefUploadTarget = {
  /** The list to add to or overwrite. Needs write access to it. */
  listId?: InputMaybe<Scalars['ID']['input']>;
  mode: CrossRefUploadMode;
  /** The new list's name: unique among the lists you can read. */
  newListName?: InputMaybe<Scalars['String']['input']>;
};

export enum CrossReferenceType {
  Alternative = 'alternative',
  Exact = 'exact',
  Other = 'other',
  Similar = 'similar'
}

export type CrossStats = {
  __typename?: 'CrossStats';
  totalCrossed: Scalars['Float']['output'];
  totalItems: Scalars['Float']['output'];
  totalLeftUncrossed: Scalars['Float']['output'];
  totalUncrossed: Scalars['Float']['output'];
};

export enum CrossedStatus {
  Crossed = 'crossed',
  LeftUncrossed = 'leftUncrossed',
  Uncrossed = 'uncrossed'
}

export enum CurvoErrorCode {
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  PermissionError = 'PERMISSION_ERROR',
  ValidationError = 'VALIDATION_ERROR'
}

export type CustomField = {
  __typename?: 'CustomField';
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  editableBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  order: Scalars['Float']['output'];
  required: Scalars['Boolean']['output'];
  target: CustomFieldTargetEnum;
  type: CustomFieldTypeEnum;
  updatedAt: Scalars['Date']['output'];
  updatedBy: Scalars['String']['output'];
  visibility?: Maybe<Scalars['String']['output']>;
};

export enum CustomFieldEditableBy {
  All = 'all',
  Hcp = 'hcp',
  Supplier = 'supplier'
}

export type CustomFieldFilterInput = {
  targets?: InputMaybe<Array<CustomFieldTargetEnum>>;
  visibilities?: InputMaybe<Array<CustomFieldVisibility>>;
};

export type CustomFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  editableBy?: InputMaybe<CustomFieldEditableBy>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['JSON']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  target: CustomFieldTargetEnum;
  type: CustomFieldTypeEnum;
  visibility?: InputMaybe<CustomFieldVisibility>;
};

export enum CustomFieldTargetEnum {
  Contract = 'contract',
  Rfx = 'rfx',
  Tier = 'tier'
}

export enum CustomFieldTypeEnum {
  DatePicker = 'datePicker',
  Select = 'select',
  Text = 'text',
  Textarea = 'textarea'
}

export type CustomFieldUpdateOrderInput = {
  id: Scalars['String']['input'];
  order: Scalars['Float']['input'];
};

export enum CustomFieldVisibility {
  All = 'all',
  Hcp = 'hcp',
  Supplier = 'supplier'
}

export type Customer = {
  __typename?: 'Customer';
  address: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  broadJumpId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  geoCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  mainContact?: Maybe<User>;
  maxUser: Scalars['Int']['output'];
  medicareId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  normalizedName?: Maybe<Scalars['String']['output']>;
  organizations: Array<Organization>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  stripeId: Scalars['String']['output'];
  topUsers: Array<User>;
  totalContracts?: Maybe<Scalars['Int']['output']>;
  totalOrganizations?: Maybe<Scalars['Int']['output']>;
  totalPowerUsers?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  type: CustomerTypeEnum;
  updatedAt: Scalars['Date']['output'];
  user: User;
  users: Array<User>;
  vendorFeatures?: Maybe<VendorFeatures>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type CustomerTopUsersArgs = {
  isPowerUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerActivationInput = {
  id: Scalars['String']['input'];
};

export type CustomerMainContactInput = {
  customerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum CustomerTypeEnum {
  ServiceProvider = 'serviceProvider',
  Supplier = 'supplier'
}

export type CustomerView = {
  __typename?: 'CustomerView';
  address: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  geoCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  mainContact?: Maybe<User>;
  medicareId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  normalizedName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: CustomerTypeEnum;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  angleTypes?: Maybe<Array<Scalars['String']['output']>>;
  arnValue?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  basketDashboards: Array<BasketDashboard>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  supplierSection?: Maybe<Array<SupplierSectionEnum>>;
  updatedAt: Scalars['Date']['output'];
};

export type DashboardFilter = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardSort = {
  dir: Scalars['String']['input'];
  field: DashboardSortEnum;
};

export enum DashboardSortEnum {
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt'
}

export type DashboardsResult = {
  __typename?: 'DashboardsResult';
  hits: Array<Dashboard>;
  totalHits: Scalars['Int']['output'];
};

export type DeleteCrossReferenceMapsInput = {
  /** If this parameter is null, the System will try to use the System Generated List */
  crossReferenceListId?: InputMaybe<Scalars['String']['input']>;
  partTsIds: Array<Scalars['String']['input']>;
};

export type DeleteSavedMappingInput = {
  id: Scalars['String']['input'];
};

export type DescriptiveAction = {
  __typename?: 'DescriptiveAction';
  action: Scalars['String']['output'];
  changes?: Maybe<Array<Change>>;
  object: Scalars['String']['output'];
};

export type DetailedSearchInput = {
  facilityId: Scalars['Int']['input'];
  tsId: Scalars['String']['input'];
};

export type DoUploadSearchInput = {
  mappedFields: MappedFieldsType;
  mappedManufacturers: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  searchFields: Array<ColumnAttributesInput>;
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type DoUploadSearchResult = {
  __typename?: 'DoUploadSearchResult';
  uploadedSearchId: Scalars['String']['output'];
};

export type DownloadVendorOfferInput = {
  customerId: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
};

export type EvidenceDocInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  s3Url: Scalars['String']['input'];
};

export type ExportAggregatedSearchInput = {
  advancedSearchQuery?: InputMaybe<Array<AdvancedSearchGroup>>;
  exportPo: Scalars['Boolean']['input'];
  grouping?: InputMaybe<Array<GroupField>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAggs?: InputMaybe<IncludeAggsEnum>;
  isRecent?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  resultCount?: InputMaybe<Scalars['Int']['input']>;
  searchFields: Array<ColumnAttributesInput>;
  searchText: Scalars['String']['input'];
  uploadedSearchId?: InputMaybe<Scalars['String']['input']>;
};

export enum ExportCatalogPartsFieldEnum {
  Category = 'category',
  Description = 'description',
  Gtin = 'gtin',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  Price = 'price',
  SubCategory = 'subCategory',
  TierName = 'tierName',
  Uom = 'uom',
  UomConversion = 'uomConversion',
  Vendor = 'vendor',
  VendorItem = 'vendorItem'
}

export type ExportCatalogPartsInput = {
  exportedFields?: InputMaybe<Array<ExportCatalogPartsFieldEnum>>;
  tierId?: InputMaybe<Scalars['String']['input']>;
};

export type ExportCatalogPartsPayload = {
  __typename?: 'ExportCatalogPartsPayload';
  downloadUrl: Scalars['String']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
};

export enum ExportCrossRefercenceColumn {
  CrossedPartDescription = 'crossedPartDescription',
  CrossedPartManufacturer = 'crossedPartManufacturer',
  CrossedPartManufacturerItem = 'crossedPartManufacturerItem',
  CrossedPartVendor = 'crossedPartVendor',
  CrossedPartVendorItem = 'crossedPartVendorItem',
  NoCrossComment = 'noCrossComment',
  PartDescription = 'partDescription',
  PartManufacturer = 'partManufacturer',
  PartManufacturerItem = 'partManufacturerItem',
  PartVendor = 'partVendor',
  PartVendorItem = 'partVendorItem'
}

export type ExportCrossReferencesOption = {
  columns?: InputMaybe<Array<ExportCrossRefercenceColumn>>;
  crossStatus?: InputMaybe<CrossReferenceCrossStatus>;
  crossStatuses?: InputMaybe<Array<OfferItemCrossStatus>>;
  matchType?: InputMaybe<CrossReferenceType>;
  pagination?: InputMaybe<Pagination>;
  searchOnFields?: InputMaybe<Array<SupplierCrossReferenceSearchOnField>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<SupplierCrossReferencesSortInput>>;
  tsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  xrefTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExportEventResultType = {
  __typename?: 'ExportEventResultType';
  downloadUrl: Scalars['String']['output'];
};

export type ExportHistories = {
  __typename?: 'ExportHistories';
  data: Array<UploadJob>;
};

export type ExportItemPoTransactionsInput = {
  facilityId: Scalars['Int']['input'];
  tsId: Scalars['String']['input'];
};

export type ExtendedOfferItem = {
  __typename?: 'ExtendedOfferItem';
  averagePrice?: Maybe<Scalars['Float']['output']>;
  basket?: Maybe<Basket>;
  comment?: Maybe<OfferItemComment>;
  createdAt: Scalars['Date']['output'];
  crossReferenceSuggestions?: Maybe<Array<CatalogPart>>;
  crossStatus?: Maybe<Scalars['Boolean']['output']>;
  curvo25?: Maybe<Scalars['Float']['output']>;
  curvo50?: Maybe<Scalars['Float']['output']>;
  curvo75?: Maybe<Scalars['Float']['output']>;
  curvo90?: Maybe<Scalars['Float']['output']>;
  customer?: Maybe<Customer>;
  customerId: Scalars['String']['output'];
  esId: Scalars['String']['output'];
  facilityId?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  /** A group ID for items with the same product */
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item?: Maybe<CatalogPart>;
  itemConversion?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use itemCrossStatus instead */
  itemCrossStatus?: Maybe<OfferItemCrossStatus>;
  itemEnrichment?: Maybe<OfferItemEnrichment>;
  itemTsId: Scalars['String']['output'];
  itemUoM?: Maybe<Scalars['String']['output']>;
  markupAdjustedPrice?: Maybe<Scalars['Float']['output']>;
  masterCatalogData?: Maybe<MasterCatalogData>;
  matchedCrossRefVendorItems?: Maybe<Scalars['Int']['output']>;
  noCross?: Maybe<Scalars['Boolean']['output']>;
  noCrossComment?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  offerId: Scalars['String']['output'];
  offerItem?: Maybe<CatalogPart>;
  offerTsId?: Maybe<Scalars['String']['output']>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  priceTiers?: Maybe<Array<CatalogPartTier>>;
  pricingTarget?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  secondOfferItem?: Maybe<CatalogPart>;
  secondOfferTsId?: Maybe<Scalars['String']['output']>;
  selectedPriceTierIds?: Maybe<Array<Scalars['String']['output']>>;
  submittedItem?: Maybe<CatalogPart>;
  submittedTsId: Scalars['String']['output'];
  suggestion?: Maybe<OfferItemSuggestion>;
  unitprice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ExtendedQueuedLinkProcess = {
  __typename?: 'ExtendedQueuedLinkProcess';
  aiGudidOverwrite?: Maybe<Scalars['Boolean']['output']>;
  aiMedOverwrite?: Maybe<Scalars['Boolean']['output']>;
  aiStanOverwrite?: Maybe<Scalars['Boolean']['output']>;
  asp?: Maybe<Scalars['Float']['output']>;
  bamfGudidId?: Maybe<Scalars['String']['output']>;
  bamfMedId?: Maybe<Scalars['String']['output']>;
  bamfStanId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionOrg?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gudidCatalogNumber?: Maybe<Scalars['String']['output']>;
  gudidCompanyName?: Maybe<Scalars['String']['output']>;
  gudidDescription?: Maybe<Scalars['String']['output']>;
  gudidManufacturer?: Maybe<Scalars['String']['output']>;
  gudidMatch: Scalars['String']['output'];
  /** curvo normalized names of gudid matched suppliers */
  gudidMatchedNormSuppliers?: Maybe<Array<Scalars['String']['output']>>;
  gudidState: Scalars['String']['output'];
  gudidVersionModelNumber?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  ignoreManufacturer?: Maybe<Scalars['Boolean']['output']>;
  ignoreRow?: Maybe<Scalars['Boolean']['output']>;
  ignoreVendor?: Maybe<Scalars['Boolean']['output']>;
  isGudidApproved?: Maybe<Scalars['Boolean']['output']>;
  isGudidSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  isMedApproved?: Maybe<Scalars['Boolean']['output']>;
  isMedSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  isReprocessed?: Maybe<Scalars['Boolean']['output']>;
  isStanApproved?: Maybe<Scalars['Boolean']['output']>;
  isStanSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerGudidType?: Maybe<Scalars['String']['output']>;
  manufacturerMedType?: Maybe<Scalars['String']['output']>;
  manufacturerOrg?: Maybe<Scalars['String']['output']>;
  manufacturerStanType?: Maybe<Scalars['String']['output']>;
  matchGudidId?: Maybe<Scalars['String']['output']>;
  matchMedId?: Maybe<Scalars['String']['output']>;
  matchStanId?: Maybe<Scalars['String']['output']>;
  medDescription?: Maybe<Scalars['String']['output']>;
  medManufacturer?: Maybe<Scalars['String']['output']>;
  medMatch: Scalars['String']['output'];
  /** curvo normalized names of medline/commodity matched suppliers */
  medMatchedNormSuppliers?: Maybe<Array<Scalars['String']['output']>>;
  medMaterialCode?: Maybe<Scalars['String']['output']>;
  medSku?: Maybe<Scalars['String']['output']>;
  medState: Scalars['String']['output'];
  mfgitem?: Maybe<Scalars['String']['output']>;
  mfgitemOrg?: Maybe<Scalars['String']['output']>;
  priceTiers?: Maybe<Array<TransactionTier>>;
  qtypurchase?: Maybe<Scalars['Int']['output']>;
  stanManufacturer?: Maybe<Scalars['String']['output']>;
  stanManufacturerId?: Maybe<Scalars['String']['output']>;
  stanManufacturerOb?: Maybe<Manufacturer>;
  stanMatch: Scalars['String']['output'];
  stanPartDescription?: Maybe<Scalars['String']['output']>;
  stanPartNumber?: Maybe<Scalars['String']['output']>;
  stanState: Scalars['String']['output'];
  study: QueuedStudy;
  /** curvo normalized names of normalized vendor and normalized manufacturer */
  supplierNormCurvos?: Maybe<Array<Scalars['String']['output']>>;
  /** manufacturer IDs of normalized vendor and normalized manufacturer */
  supplierNormManufacturerIds?: Maybe<Array<Scalars['String']['output']>>;
  /** whether this supplier produces reprocessed items */
  supplierProducesReprocessed?: Maybe<Scalars['Boolean']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  tsId: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  uomconversion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorOrg?: Maybe<Scalars['String']['output']>;
  venitem?: Maybe<Scalars['String']['output']>;
  venitemOrg?: Maybe<Scalars['String']['output']>;
};

export type ExternalAuthConnection = {
  __typename?: 'ExternalAuthConnection';
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FacilityFilterTerms = {
  __typename?: 'FacilityFilterTerms';
  facilityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FacilityInfo = {
  __typename?: 'FacilityInfo';
  batchId?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<FacilityInfoItem>>;
};

export type FacilityInfoItem = {
  __typename?: 'FacilityInfoItem';
  facilityId: Scalars['Float']['output'];
  spendDateFrom?: Maybe<Scalars['Date']['output']>;
  spendDateTo?: Maybe<Scalars['Date']['output']>;
};

export type FeaturedBasket = {
  __typename?: 'FeaturedBasket';
  basket: Basket;
  featuredTag?: Maybe<Scalars['String']['output']>;
  featuredValue?: Maybe<Scalars['Float']['output']>;
};

export type FetchMappingFieldsInput = {
  s3Key: Scalars['String']['input'];
};

export type FetchMappingFieldsResult = {
  __typename?: 'FetchMappingFieldsResult';
  data: Array<MapField>;
};

export type FieldLiteralMapping = {
  type: MappingTypeEnum;
  value: Scalars['String']['input'];
};

export type FilterColumnInput = {
  columnName: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type FilterColumnResult = {
  __typename?: 'FilterColumnResult';
  data: Array<Scalars['String']['output']>;
};

export type GmdnTerm = {
  __typename?: 'GMDNTerm';
  gmdnptdefinition?: Maybe<Scalars['String']['output']>;
  gmdnptname: Scalars['String']['output'];
};

export type GenerateAllContractMembersInput = {
  customerId: Scalars['String']['input'];
};

export type GenerateBasketSmartRulesInput = {
  basketId: Scalars['String']['input'];
  ruleFields?: InputMaybe<Array<SmartRuleField>>;
  smartBasketConfig?: InputMaybe<SmartBasketConfigInput>;
};

export type GenerateRebateEvidenceUploadUrlInput = {
  contractId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  rebateId: Scalars['String']['input'];
};

export type GetBasketAclByCriteriaInput = {
  basketId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<AcLevelEnum>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AcTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetBasketContextInput = {
  aggregateType: BasketContextAggregateType;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetBasketProductsByCriteriaInput = {
  basketId?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type GetBasketsByCriteriaInput = {
  creatorId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isCatalogBasket?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  skipVisibilityCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<BasketSort>;
  targetPercentile?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<BasketType>;
};

export type GetCatalogPartsByCriteriaInput = {
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to catalog parts that are items in this offer */
  offerId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  tsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetContractAclByCriteriaInput = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<AcLevelEnum>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AcTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetContractMemberInput = {
  contractId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type GetContractMembersInput = {
  contractId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  withoutStats?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetContractOrganizationsByCriteriaInput = {
  contractsId?: InputMaybe<Scalars['String']['input']>;
  organizationsId?: InputMaybe<Scalars['String']['input']>;
  tiersId?: InputMaybe<Scalars['String']['input']>;
};

export type GetContractPartsInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
};

export type GetContractsByCriteriaInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  searchIns?: InputMaybe<Array<ContractSearchFieldEnum>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  status?: InputMaybe<ContractFilterStatus>;
  subCategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetCrossReferenceListAclByCriteriaInput = {
  crossReferenceListId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<AcLevelEnum>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AcTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCrossReferenceListsByCriteriaInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomersByCriteriaInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomerTypeEnum>;
  vendorFeatures?: InputMaybe<VendorFeaturesInput>;
};

export type GetDashboardEmbedUrlInput = {
  dashboardId: Scalars['String']['input'];
};

export type GetDashboardInput = {
  dashboardId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDashboardsByCriteriaInput = {
  filter?: InputMaybe<DashboardFilter>;
  sort?: InputMaybe<Array<DashboardSort>>;
};

export type GetInitiativesByCriteriaInput = {
  filter?: InputMaybe<InitiativeFilter>;
  sort?: InputMaybe<Array<InitiativeSort>>;
};

export type GetOrganizationTypeByCriteriaInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrganizationsByCriteriaInput = {
  /** Bulk search Organization by name */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Skip uneditable organizations */
  skipUneditable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetPartAclByCriteriaInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<AcLevelEnum>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  partTsId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AcTypeEnum>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPartsTiersByCriteriaInput = {
  cotId?: InputMaybe<Scalars['Int']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  partsTsId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  tiersId?: InputMaybe<Scalars['String']['input']>;
  uom?: InputMaybe<Scalars['String']['input']>;
  uomConversion?: InputMaybe<Scalars['Int']['input']>;
};

export type GetProjectsByCriteriaInput = {
  creatorId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type GetRelatedSearchInput = {
  searchText?: InputMaybe<Scalars['String']['input']>;
  tsId: Scalars['String']['input'];
};

export type GetSavedMappingInput = {
  type: MappingTypesEnum;
};

export type GetSourcingPlansByCriteriaInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<SourcingPlanOwnerEnum>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetSuggestedVendorsInput = {
  normalizedVendors?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetSupplierDashboardsInput = {
  supplierSection?: InputMaybe<SupplierSectionEnum>;
};

export type GetSystemByCriteriaInput = {
  creatorId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type GetTiersByCriteriaInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  showClonedTiers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserActivitiesByCriteriaInput = {
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetUsersByCriteriaInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isCurvoAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUsername?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type GetVendorsByCriteriaInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  vendorFeatures?: InputMaybe<VendorFeaturesInput>;
};

export type Gic = {
  __typename?: 'Gic';
  allowedTypeOnes: Array<GicTypeOne>;
  createdAt: Scalars['Date']['output'];
  excludes?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sizeOneDescription?: Maybe<Scalars['String']['output']>;
  sizeThreeDescription?: Maybe<Scalars['String']['output']>;
  sizeTwoDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type GicTypeOne = {
  __typename?: 'GicTypeOne';
  createdAt: Scalars['Date']['output'];
  excludes?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  includes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GicTypeTwo = {
  __typename?: 'GicTypeTwo';
  createdAt: Scalars['Date']['output'];
  excludes?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  includes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum GroupField {
  EsProductNormalized = 'esProductNormalized',
  EsSupplierNormalized = 'esSupplierNormalized',
  EsVendorItemNormalized = 'esVendorItemNormalized',
  EsVendorNormalized = 'esVendorNormalized',
  FacilityName = 'facilityName',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  Vendor = 'vendor',
  VendorItem = 'vendorItem'
}

export type HasSimilarProductsInput = {
  /** Extended use graph clustered 510k data to cross with not only direct 510k items but all 510k items connected in the cluster */
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  gudids: Array<Scalars['String']['input']>;
};

export type HideSourcingPlanInput = {
  basketId: Scalars['String']['input'];
  hide: Scalars['Boolean']['input'];
  sourcingPlanId?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageFeaturedContent = {
  __typename?: 'HomepageFeaturedContent';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type HomepageFeaturedContentQueryInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageFeaturedContentUpdate = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID to update the existing feature, null ID will create new feature */
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A contract a list is loaded to (#8014). */
export type HospitalCrossReferenceContractRef = {
  __typename?: 'HospitalCrossReferenceContractRef';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** What deleting a list does (#8015, Q14): the delete confirmation is built from it. */
export type HospitalCrossReferenceListDeleteImpact = {
  __typename?: 'HospitalCrossReferenceListDeleteImpact';
  /** The organization's own contracts on All lists, which stop using its crosses. */
  allListsContractCount: Scalars['Int']['output'];
  /** Crosses deleted with the list: pairs plus legacy cluster crosses. */
  crossCount: Scalars['Int']['output'];
  list: HospitalCrossReferenceListRef;
  /** The organization's contracts on Specific lists that picked the list; it is removed from them. */
  removedFrom: Array<HospitalCrossReferenceContractRef>;
  /** Of `removedFrom`, the contracts with no other list, which go back to All lists. */
  revertToAll: Array<HospitalCrossReferenceContractRef>;
};

export type HospitalCrossReferenceListRef = {
  __typename?: 'HospitalCrossReferenceListRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HospitalCrossReferenceUploadInput = {
  /** Launched from this contract: once loaded, the contract uses the list. Needs contract write. */
  contractId?: InputMaybe<Scalars['ID']['input']>;
  /** Preview: check the file and count what loading it would do, writing nothing. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** `offer*` are the contract item, `competitor*` the cross item. */
  mappedFields: ContractXrefMappedFieldsType;
  /** The file, as `uploadContractXrefFile` stored it. */
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
  target: CrossRefUploadTarget;
};

/**
 * What an upload does (#8002), or would do for a dry run. It rides on the job's `result_stats`, so the
 * GraphQL type documents the shape for clients.
 */
export type HospitalCrossReferenceUploadStats = {
  __typename?: 'HospitalCrossReferenceUploadStats';
  /** Other contracts that picked the list, whose matching changes. */
  contractsAffected: Array<HospitalCrossReferenceContractRef>;
  dryRun: Scalars['Boolean']['output'];
  /** Rows repeating a cross earlier in the file. */
  duplicates: Scalars['Int']['output'];
  /** Rows with an error, which don't load. */
  errors: Scalars['Int']['output'];
  /** Crosses already in the list, kept and marked changed. */
  existingPairs: Scalars['Int']['output'];
  /** Overwrite: crosses in the old format, removed. */
  legacyToDelete: Scalars['Int']['output'];
  /** The list loaded to; for a dry run of a new list, none yet. */
  listId?: Maybe<Scalars['ID']['output']>;
  newPairs: Scalars['Int']['output'];
  /** Contract items marked No cross that get a cross, which reverses it (D11). */
  noCrossToReverse: Scalars['Int']['output'];
  /** Overwrite: crosses in the list but not in the file, removed. */
  toDelete: Scalars['Int']['output'];
  /** Rows in the file. */
  total: Scalars['Int']['output'];
  /** Rows that load. */
  valid: Scalars['Int']['output'];
};

/** The file's columns for a No cross upload (#8041): the template's, mapped as on any upload. */
export type ContractItemNoCrossMappedFields = {
  /** Passed to linkage with the manufacturer and item #, and shown in the errors. */
  description?: InputMaybe<FieldLiteralMapping>;
  manufacturer?: InputMaybe<FieldLiteralMapping>;
  /** The manufacturer item #. */
  mfgitem?: InputMaybe<FieldLiteralMapping>;
  /** The row's note: the note for every row when blank. */
  note?: InputMaybe<FieldLiteralMapping>;
};

/**
 * What a No cross upload does (#8041), or would do for a dry run. It rides on the job's `result_stats`, so the
 * GraphQL type documents the shape for clients.
 */
export type ContractItemNoCrossUploadStats = {
  __typename?: 'ContractItemNoCrossUploadStats';
  /** Of them, already No cross: their note is updated when the file gives one. */
  alreadyNoCross: Scalars['Int']['output'];
  /** Those contracts, the first 100 by code. */
  contractsAffected: Array<HospitalCrossReferenceContractRef>;
  /** Contracts carrying the items, whose matching changes. */
  contractsAffectedCount: Scalars['Int']['output'];
  /** Their crosses in the organization's lists, removed. */
  crossesToRemove: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  /** Rows repeating an item earlier in the file. */
  duplicates: Scalars['Int']['output'];
  /** Rows with an error, which don't log. */
  errors: Scalars['Int']['output'];
  /** Contract items logged No cross: a row can find several (other vendors). */
  items: Scalars['Int']['output'];
  /** Rows in the file. */
  total: Scalars['Int']['output'];
  /** Rows that log. */
  valid: Scalars['Int']['output'];
};

export type UploadContractItemNoCrossesInput = {
  /** Preview: check the file and count what logging it would do, writing nothing. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  mappedFields: ContractItemNoCrossMappedFields;
  /** The note for every row without one of its own. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The file, as `uploadContractXrefFile` stored it. */
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type HospitalCrossReferenceListRow = {
  __typename?: 'HospitalCrossReferenceListRow';
  /** The user's organization's own contracts on All lists, which use every list it can read (Q11). */
  allListsContractCount: Scalars['Int']['output'];
  /** The user's organization can change the list's crosses (write or admin ACL). */
  canWrite: Scalars['Boolean']['output'];
  /** Pairs in the list, No cross rows excluded. */
  crossCount: Scalars['Int']['output'];
  /** Another customer's list, shared to the user's organization. */
  isShared: Scalars['Boolean']['output'];
  isStarred: Scalars['Boolean']['output'];
  lastChangeAt: Scalars['Date']['output'];
  /** Who made the last change, by name. */
  lastChangeBy?: Maybe<Scalars['String']['output']>;
  /** Crosses still held as clusters: members - 1 per cluster (until the #8046 migration). */
  legacyCrossCount: Scalars['Int']['output'];
  list: HospitalCrossReferenceListRef;
  /** The user's organization's contracts on Specific lists that picked this list (Loaded to, Q11). */
  specificContracts: Array<HospitalCrossReferenceContractRef>;
};

/** A cross: a contract item and the item it crosses (#8017). */
export type HospitalCrossReferencePair = {
  __typename?: 'HospitalCrossReferencePair';
  contractItem: HospitalCrossReferencePairItem;
  crossItem: HospitalCrossReferencePairItem;
  id: Scalars['ID']['output'];
  lastChangeAt: Scalars['Date']['output'];
  /** Who made the last change, by name. */
  lastChangeBy?: Maybe<Scalars['String']['output']>;
  list: HospitalCrossReferenceListRef;
};

/** Which pairs to show: by list (#8017), and by a search across lists (#8018). The contract filter comes with #8019. */
export type HospitalCrossReferencePairFilter = {
  /** Only the pairs that count on this contract (#8019): their contract item is on it. */
  contractId?: InputMaybe<Scalars['ID']['input']>;
  /** The lists to show. Omitted or empty: every list the organization can read. */
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Partial, case-insensitive. Matches either item of a pair, its list, or its contracts. */
  search?: InputMaybe<Scalars['String']['input']>;
  searchIn?: InputMaybe<HospitalCrossReferencePairSearchField>;
};

/** One side of a pair (#8017, spec §5.7): the item, its UOM and the contracts it is on. */
export type HospitalCrossReferencePairItem = {
  __typename?: 'HospitalCrossReferencePairItem';
  /** The organization's live contracts carrying the item. */
  contracts: Array<HospitalCrossReferenceContractRef>;
  description?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  tsId: Scalars['String']['output'];
  /** Display only (D16): as the item is priced on the organization's contracts, e.g. BX/10. */
  uom?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type HospitalCrossReferencePairPage = {
  __typename?: 'HospitalCrossReferencePairPage';
  /** The contract the pairs are filtered to (#8019), when `filter.contractId` is set. */
  contract?: Maybe<HospitalCrossReferenceContractRef>;
  hits: Array<HospitalCrossReferencePair>;
  totalHits: Scalars['Int']['output'];
};

/** Where a pair search looks (#8018): every field, or one. */
export enum HospitalCrossReferencePairSearchField {
  All = 'all',
  Contract = 'contract',
  Description = 'description',
  ItemNumber = 'itemNumber',
  List = 'list',
  Manufacturer = 'manufacturer',
  Vendor = 'vendor'
}

export type HospitalCrossReferencePairSort = {
  direction: OrderDirection;
  field: HospitalCrossReferencePairSortField;
};

export enum HospitalCrossReferencePairSortField {
  ContractItem = 'contractItem',
  CrossItem = 'crossItem',
  LastChange = 'lastChange'
}

export type IdArgs = {
  id: Scalars['String']['input'];
};

export type IOfferScenarioPriority = {
  isDisabled: Scalars['Boolean']['output'];
  isStrict: Scalars['Boolean']['output'];
  type: OfferScenarioPriorityType;
};

export enum IncludeAggsEnum {
  All = 'all',
  None = 'none',
  TotalSpend = 'totalSpend'
}

export type Initiative = {
  __typename?: 'Initiative';
  attachments?: Maybe<Array<InitiativeAttachment>>;
  comment?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dealRequestCount: Scalars['Int']['output'];
  embeddedIssueUrl?: Maybe<Scalars['String']['output']>;
  hospitalArea: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interested: Scalars['Boolean']['output'];
  interestedCount: Scalars['Int']['output'];
  isPublic: Scalars['Boolean']['output'];
  medtech?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Network>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: InitiativeStatusEnum;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user: User;
  valueElement?: Maybe<Array<Scalars['String']['output']>>;
};

export type InitiativeActivity = {
  __typename?: 'InitiativeActivity';
  action: InitiativeActivityActionEnum;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  initiative: Initiative;
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export enum InitiativeActivityActionEnum {
  Interested = 'interested',
  RequestedDeal = 'requestedDeal'
}

export type InitiativeActivityInput = {
  action: InitiativeActivityActionEnum;
  initiativeId: Scalars['String']['input'];
};

export type InitiativeAttachment = {
  __typename?: 'InitiativeAttachment';
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiativeId: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};

export type InitiativeAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** For updating existing Attachment. Omit this will create new Attachment Entity */
  id?: InputMaybe<Scalars['String']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};

export type InitiativeFilter = {
  myNetworksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<InitiativeType>;
};

export type InitiativeSelectorsList = {
  __typename?: 'InitiativeSelectorsList';
  hospitalAreas: Array<Scalars['String']['output']>;
  valueElements: Array<Scalars['String']['output']>;
};

export type InitiativeSort = {
  dir: Scalars['String']['input'];
  field: InitiativeSortEnum;
};

export enum InitiativeSortEnum {
  Collaboratior = 'collaboratior',
  CreatedAt = 'createdAt',
  Interested = 'interested'
}

export enum InitiativeStatusEnum {
  Completed = 'completed',
  InProgress = 'inProgress'
}

export enum InitiativeType {
  Completed = 'completed',
  Favorites = 'favorites',
  InProgress = 'inProgress'
}

export type InitiativesResult = {
  __typename?: 'InitiativesResult';
  hits: Array<Initiative>;
  totalHits: Scalars['Int']['output'];
};

export type InvitationMeta = {
  __typename?: 'InvitationMeta';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum InvitationStatusEnum {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type InviteMoreVendorsInput = {
  id: Scalars['String']['input'];
  vendors: Array<OpportunityInviteBaseInput>;
};

export type InviteUserInput = {
  customerId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  externalAuthConnectionId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isTopPowerUser?: InputMaybe<Scalars['Boolean']['input']>;
  isTopUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizations: Array<OrganizationPermission>;
  permissions?: InputMaybe<Array<UserPermissionFeature>>;
  qsGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InvitedUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Network role */
  role?: InputMaybe<UserNetworkRoleEnum>;
};

export type ItemGudid = {
  __typename?: 'ItemGudid';
  brandName?: Maybe<Scalars['String']['output']>;
  catalogNumber?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gmdnName?: Maybe<Array<Scalars['String']['output']>>;
  gmdnTerms?: Maybe<Array<GmdnTerm>>;
  gudid: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  productCodes?: Maybe<Array<ProductCode>>;
  submissionNumbers?: Maybe<Array<Scalars['String']['output']>>;
  versionModelNumber?: Maybe<Scalars['String']['output']>;
};

export type ItemSpend = {
  __typename?: 'ItemSpend';
  actualImpact?: Maybe<Scalars['Float']['output']>;
  benchmarks?: Maybe<Benchmark>;
  commodity?: Maybe<AggregatedItemCommodityType>;
  contract?: Maybe<Scalars['String']['output']>;
  currentPrice?: Maybe<Scalars['Float']['output']>;
  curvo25?: Maybe<Scalars['Float']['output']>;
  curvo50?: Maybe<Scalars['Float']['output']>;
  curvo75?: Maybe<Scalars['Float']['output']>;
  curvo90?: Maybe<Scalars['Float']['output']>;
  datepurchase?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['String']['output'];
  facilityItem?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gudid?: Maybe<ItemGudid>;
  id: Scalars['String']['output'];
  impact3m?: Maybe<Scalars['Float']['output']>;
  impact12m?: Maybe<Scalars['Float']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  l12mBenchmarks?: Maybe<Benchmark>;
  last12MonthsQuantity?: Maybe<Scalars['Float']['output']>;
  last12MonthsSpend?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  markupAdjusted12MSpend?: Maybe<Scalars['Float']['output']>;
  markupAdjustedPrice?: Maybe<Scalars['Float']['output']>;
  matchId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationItem?: Maybe<Scalars['String']['output']>;
  poNum?: Maybe<Scalars['String']['output']>;
  pricingTrends?: Maybe<Trend>;
  qty?: Maybe<Scalars['Float']['output']>;
  stan?: Maybe<AggregatedItemStanType>;
  topParentId?: Maybe<Scalars['String']['output']>;
  topParentName?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Scalars['Int']['output']>>;
  tsId?: Maybe<Scalars['String']['output']>;
  typeOne?: Maybe<Scalars['String']['output']>;
  typeTwo?: Maybe<Scalars['String']['output']>;
  unspsc?: Maybe<Scalars['String']['output']>;
  unspscClass?: Maybe<Scalars['String']['output']>;
  unspscClassCode?: Maybe<Scalars['String']['output']>;
  unspscCommodity?: Maybe<Scalars['String']['output']>;
  unspscCommodityCode?: Maybe<Scalars['String']['output']>;
  unspscFamily?: Maybe<Scalars['String']['output']>;
  unspscFamilyCode?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type ItemTransaction = {
  __typename?: 'ItemTransaction';
  datePurchase?: Maybe<Scalars['Date']['output']>;
  facDesc?: Maybe<Scalars['String']['output']>;
  facName?: Maybe<Scalars['String']['output']>;
  facilityItem?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  markupPrice?: Maybe<Scalars['Float']['output']>;
  mfgItem?: Maybe<Scalars['String']['output']>;
  poNum?: Maybe<Scalars['String']['output']>;
  qtyPurchase?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type ItemTransactionResult = {
  __typename?: 'ItemTransactionResult';
  hits: Array<ItemTransaction>;
  totalHit: Scalars['Int']['output'];
};

export type JobProgressEvent = {
  __typename?: 'JobProgressEvent';
  current: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export enum JobTypeEnum {
  BasketMetricsUpdate = 'BasketMetricsUpdate',
  BasketSmartRuleUpload = 'BasketSmartRuleUpload',
  BasketUpload = 'BasketUpload',
  BulkUpdateOfferItems = 'BulkUpdateOfferItems',
  CalculateBasketMetrics = 'CalculateBasketMetrics',
  CatalogUpload = 'CatalogUpload',
  ContractIngestion = 'ContractIngestion',
  ContractMatchingSpendsUpdate = 'ContractMatchingSpendsUpdate',
  ContractMatchingUpdate = 'ContractMatchingUpdate',
  ContractMembersApply = 'ContractMembersApply',
  ContractMembersUpload = 'ContractMembersUpload',
  ContractUpload = 'ContractUpload',
  ContractXrefUpload = 'ContractXrefUpload',
  CreateSmartBasket = 'CreateSmartBasket',
  CrossOfferItems = 'CrossOfferItems',
  CrossRefUpload = 'CrossRefUpload',
  ExportCatalogParts = 'ExportCatalogParts',
  ExportItemPoTransactions = 'ExportItemPoTransactions',
  ExportSearch = 'ExportSearch',
  OfferUpload = 'OfferUpload',
  OpportunityAccept = 'OpportunityAccept',
  OpportunityRefreshEnrichment = 'OpportunityRefreshEnrichment',
  OpportunityRetry = 'OpportunityRetry',
  PartsLinkageUpdate = 'PartsLinkageUpdate',
  PlayBookBasketsSync = 'PlayBookBasketsSync',
  RebuildQuicksightPermissions = 'RebuildQuicksightPermissions',
  RefreshConsolidatedView = 'RefreshConsolidatedView',
  SyncCurvoNormalizations = 'SyncCurvoNormalizations',
  UploadSearch = 'UploadSearch'
}

export type LastPurchaseDateByFacility = {
  __typename?: 'LastPurchaseDateByFacility';
  facilityId: Scalars['Float']['output'];
  facilityName: Scalars['String']['output'];
  lastPurchaseDate?: Maybe<Scalars['Date']['output']>;
};

export type LastPurchaseDateResult = {
  __typename?: 'LastPurchaseDateResult';
  data: Array<LastPurchaseDateByFacility>;
};

export type LinkageSearchInput = {
  searchText: Scalars['String']['input'];
};

export type ListDashboardsForUserInput = {
  userId: Scalars['String']['input'];
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  city: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  producesReprocessedItems?: Maybe<Scalars['Boolean']['output']>;
  retry?: Maybe<Array<ManufacturerRetry>>;
  segmentationId?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  ticker?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ManufacturerType>;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerRetry = {
  __typename?: 'ManufacturerRetry';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Type of Manufacturers */
export enum ManufacturerType {
  B = 'B',
  I = 'I',
  L = 'L',
  O = 'O',
  Other = 'Other',
  P = 'P',
  Unknown = 'Unknown'
}

export type MapField = {
  __typename?: 'MapField';
  columnName: Scalars['String']['output'];
  previewData?: Maybe<Scalars['String']['output']>;
  sheetIndex: Scalars['Int']['output'];
  sheetName: Scalars['String']['output'];
};

export type MappedFieldsType = {
  activationDate?: InputMaybe<Scalars['String']['input']>;
  contractCode?: InputMaybe<Scalars['String']['input']>;
  deactivationDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerItem?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  tierCode?: InputMaybe<Scalars['String']['input']>;
  topParent?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['String']['input']>;
  uom?: InputMaybe<Scalars['String']['input']>;
  uomConversion?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendorItem?: InputMaybe<Scalars['String']['input']>;
};

export enum MappingTypeEnum {
  Field = 'field',
  Literal = 'literal'
}

export enum MappingTypesEnum {
  Basket = 'Basket',
  Contract = 'Contract',
  ContractMembers = 'ContractMembers',
  CrossReference = 'CrossReference',
  NoCross = 'NoCross',
  Search = 'Search',
  SmartRule = 'SmartRule'
}

export type MarketTrend = {
  __typename?: 'MarketTrend';
  lrR2: Scalars['Float']['output'];
  lrSlope: Scalars['Float']['output'];
  numDataPoint: Scalars['Int']['output'];
  priceDelta: Scalars['Float']['output'];
  priceDeltaPercentage: Scalars['Float']['output'];
};

export type MarkContractItemsNoCrossInput = {
  /** Optional, e.g. "Checked Medline and Halyard. Nothing equivalent." */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Contract items: on a contract of the organization. */
  tsIds: Array<Scalars['String']['input']>;
};

export type MarkedContractItemsNoCross = {
  __typename?: 'MarkedContractItemsNoCross';
  /** Their crosses removed from the organization's lists, which contradict the No cross. */
  crossesRemoved: Scalars['Int']['output'];
  /** Items logged No cross. */
  marked: Scalars['Int']['output'];
};

export type MarkupRuleResult = {
  __typename?: 'MarkupRuleResult';
  data: Array<MarkupRuleWithDetail>;
  total: Scalars['Int']['output'];
};

export type MarkupRuleWithDetail = {
  __typename?: 'MarkupRuleWithDetail';
  baskets?: Maybe<Array<Basket>>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  facility?: Maybe<Organization>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Array<Scalars['String']['output']>>;
  marketBasket?: Maybe<Array<Scalars['String']['output']>>;
  markupPercent: Scalars['Float']['output'];
  topParent?: Maybe<Organization>;
  topParentId?: Maybe<Scalars['ID']['output']>;
  unspsc?: Maybe<Array<Scalars['String']['output']>>;
  unspscCommodity?: Maybe<Array<UnspscCommodity>>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type MatchOrganizationNamesInput = {
  kind: OrganizationMatchKindEnum;
  /** Matches returned per name (1–20, default 5) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Lowest score returned (0–1, default 0.3) */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** Names to match; one result per name, in the same order */
  names: Array<Scalars['String']['input']>;
};

export type MasterCatalog = {
  __typename?: 'MasterCatalog';
  commodityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  normalizedDescription?: Maybe<Scalars['String']['output']>;
  normalizedManufacturer?: Maybe<Scalars['String']['output']>;
  normalizedManufacturerItem?: Maybe<Scalars['String']['output']>;
  normalizedVendor?: Maybe<Scalars['String']['output']>;
  normalizedVendorItem?: Maybe<Scalars['String']['output']>;
  stanId?: Maybe<Scalars['String']['output']>;
  tsId?: Maybe<Scalars['String']['output']>;
  udiId?: Maybe<Scalars['String']['output']>;
};

export type MasterCatalogData = {
  __typename?: 'MasterCatalogData';
  description?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  med?: Maybe<MasterDataSourceMedType>;
  stn?: Maybe<MasterDataSourceStanType>;
  udi?: Maybe<MasterDataSourceUdiType>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export type MasterCatalogResult = {
  __typename?: 'MasterCatalogResult';
  hits: Array<MasterCatalog>;
  totalHits: Scalars['Int']['output'];
};

export type MasterDataSourceMedType = {
  __typename?: 'MasterDataSourceMedType';
  description?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  materialCode?: Maybe<Scalars['String']['output']>;
  normalizedCurvo?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  strippedMaterialCode?: Maybe<Scalars['String']['output']>;
  strippedSku?: Maybe<Scalars['String']['output']>;
};

export type MasterDataSourceStanType = {
  __typename?: 'MasterDataSourceStanType';
  brand?: Maybe<StanBaseData>;
  gic?: Maybe<StanBaseData>;
  id?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<StanBaseData>;
  material?: Maybe<StanBaseData>;
  part?: Maybe<StanPart>;
  productLine?: Maybe<StanBaseData>;
  segment?: Maybe<StanBaseData>;
  subSegment?: Maybe<StanBaseData>;
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
  typeOne?: Maybe<StanBaseData>;
  typeTwo?: Maybe<StanBaseData>;
};

export type MasterDataSourceUdiType = {
  __typename?: 'MasterDataSourceUdiType';
  catalogNumber?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gmdnName?: Maybe<Array<Scalars['String']['output']>>;
  normalizedCurvo?: Maybe<Scalars['String']['output']>;
  primaryIdentifier?: Maybe<Scalars['String']['output']>;
  productCodes?: Maybe<Array<Scalars['String']['output']>>;
  strippedCatalogNumber?: Maybe<Scalars['String']['output']>;
  strippedVersionModelNumber?: Maybe<Scalars['String']['output']>;
  versionModelNumber?: Maybe<Scalars['String']['output']>;
};

export type MemberAnalysisInput = {
  isProspect?: Scalars['Boolean']['input'];
  organizationIds: Array<Scalars['String']['input']>;
};

export type MemberAnalysisOutput = {
  __typename?: 'MemberAnalysisOutput';
  contract_description?: Maybe<Scalars['String']['output']>;
  contract_end?: Maybe<Scalars['Date']['output']>;
  contract_mfg?: Maybe<Scalars['String']['output']>;
  contract_mfgitem?: Maybe<Scalars['String']['output']>;
  contract_name?: Maybe<Scalars['String']['output']>;
  contract_price_diff?: Maybe<Scalars['Float']['output']>;
  contract_start?: Maybe<Scalars['Date']['output']>;
  contract_supplier?: Maybe<Scalars['String']['output']>;
  curvo25?: Maybe<Scalars['Float']['output']>;
  curvo50?: Maybe<Scalars['Float']['output']>;
  curvo75?: Maybe<Scalars['Float']['output']>;
  curvo90?: Maybe<Scalars['Float']['output']>;
  curvo_category?: Maybe<Scalars['String']['output']>;
  e_description?: Maybe<Scalars['String']['output']>;
  e_manufacturer?: Maybe<Scalars['String']['output']>;
  e_mfgitem?: Maybe<Scalars['String']['output']>;
  e_uom?: Maybe<Scalars['String']['output']>;
  e_uomconversion?: Maybe<Scalars['Float']['output']>;
  e_vendor?: Maybe<Scalars['String']['output']>;
  e_venitem?: Maybe<Scalars['String']['output']>;
  extprice?: Maybe<Scalars['Float']['output']>;
  facility_name?: Maybe<Scalars['String']['output']>;
  gic?: Maybe<Scalars['String']['output']>;
  is_prospect: Scalars['Boolean']['output'];
  last_date_purchase?: Maybe<Scalars['Date']['output']>;
  last_price?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  perc_contract_price_diff?: Maybe<Scalars['Float']['output']>;
  perc_price_diff_after_rebates?: Maybe<Scalars['Float']['output']>;
  price_diff_after_rebates?: Maybe<Scalars['Float']['output']>;
  product_line?: Maybe<Scalars['String']['output']>;
  projected_spend?: Maybe<Scalars['Float']['output']>;
  qtypurchase?: Maybe<Scalars['Float']['output']>;
  rebate_stats?: Maybe<Scalars['JSON']['output']>;
  s_description?: Maybe<Scalars['String']['output']>;
  s_manufacturer?: Maybe<Scalars['String']['output']>;
  s_mfgitem?: Maybe<Scalars['String']['output']>;
  s_uom?: Maybe<Scalars['String']['output']>;
  s_uomconversion?: Maybe<Scalars['Float']['output']>;
  s_vendor?: Maybe<Scalars['String']['output']>;
  s_venitem?: Maybe<Scalars['String']['output']>;
  sourcing_officer?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  tier_price?: Maybe<Scalars['Float']['output']>;
  tier_rebate?: Maybe<Scalars['Float']['output']>;
  tier_uom?: Maybe<Scalars['String']['output']>;
  tier_uom_conversion?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_one?: Maybe<Scalars['String']['output']>;
  type_two?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MessageTemplateList = {
  __typename?: 'MessageTemplateList';
  data: Array<MessageTemplate>;
};

export type MetricsType = {
  __typename?: 'MetricsType';
  benchmarks: Scalars['Boolean']['output'];
  coverage: Scalars['Boolean']['output'];
  pricingTarget: Scalars['Boolean']['output'];
  quantity: Scalars['Boolean']['output'];
  rank: Scalars['Boolean']['output'];
};

export type MetricsVendorType = {
  benchmarks: Scalars['Boolean']['input'];
  coverage: Scalars['Boolean']['input'];
  pricingTarget: Scalars['Boolean']['input'];
  quantity: Scalars['Boolean']['input'];
  rank: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Log contract items as having no equivalent, with an optional note: nothing converts to them on any contract. Removes their crosses from the organization's lists. */
  markContractItemsNoCross: MarkedContractItemsNoCross;
  /** Undo a No cross: the item needs a cross again. The crosses logging it removed stay removed. */
  reverseContractItemNoCross: Scalars['Boolean']['output'];
  acceptOpportunity?: Maybe<UploadJob>;
  activateCustomer: Customer;
  /** Activate sourcing plan with at least one basket and `draft` status. */
  activateSourcingPlan: SourcingPlan;
  activateVendor: Customer;
  addContractAttachment: ContractAttachment;
  /** Queues the job applying a contract members upload's previewed batch, behind the customer's other uploads */
  applyContractMembersUpload: ContractMembersApplySubmission;
  addContractTier: UpdateContractTierResult;
  addContractTierRebate: Scalars['Boolean']['output'];
  /** Add one cross to a list the organization owns and can write (#8022). Reverses the contract item's No cross. */
  addCrossReferencePair: AddedCrossReferencePair;
  addInitiativeActivity: InitiativeActivity;
  addNetworkMembers: Array<UserNetwork>;
  addOfferFavorite: OfferFavorite;
  addOrganizationToCustomer: Organization;
  /** Add basket to sourcing plan. */
  addSourcingPlanBasket: SourcingPlanBasket;
  addSourcingPlanBasketStakeholder: SourcingPlanBasketsStakeholders;
  /** Add sourcing plan stakeholder. */
  addSourcingPlanStakeholder: SourcingPlanStakeHolder;
  addUserToOrganization: UserOrganization;
  adminFillCustomBasketProductsInfo: Scalars['Boolean']['output'];
  adminGenerateOfferItemsCrossSuggestion: Scalars['Boolean']['output'];
  adminPopulateOfferItemCatalogPartsBenchmarks: Scalars['Boolean']['output'];
  adminRedeemOpportunity: Offer;
  adminResetPassword: Scalars['Boolean']['output'];
  adminUpdateClustersAndLeaders: Scalars['Boolean']['output'];
  applyAllOfferItemsSuggestion: Scalars['Boolean']['output'];
  applySuggestionsToAllUnlinkedCatalogParts: Scalars['Boolean']['output'];
  /** Archives a basket and disconnects it from every contract using it, dropping the tier / rebate rules scoped to it. */
  archiveBasket: Basket;
  archiveContract: Contract;
  archiveNetwork: Network;
  archiveOpportunity: Offer;
  archiveSupplierOpportunity: SupplierOpportunity;
  archiveSupplierOpportunityOffer: SupplierOpportunity;
  awardScenario: OfferScenario;
  bulkApproveStudyLinks: Array<QueuedLinkProcess>;
  bulkOrganizationUserRoleUpdate: Array<UserOrganization>;
  bulkUpdateBasketSmartRules: Array<SmartRule>;
  bulkUpdateHomepageFeaturedContents: Array<HomepageFeaturedContent>;
  bulkUpdateOfferCrossItems: Array<OfferItem>;
  bulkUpdateOfferItemsLinkage: Array<OfferItem>;
  /** Bulk update offer items' tier prices. If a negative price is passed, this mutation will delete that record, otherwise create or update offer items' tiers' price */
  bulkUpdateOfferItemsTiersPrice: Array<OfferItem>;
  /** Bulk update offer items and its related (affected by same tiers) catalog parts' tier prices. This mutation updates whether OfferItem or CatalogPart based on the prefix of input id, `offerItem#` for updating `OfferItem` and `catalogPart#` for `CatalogPart` . If a negative price is passed, this mutation will delete that record, otherwise create or update offer items' tiers' price */
  bulkUpdateOfferPricingItemsTiersPrice: Array<OfferPricingItem>;
  bulkUpdateOpportunityItemsPricingTarget: Array<OfferItem>;
  bulkUpdateScenarioItems: Scalars['Boolean']['output'];
  bulkUpdateStudyLinks: Array<QueuedLinkProcess>;
  bulkUpsertCatalogPartTiers: Array<CatalogPartTier>;
  bulkUserPermissionsUpdate: Array<UserOrganization>;
  calculateAllBasketsMetrics: Array<BasketMetricsUpdateResult>;
  /** Cancel the `active` `CategoryConsultRequest`, notify Curvo Customer Success team via email and slack */
  cancelCategoryConsultRequest: CategoryConsultRequest;
  /** Takes the caller's apply job out of the upload queue before it starts */
  cancelContractMembersUploadApply: Scalars['Boolean']['output'];
  /** Check if this opportunity needs to be generated items */
  checkAndGenerateOfferItems: Offer;
  checkExistVendor: Scalars['Boolean']['output'];
  cloakingPermissionsOfUser: Scalars['Boolean']['output'];
  completeSupplierOpportunity: SupplierOpportunity;
  /** A signed form to post a cross-reference file straight to S3, for the contract upload wizard; valid for 1 hour. */
  contractXrefUploadUrl: S3UploadGeneratedUrl;
  /** Create a copy of a Curvo Basket, newly created Basket will be a normal Custom basket */
  copyCurvoBasket: CopyCurvoBasketResponse;
  createBasketDashboardRelation: Scalars['Boolean']['output'];
  createCatalogParts: Array<CatalogPart>;
  createContact: Contact;
  createContractDashboardRelation: Scalars['Boolean']['output'];
  createCrossReferenceList: UploadJob;
  createCustomField: CustomField;
  createCustomer: Customer;
  createDashboard: Dashboard;
  createDashboards: Array<Scalars['String']['output']>;
  createDraftContract: Contract;
  createNetworkWithUsers: Network;
  createNewInitiative: Initiative;
  createOffer: Offer;
  createOfferScenario: OfferScenario;
  createOrganization: Organization;
  createOrganizationType: OrganizationType;
  createSavedMapping: SavedMapping;
  createSupportTicket: Scalars['Boolean']['output'];
  createTiers: Array<Tier>;
  createVendor: Customer;
  createVendorUser: User;
  crossReferenceOfferItems: Offer;
  deactivateCustomer: Customer;
  deactivateVendor: Customer;
  deleteClusterParts: Array<Scalars['String']['output']>;
  deleteCrossReferenceClusters: Array<Scalars['String']['output']>;
  deleteCrossReferenceLists: Array<Scalars['String']['output']>;
  deleteCrossReferenceMaps: Array<CrossReferenceMap>;
  /** Delete crosses from lists the organization owns and can write (#8024). Returns the ids deleted. */
  deleteCrossReferencePairs: Array<Scalars['ID']['output']>;
  deleteCustomField: Scalars['Boolean']['output'];
  /** Delete lists (#8015): owner only, never the starred list. Contracts left with no list go back to All lists. */
  deleteHospitalCrossReferenceLists: Array<Scalars['String']['output']>;
  deleteMarkupRule: Scalars['Boolean']['output'];
  deleteOrganizationType: Scalars['Boolean']['output'];
  deleteSavedMapping: SavedMapping;
  deleteSavedSearch: SavedSearch;
  deleteScenario: OfferScenario;
  /** Soft delete a Sourcing Plan by id. Only the creator can delete Sourcing Plan */
  deleteSourcingPlan: SourcingPlan;
  deleteSupplierOpportunity: SupplierOpportunity;
  deleteSupplierOpportunityOffer: SupplierOpportunity;
  /** Drops the caller's contract members upload batches that were never applied; returns the rows removed */
  discardContractMembersUploadDrafts: Scalars['Int']['output'];
  doAggregatedSearch: AggregatedSearchResult;
  doSavedSearch: SearchResult;
  doUploadAggSearch: UploadJob;
  downloadContractAttachment: Scalars['String']['output'];
  downloadVendorOffer: Scalars['String']['output'];
  duplicateSearch: SavedSearch;
  editSavedMapping: SavedMapping;
  editSavedSearch: SavedSearch;
  editSmartBasket: SmartBasket;
  exportAggregatedSearch: UploadJob;
  exportCatalogParts: ExportCatalogPartsPayload;
  exportConsolidatedReport: Scalars['String']['output'];
  /** The crosses `hospitalCrossReferencePairs` finds, as an xlsx (base64) in the upload columns, so it can be edited and uploaded again (#8025). */
  exportCrossReferencePairs: UploadJob;
  exportItemPoTransactions: UploadJob;
  exportOfferItemsToXlsx: Scalars['String']['output'];
  fetchMappingFields: FetchMappingFieldsResult;
  fillAllPriceScores: Scalars['Boolean']['output'];
  fillPriceScores: Scalars['Boolean']['output'];
  generateAllContractMembers: Scalars['Boolean']['output'];
  generateBasketSmartRules: Scalars['Boolean']['output'];
  generateCustomFieldsFromExtraFields: Array<CustomField>;
  generateDefaultOfferScenario: Scalars['Boolean']['output'];
  /** Allow user to upload a document file (word, excel, csv or pdf) to a s3 temp folder, the result is a URL which can be only used for uploading and valid for 1 hour */
  generateDocumentUploadUrl: S3UploadGeneratedUrl;
  /** Allow user to upload an image file to a s3 temp folder, the result is a URL which can be only used for uploading and valid for 1 hour */
  generateImageUploadUrl: S3UploadGeneratedUrl;
  /** Generate a presigned URL to upload a rebate reconciliation evidence document directly to its final S3 location. */
  generateRebateEvidenceUploadUrl: S3UploadGeneratedUrl;
  getContractPartUploadTemplate: Scalars['String']['output'];
  getContractXrefUploadTemplate: Scalars['String']['output'];
  /** Hide a Basket/Category */
  hideSourcingPlanBasket: SourcingPlanBasketBase;
  inviteMoreVendors: Array<OfferInvitingVendor>;
  inviteUser: User;
  leaveNetwork: Scalars['Boolean']['output'];
  linkStudy: QueuedStudy;
  migrateVendorUser: Scalars['Boolean']['output'];
  newSmartBasket: SmartBasket;
  onLogin: Scalars['Boolean']['output'];
  opportunityCustomizationSave: Scalars['Boolean']['output'];
  /** Pin a Basket/Category */
  pinSourcingPlanBasket: SourcingPlanBasketBase;
  populateContractTierRebateMessage: Scalars['Boolean']['output'];
  populateOfferItemCatalogPartsBenchmarks: Scalars['Boolean']['output'];
  processBasketUpload: Scalars['String']['output'];
  /** Queues the preview job of a contract members bulk upload */
  processContractMembersUpload: ContractMembersUploadSubmission;
  processContractUpload: Scalars['String']['output'];
  processContractXrefUpload: Scalars['String']['output'];
  processSmartRuleUpload: Scalars['String']['output'];
  queueAllContracMatchingSpendsUpdateJob: Array<UploadJob>;
  /** Queue a list of ContractMatchingUpdate jobs to be processed by worker. */
  queueAllContractsMatchingUpdateJob: Array<UploadJob>;
  /** Queue a CalculateBasketMetricsJob to be processed by worker. */
  queueCalculateBasketMetricsJob: Array<UploadJob>;
  queueContracMatchingSpendsUpdateJob: UploadJob;
  queueCreateSmartBasket: UploadJob;
  queueCrossReferenceOfferItems: UploadJob;
  queueJob: Scalars['Boolean']['output'];
  /** Queue a PlayBookBasketsSync job to send basket data to PlayBook. */
  queuePlayBookBasketsSync: Array<UploadJob>;
  /** Queue a list of PartsLinkageUpdate jobs to be processed by worker. */
  queueUpdatePartsLinkageJob: Array<UploadJob>;
  quickCreateNewOrganizations: Array<Organization>;
  rebuildQuicksightPermissions: Scalars['Boolean']['output'];
  redeemOpportunity: Offer;
  refreshOfferScenarioTiersAndRebatesCalulation: Scalars['Boolean']['output'];
  /** Queue a refresh enrichment job for input opportunity to be processed by worker. */
  refreshOpportunityEnrichment: UploadJob;
  refreshSmartBasket: Basket;
  rejectOpportunity: Scalars['Boolean']['output'];
  removeBasketProducts: RemoveBasketProductsResponse;
  removeBasketSmartRules: Scalars['Boolean']['output'];
  /** Remove Cloaked status for current Admin User */
  removeCloak: Scalars['Boolean']['output'];
  removeContractAttachment: Scalars['Boolean']['output'];
  removeContractMemberTierHistories: Array<Scalars['String']['output']>;
  /** Return affected parts */
  removeContractPartTierHistories: Array<Part>;
  removeContractParts: Scalars['Boolean']['output'];
  removeContractTier: Scalars['Boolean']['output'];
  removeContractRebateGroup: Scalars['Boolean']['output'];
  removeContractTierRebate: Scalars['Boolean']['output'];
  removeDashboards: Scalars['Boolean']['output'];
  removeInitiativeActivity: Scalars['Boolean']['output'];
  removeMessageTemplate: Scalars['Boolean']['output'];
  removeNetworkMember: UserNetwork;
  removeOfferFavorite: Scalars['Boolean']['output'];
  removeOfferRebate: Scalars['Boolean']['output'];
  removeOpportunityItems: Array<OfferItem>;
  removeRebateEvidenceDoc: RebatePeriodActual;
  /** Remove basket from sourcing plan. */
  removeSourcingPlanBasket: SourcingPlanBasket;
  removeSourcingPlanBasketStakeholder: SourcingPlanBasketsStakeholders;
  /** Remove a sourcing plan stakeholder by ID. But its `Contact` should be persisted */
  removeSourcingPlanStakeholder: SourcingPlanStakeHolder;
  removeUser: User;
  removeUserFromOrganization: UserOrganization;
  /** Rename a list (#8015). Owner only; the name must be unique among the lists the organization reads. */
  renameCrossReferenceList: CrossReferenceList;
  reopenSubmittedOffer: Scalars['Boolean']['output'];
  repopulateCatalogPartsIsImplantable: Scalars['Boolean']['output'];
  repopulateStanDataForCatalogParts: Scalars['Boolean']['output'];
  /** Fire new `Category` (`Basket`) consult request, notify Curvo Customer Success team via email and slack */
  requestCategoryConsult: CategoryConsultRequest;
  resendInvite: Scalars['Boolean']['output'];
  resendNetworkInvitation: Scalars['Boolean']['output'];
  resendUserInvitation: Scalars['Boolean']['output'];
  /** Allow a cloaked CS user to wipe out whole catalog of a Supplier */
  resetCatalog: Scalars['Boolean']['output'];
  resetOfferScenario: OfferScenario;
  resetPassword: Scalars['Boolean']['output'];
  /** Undo a delete (#8024): put the crosses back with their original ids, skipping any in the way. */
  restoreCrossReferencePairs: RestoredCrossReferencePairs;
  /** Retry the Opportunity, create new Offer and start over; Return UploadJob record with new offer id in field resultStats */
  retryOpportunity?: Maybe<UploadJob>;
  saveCrossReferenceMappings: Array<CrossReferenceMap>;
  saveDraftOpportunity: Offer;
  saveMessageTemplate: MessageTemplate;
  saveSearch: SavedSearch;
  searchByUploadedSearchId: SearchByUploadedSearchIdResult;
  sendBasketStakeholdersSurvey: Array<SourcingPlanBasketsStakeholders>;
  sendProjectApertureInvitation: Scalars['Boolean']['output'];
  sendSourcingPlanStakeholdersSurvey: Array<SourcingPlanStakeHolder>;
  /** Choose all lists, specific lists or none for a contract (#7999). */
  setContractCrossReferenceLists: Contract;
  setCustomerMainContact: Customer;
  setNormalizedManufacturer: Customer;
  signUp: User;
  /** Snooze a Basket/Category */
  snoozeSourcingPlanBasket: SourcingPlanBasketBase;
  /** Start new draft sourcing plan with draft status. */
  startSourcingPlan: SourcingPlan;
  submitContract: Scalars['Boolean']['output'];
  submitOpportunity: Offer;
  syncContractEnrichments: SyncContractEnrichmentsResult;
  syncCreateCustomer: Customer;
  syncCreateOrganization: Organization;
  syncCurvoNormalizations: UploadJob;
  syncOpportunitiesWithEventTracker: Scalars['Boolean']['output'];
  syncUpdateCustomer: Customer;
  syncUpdateOrganization: Organization;
  syncUserQuickSightGroups: Scalars['Boolean']['output'];
  syncUsersToPlane: Scalars['Boolean']['output'];
  tierArchivedToggle: Tier;
  toggleRebateCardStar: RebateOpportunityCardPreference;
  toggleRebateCardVisibility: RebateOpportunityCardPreference;
  toggleUserActivation: User;
  unarchiveBasket: Basket;
  unarchiveOpportunity: Offer;
  updateAutoBaskets: Scalars['Boolean']['output'];
  updateBasketVisibility: Basket;
  updateCatalogItem: CatalogPart;
  updateCatalogParts: Array<CatalogPart>;
  updateCatalogPartsWithMasterTsId: Array<CatalogPart>;
  /** Update Cloaked Organization for current Admin User */
  updateCloak: Scalars['Boolean']['output'];
  updateCommitment: OfferScenario;
  updateContractAttachment: ContractAttachment;
  updateContractBaskets: Contract;
  updateContractMemberTierHistories: Array<ContractOrganizationHistory>;
  updateContractMembers: Array<ContractMember>;
  updateContractParts: Array<UpdateContractPartsOutput>;
  updateContractWithCrossReferenceList: Scalars['String']['output'];
  /** Run contract matching for a list of contracts */
  updateContractsMatching: Scalars['Boolean']['output'];
  updateCrossReferenceList: CrossReferenceList;
  /** Point a cross at other items (#8023); a side left out stays. Reverses the new contract item's No cross. */
  updateCrossReferencePair: AddedCrossReferencePair;
  updateCustomField: CustomField;
  updateCustomFieldsOrder: Scalars['Boolean']['output'];
  updateCustomer: Customer;
  updateDashboard: Scalars['String']['output'];
  updateDraftContract: UpdateDraftContractResult;
  updateDraftOpportunity: Offer;
  updateLinkedTsIds: Scalars['Boolean']['output'];
  updateMe: User;
  updateMessageTemplate: MessageTemplate;
  updateNetworkMemberRole: UserNetwork;
  updateOffer: UpdateOfferResult;
  updateOfferCustomFields: Scalars['Boolean']['output'];
  updateOfferTier: Offer;
  updateOpportunityAttachment: OpportunityAttachment;
  updateOpportunityItem: OfferItem;
  updateOrganization: Organization;
  updateRebateCardNote: RebateOpportunityCardPreference;
  updateScenarioItemByOffer: Scalars['Boolean']['output'];
  updateSmartBasketConfig: Basket;
  /** Update sourcing plan. */
  updateSourcingPlan: SourcingPlan;
  /** Update SourcingPlanBasket */
  updateSourcingPlanBasket: SourcingPlanBasketBase;
  /** Update sourcing plan basket stakeholder. */
  updateSourcingPlanBasketStakeholder: SourcingPlanBasketsStakeholders;
  /** Update sourcing plan stakeholder. */
  updateSourcingPlanStakeholder: SourcingPlanStakeHolder;
  updateSupplierOpportunity: SupplierOpportunity;
  updateSupplierOpportunityACL: Array<Acl>;
  updateSupplierOpportunityAttachments: Array<OpportunityAttachment>;
  updateTierCatalogPartPrice: CatalogPartTier;
  updateTierRules: Tier;
  updateTiers: Array<Tier>;
  updateUploadBasketBenchmarks: Scalars['Boolean']['output'];
  updateUser: User;
  updateVendor: Customer;
  updateVendorUser: User;
  uploadBasketFile: UploadBasketResult;
  uploadBulkUpdateOfferItems: UploadJob;
  uploadCatalog: Scalars['String']['output'];
  uploadContractFile: UploadContractResult;
  uploadContractMembersFile: UploadBasketResult;
  uploadContractXrefFile: UploadContractResult;
  uploadCrossReference: UploadJob;
  /** Upload crosses into a new list, or add to or overwrite one (#8002, spec §5.5); with `dryRun`, preview. Returns the job id: its `result_stats` hold `HospitalCrossReferenceUploadStats`. */
  uploadHospitalCrossReferences: Scalars['String']['output'];
  /** Upload a file of contract items with no equivalent, each logged No cross (#8041); with `dryRun`, preview. Returns the job id: its `result_stats` hold `ContractItemNoCrossUploadStats`. */
  uploadContractItemNoCrosses: Scalars['String']['output'];
  uploadOpportunity: UploadJob;
  uploadSearchFile: UploadSearchResult;
  uploadSmartRuleFile: UploadBasketResult;
  upsertContractPartTierHistories: UpsertContractPartTierHistoriesResult;
  upsertContractRebateGroup: RebateGroup;
  upsertMarkupRules: Array<MarkupRuleWithDetail>;
  upsertOfferRebate: TierRebate;
  upsertRebatePeriodActual: RebatePeriodActual;
  verifyAccount: User;
  viewOffer: Scalars['Boolean']['output'];
  warmupMigrationFunction: Scalars['Boolean']['output'];
};


export type MutationAcceptOpportunityArgs = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationApplyContractMembersUploadArgs = {
  batchId: Scalars['ID']['input'];
};


export type MutationActivateCustomerArgs = {
  input: CustomerActivationInput;
};


export type MutationActivateSourcingPlanArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  sourcingPlanId: Scalars['String']['input'];
};


export type MutationActivateVendorArgs = {
  input: IdArgs;
};


export type MutationAddContractAttachmentArgs = {
  input: AddContractAttachmentInput;
};


export type MutationAddContractTierArgs = {
  input: CreateContractTierInput;
};


export type MutationAddContractTierRebateArgs = {
  input: CreateTierRebateInput;
};


export type MutationAddCrossReferencePairArgs = {
  input: AddCrossReferencePairInput;
};

export type MutationAddInitiativeActivityArgs = {
  input: InitiativeActivityInput;
};


export type MutationAddNetworkMembersArgs = {
  input: AddNetworkMemberInput;
};


export type MutationAddOfferFavoriteArgs = {
  input: OfferFavoriteInput;
};


export type MutationAddOrganizationToCustomerArgs = {
  input: AddOrganizationToCustomerInput;
};


export type MutationAddSourcingPlanBasketArgs = {
  input: AddSourcingPlanBasketInput;
};


export type MutationAddSourcingPlanBasketStakeholderArgs = {
  input: AddSourcingPlanBasketsStakeholdersInput;
};


export type MutationAddSourcingPlanStakeholderArgs = {
  input: AddSourcingPlanStakeholderInput;
};


export type MutationAddUserToOrganizationArgs = {
  input: UserOrganizationInput;
};


export type MutationAdminFillCustomBasketProductsInfoArgs = {
  basketIds: Array<Scalars['String']['input']>;
};


export type MutationAdminGenerateOfferItemsCrossSuggestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationAdminRedeemOpportunityArgs = {
  input: AdminRedeemOpportunityInput;
};


export type MutationAdminResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationAdminUpdateClustersAndLeadersArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationApplyAllOfferItemsSuggestionArgs = {
  input: IdArgs;
};


export type MutationArchiveBasketArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveContractArgs = {
  input: ArchiveContractInput;
};


export type MutationArchiveNetworkArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSupplierOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSupplierOpportunityOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationAwardScenarioArgs = {
  input: AwardScenarioInput;
};


export type MutationBulkApproveStudyLinksArgs = {
  input: BulkApproveStudyLinkInput;
};


export type MutationBulkOrganizationUserRoleUpdateArgs = {
  input: BulkUserOrganizationRoleUpdateInput;
};


export type MutationBulkUpdateBasketSmartRulesArgs = {
  input: BulkUpdateBasketSmartRulesInput;
};


export type MutationBulkUpdateHomepageFeaturedContentsArgs = {
  input: BulkUpdateHomepageFeaturedContentInput;
};


export type MutationBulkUpdateOfferCrossItemsArgs = {
  input: BulkUpdateOfferItemCrossInput;
};


export type MutationBulkUpdateOfferItemsLinkageArgs = {
  input: BulkUpdateOfferItemLinkageInput;
};


export type MutationBulkUpdateOfferItemsTiersPriceArgs = {
  input: BulkUpdateOfferItemTiersPriceInput;
};


export type MutationBulkUpdateOfferPricingItemsTiersPriceArgs = {
  input: BulkUpdateOfferPricingItemTiersPriceInput;
};


export type MutationBulkUpdateOpportunityItemsPricingTargetArgs = {
  input: BulkUpdateOpportunityItemsPricingTargetInput;
};


export type MutationBulkUpdateScenarioItemsArgs = {
  input: BulkUpdateOfferScenarioItemsInput;
};


export type MutationBulkUpdateStudyLinksArgs = {
  input: BulkUpdateStudyLinkInput;
};


export type MutationBulkUpsertCatalogPartTiersArgs = {
  input: BulkUpdateCatalogPartTierInput;
};


export type MutationBulkUserPermissionsUpdateArgs = {
  input: BulkUserPermissionUpdateInput;
};


export type MutationCalculateAllBasketsMetricsArgs = {
  basketId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  onlyNew?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBefore?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCancelCategoryConsultRequestArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelContractMembersUploadApplyArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCheckAndGenerateOfferItemsArgs = {
  id: Scalars['String']['input'];
  skipZeroQuantityItems: Scalars['Boolean']['input'];
};


export type MutationCheckExistVendorArgs = {
  input: CheckExistVendorInput;
};


export type MutationCloakingPermissionsOfUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCompleteSupplierOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationContractXrefUploadUrlArgs = {
  input: ContractXrefUploadUrlInput;
};

export type MutationCopyCurvoBasketArgs = {
  input: CopyCurvoBasketInput;
};


export type MutationCreateBasketDashboardRelationArgs = {
  input: CreateBasketDashboardInput;
};


export type MutationCreateCatalogPartsArgs = {
  input: Array<CreateCatalogPartInput>;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContractDashboardRelationArgs = {
  input: CreateContractDashboardInput;
};


export type MutationCreateCrossReferenceListArgs = {
  input: CreateCrossReferenceListInput;
};


export type MutationCreateCustomFieldArgs = {
  input: CustomFieldInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDashboardArgs = {
  input: CreateDashboardInput;
};


export type MutationCreateDraftContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateNetworkWithUsersArgs = {
  input: CreateNetworkWithUsersInput;
};


export type MutationCreateNewInitiativeArgs = {
  input: CreateInitiativeInput;
};


export type MutationCreateOfferArgs = {
  input: CreateOfferInput;
};


export type MutationCreateOfferScenarioArgs = {
  input: CreateOfferScenarioInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationTypeArgs = {
  input: CreateOrganizationTypeInput;
};


export type MutationCreateSavedMappingArgs = {
  input: CreateSavedMappingInput;
};


export type MutationCreateSupportTicketArgs = {
  input: SupportTicketInput;
};


export type MutationCreateTiersArgs = {
  input: Array<CreateTierInput>;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationCreateVendorUserArgs = {
  input: CreateVendorUserInput;
};


export type MutationCrossReferenceOfferItemsArgs = {
  input: CrossReferenceOfferItemInput;
};


export type MutationDeactivateCustomerArgs = {
  input: CustomerActivationInput;
};


export type MutationDeactivateVendorArgs = {
  input: IdArgs;
};


export type MutationDeleteClusterPartsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCrossReferenceClustersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCrossReferenceListsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteCrossReferenceMapsArgs = {
  input: DeleteCrossReferenceMapsInput;
};


export type MutationDeleteCrossReferencePairsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCustomFieldArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteHospitalCrossReferenceListsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteMarkupRuleArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteOrganizationTypeArgs = {
  input: RemoveOrganizationTypeInput;
};


export type MutationDeleteSavedMappingArgs = {
  input: DeleteSavedMappingInput;
};


export type MutationDeleteSavedSearchArgs = {
  input: IdArgs;
};


export type MutationDeleteScenarioArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSourcingPlanArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSupplierOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSupplierOpportunityOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationDoAggregatedSearchArgs = {
  input: CreateSavedSearchInput;
  pagination?: InputMaybe<Pagination>;
};


export type MutationDoSavedSearchArgs = {
  input: IdArgs;
};


export type MutationDoUploadAggSearchArgs = {
  input: DoUploadSearchInput;
  pagination?: InputMaybe<Pagination>;
};


export type MutationDownloadContractAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDownloadVendorOfferArgs = {
  input: DownloadVendorOfferInput;
};


export type MutationDuplicateSearchArgs = {
  input: IdArgs;
};


export type MutationEditSavedMappingArgs = {
  input: UpdateSavedMappingInput;
};


export type MutationEditSavedSearchArgs = {
  input: UpdateSavedSearchInput;
};


export type MutationEditSmartBasketArgs = {
  input: UpdateSmartBasketInput;
  pagination?: InputMaybe<Pagination>;
};


export type MutationExportAggregatedSearchArgs = {
  input: ExportAggregatedSearchInput;
};


export type MutationExportCatalogPartsArgs = {
  input: ExportCatalogPartsInput;
};


export type MutationExportConsolidatedReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationExportCrossReferencePairsArgs = {
  filter: HospitalCrossReferencePairFilter;
  sort?: InputMaybe<HospitalCrossReferencePairSort>;
};


export type MutationExportItemPoTransactionsArgs = {
  input: ExportItemPoTransactionsInput;
};


export type MutationExportOfferItemsToXlsxArgs = {
  id: Scalars['String']['input'];
  selectedFields: Array<OfferItemExportsFieldEnum>;
  selectedTierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  withRemainingTiersCatalogParts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFetchMappingFieldsArgs = {
  input: FetchMappingFieldsInput;
};


export type MutationFillPriceScoresArgs = {
  opportunityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateAllContractMembersArgs = {
  input: GenerateAllContractMembersInput;
};


export type MutationGenerateBasketSmartRulesArgs = {
  input: GenerateBasketSmartRulesInput;
};


export type MutationGenerateCustomFieldsFromExtraFieldsArgs = {
  customerId: Scalars['String']['input'];
  targets?: InputMaybe<Array<CustomFieldTargetEnum>>;
};


export type MutationGenerateDefaultOfferScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationGenerateDocumentUploadUrlArgs = {
  input: UploadInput;
};


export type MutationGenerateImageUploadUrlArgs = {
  input: UploadInput;
};


export type MutationGenerateRebateEvidenceUploadUrlArgs = {
  input: GenerateRebateEvidenceUploadUrlInput;
};


export type MutationGetContractPartUploadTemplateArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationGetContractXrefUploadTemplateArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationHideSourcingPlanBasketArgs = {
  input: HideSourcingPlanInput;
};


export type MutationInviteMoreVendorsArgs = {
  input: InviteMoreVendorsInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLeaveNetworkArgs = {
  id: Scalars['String']['input'];
};


export type MutationLinkStudyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationMigrateVendorUserArgs = {
  username: Scalars['String']['input'];
};


export type MutationNewSmartBasketArgs = {
  input: CreateSmartBasketInput;
  pagination?: InputMaybe<Pagination>;
};


export type MutationOpportunityCustomizationSaveArgs = {
  input: OpportunityCustomizationSaveInput;
};


export type MutationPinSourcingPlanBasketArgs = {
  input: PinSourcingPlanInput;
};


export type MutationPopulateContractTierRebateMessageArgs = {
  contractIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPopulateOfferItemCatalogPartsBenchmarksArgs = {
  id: Scalars['String']['input'];
};


export type MutationProcessBasketUploadArgs = {
  input: ProcessBasketUploadInput;
};


export type MutationProcessContractUploadArgs = {
  input: ProcessContractUploadInput;
};


export type MutationProcessContractMembersUploadArgs = {
  input: ProcessContractMembersUploadInput;
};


export type MutationProcessContractXrefUploadArgs = {
  input: ProcessContractXrefUploadInput;
};


export type MutationUploadHospitalCrossReferencesArgs = {
  input: HospitalCrossReferenceUploadInput;
};


export type MutationUploadContractItemNoCrossesArgs = {
  input: UploadContractItemNoCrossesInput;
};


export type MutationProcessSmartRuleUploadArgs = {
  input: ProcessSmartRuleUploadInput;
};


export type MutationQueueAllContracMatchingSpendsUpdateJobArgs = {
  contractIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isProspect?: Scalars['Boolean']['input'];
  skipGenerating?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationQueueAllContractsMatchingUpdateJobArgs = {
  contractIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  withLinkage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationQueueCalculateBasketMetricsJobArgs = {
  basketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyNew?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationQueueCreateSmartBasketArgs = {
  input: CreateSmartBasketInput;
  pagination?: InputMaybe<Pagination>;
};


export type MutationQueueCrossReferenceOfferItemsArgs = {
  input: CrossReferenceOfferItemInput;
};


export type MutationQueueJobArgs = {
  input: IdArgs;
};


export type MutationQueuePlayBookBasketsSyncArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationQueueUpdatePartsLinkageJobArgs = {
  processAll?: InputMaybe<Scalars['Boolean']['input']>;
  processContractMatchingNext: Scalars['Boolean']['input'];
};


export type MutationQuickCreateNewOrganizationsArgs = {
  input: Array<QuickCreateOrganizationInput>;
};


export type MutationRebuildQuicksightPermissionsArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRedeemOpportunityArgs = {
  input: RedeemOpportunityInput;
};


export type MutationRefreshOfferScenarioTiersAndRebatesCalulationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshOpportunityEnrichmentArgs = {
  id: Scalars['String']['input'];
  updatePrice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRefreshSmartBasketArgs = {
  id: Scalars['String']['input'];
};


export type MutationRejectOpportunityArgs = {
  input: IdArgs;
};


export type MutationRemoveBasketProductsArgs = {
  input: RemoveBasketProductsInput;
};


export type MutationRemoveBasketSmartRulesArgs = {
  input: RemoveBasketSmartRulesInput;
};


export type MutationRemoveContractAttachmentArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveContractMemberTierHistoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveContractPartTierHistoriesArgs = {
  contractId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveContractPartsArgs = {
  input: RemoveContractPartsInput;
};


export type MutationRemoveContractTierArgs = {
  input: RemoveContractTierInput;
};


export type MutationRemoveContractRebateGroupArgs = {
  input: RemoveContractRebateGroupInput;
};


export type MutationRemoveContractTierRebateArgs = {
  input: RemoveContractTierRebateInput;
};


export type MutationUpsertContractRebateGroupArgs = {
  input: RebateGroupInput;
};


export type MutationRemoveDashboardsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveInitiativeActivityArgs = {
  input: InitiativeActivityInput;
};


export type MutationRemoveMessageTemplateArgs = {
  input: IdArgs;
};


export type MutationRemoveNetworkMemberArgs = {
  input: RemoveNetworkMemberInput;
};


export type MutationRemoveOfferFavoriteArgs = {
  input: OfferFavoriteInput;
};


export type MutationRemoveOfferRebateArgs = {
  input: RemoveOfferTierRebateInput;
};


export type MutationRemoveOpportunityItemsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRemoveRebateEvidenceDocArgs = {
  input: RemoveRebateEvidenceDocInput;
};


export type MutationRemoveSourcingPlanBasketArgs = {
  input: RemoveSourcingPlanBasketInput;
};


export type MutationRemoveSourcingPlanBasketStakeholderArgs = {
  input: RemoveSourcingPlanBasketStakeholderInput;
};


export type MutationRemoveSourcingPlanStakeholderArgs = {
  input: RemoveSourcingPlanStakeholderInput;
};


export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationRemoveUserFromOrganizationArgs = {
  input: RemoveOrganizationInput;
};


export type MutationRenameCrossReferenceListArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationReopenSubmittedOfferArgs = {
  input: ReopenOfferInput;
};


export type MutationRepopulateCatalogPartsIsImplantableArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationRepopulateStanDataForCatalogPartsArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationRequestCategoryConsultArgs = {
  input: RequestCategoryConsultInput;
};


export type MutationResendInviteArgs = {
  input: ResendInviteInput;
};


export type MutationResendNetworkInvitationArgs = {
  userNetworkId: Scalars['String']['input'];
};


export type MutationResendUserInvitationArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetOfferScenarioArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkContractItemsNoCrossArgs = {
  input: MarkContractItemsNoCrossInput;
};


export type MutationReverseContractItemNoCrossArgs = {
  tsId: Scalars['String']['input'];
};


export type MutationRestoreCrossReferencePairsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRetryOpportunityArgs = {
  input: RetryOpportunityInput;
};


export type MutationSaveCrossReferenceMappingsArgs = {
  input: SaveCrossReferenceMaps;
};


export type MutationSaveDraftOpportunityArgs = {
  input: CreateOpportunityInput;
};


export type MutationSaveMessageTemplateArgs = {
  input: CreateMessageTemplateInput;
};


export type MutationSaveSearchArgs = {
  input: CreateSavedSearchInput;
};


export type MutationSearchByUploadedSearchIdArgs = {
  input: SearchByUploadedSearchIdInput;
  pagination?: InputMaybe<Pagination>;
};


export type MutationSendBasketStakeholdersSurveyArgs = {
  input: SendBasketStakeholdersSurveyInput;
};


export type MutationSendProjectApertureInvitationArgs = {
  input: ProjectApertureInvitationInput;
};


export type MutationSendSourcingPlanStakeholdersSurveyArgs = {
  input: SendSourcingPlanStakeholdersSurveyInput;
};


export type MutationSetContractCrossReferenceListsArgs = {
  input: SetContractCrossReferenceListsInput;
};


export type MutationSetCustomerMainContactArgs = {
  input: CustomerMainContactInput;
};


export type MutationSetNormalizedManufacturerArgs = {
  input: SetNormalizedManufacturerInput;
};


export type MutationSignUpArgs = {
  input: CreateUserInput;
};


export type MutationSnoozeSourcingPlanBasketArgs = {
  input: SnoozeSourcingPlanInput;
};


export type MutationStartSourcingPlanArgs = {
  input: StartSourcingPlanInput;
};


export type MutationSubmitContractArgs = {
  input: SubmitContractInput;
};


export type MutationSubmitOpportunityArgs = {
  input: IdArgs;
};


export type MutationSyncContractEnrichmentsArgs = {
  input: SyncContractEnrichmentsInput;
};


export type MutationSyncCreateCustomerArgs = {
  input: SyncCreateCustomerInput;
};


export type MutationSyncCreateOrganizationArgs = {
  input: SyncCreateOrganizationInput;
};


export type MutationSyncCurvoNormalizationsArgs = {
  input: Array<SyncCurvoNormalization>;
};


export type MutationSyncUpdateCustomerArgs = {
  input: SyncUpdateCustomerInput;
};


export type MutationSyncUpdateOrganizationArgs = {
  input: SyncUpdateOrganizationInput;
};


export type MutationSyncUserQuickSightGroupsArgs = {
  createNonExistent?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationSyncUsersToPlaneArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTierArchivedToggleArgs = {
  input: IdArgs;
};


export type MutationToggleRebateCardStarArgs = {
  input: RebateCardPreferenceInput;
  note?: InputMaybe<Scalars['String']['input']>;
  starred: Scalars['Boolean']['input'];
};


export type MutationToggleRebateCardVisibilityArgs = {
  hidden: Scalars['Boolean']['input'];
  input: RebateCardPreferenceInput;
  note?: InputMaybe<Scalars['String']['input']>;
  snoozeDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationToggleUserActivationArgs = {
  input: ToggleUserActivationInput;
};


export type MutationUnarchiveBasketArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnarchiveOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAutoBasketsArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationUpdateBasketVisibilityArgs = {
  input: UpdateBasketVisibilityInput;
};


export type MutationUpdateCatalogItemArgs = {
  input: UpdateCatalogItemInput;
};


export type MutationUpdateCatalogPartsArgs = {
  input: Array<UpdateCatalogPartInput>;
};


export type MutationUpdateCatalogPartsWithMasterTsIdArgs = {
  input: Array<UpdateCatalogPartWithMasterTsIdInput>;
};


export type MutationUpdateCloakArgs = {
  input: UpdateCloakInput;
};


export type MutationUpdateCommitmentArgs = {
  input: UpdateScenarioCommitmentInput;
};


export type MutationUpdateContractAttachmentArgs = {
  input: UpdateContractAttachmentInput;
};


export type MutationUpdateContractBasketsArgs = {
  input: UpdateContractBasketsInput;
};


export type MutationUpdateContractMemberTierHistoriesArgs = {
  input: Array<UpdateHistoriesInput>;
};


export type MutationUpdateContractMembersArgs = {
  input: UpdateContractMembersInput;
};


export type MutationUpdateContractPartsArgs = {
  input: UpdateContractPartsInput;
};


export type MutationUpdateContractWithCrossReferenceListArgs = {
  crossReferenceListId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateContractsMatchingArgs = {
  contractIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateCrossReferenceListArgs = {
  input: UpdateCrossReferenceListInput;
};


export type MutationUpdateCrossReferencePairArgs = {
  input: UpdateCrossReferencePairInput;
};


export type MutationUpdateCustomFieldArgs = {
  id: Scalars['String']['input'];
  input: CustomFieldInput;
};


export type MutationUpdateCustomFieldsOrderArgs = {
  input: Array<CustomFieldUpdateOrderInput>;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateDashboardArgs = {
  input: UpdateDashboardInput;
};


export type MutationUpdateDraftContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdateDraftOpportunityArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateMessageTemplateArgs = {
  input: UpdateMessageTemplateInput;
};


export type MutationUpdateNetworkMemberRoleArgs = {
  input: UpdateNetworkMemberRoleInput;
};


export type MutationUpdateOfferArgs = {
  input: UpdateOfferInput;
};


export type MutationUpdateOfferCustomFieldsArgs = {
  input: UpdateOfferCustomFieldsInput;
};


export type MutationUpdateOfferTierArgs = {
  input: UpdateOfferTierInput;
};


export type MutationUpdateOpportunityAttachmentArgs = {
  input: SingleOpportunityAttachmentInput;
};


export type MutationUpdateOpportunityItemArgs = {
  input: UpdateOpportunityItemInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateRebateCardNoteArgs = {
  input: RebateCardPreferenceInput;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateScenarioItemByOfferArgs = {
  input: UpdateScenarioByOfferInput;
};


export type MutationUpdateSmartBasketConfigArgs = {
  input: UpdateBasketSmartRulesConfigInput;
};


export type MutationUpdateSourcingPlanArgs = {
  input: UpdateSourcingPlanInput;
};


export type MutationUpdateSourcingPlanBasketArgs = {
  input: UpdateSourcingPlanBasketInput;
};


export type MutationUpdateSourcingPlanBasketStakeholderArgs = {
  input: UpdateSourcingPlanBasketStakeholderInput;
};


export type MutationUpdateSourcingPlanStakeholderArgs = {
  input: UpdateSourcingPlanStakeholderInput;
};


export type MutationUpdateSupplierOpportunityArgs = {
  input: UpdateSupplierOpportunityInput;
};


export type MutationUpdateSupplierOpportunityAclArgs = {
  input: UpdateSupplierOpportunityAclInput;
};


export type MutationUpdateSupplierOpportunityAttachmentsArgs = {
  input: UpdateSupplierOpportunityAttachmentsInput;
};


export type MutationUpdateTierCatalogPartPriceArgs = {
  input: UpdateTierCatalogPartPriceInput;
};


export type MutationUpdateTierRulesArgs = {
  input: UpdateTierRuleInput;
};


export type MutationUpdateTiersArgs = {
  input: Array<UpdateTierInput>;
};


export type MutationUpdateUploadBasketBenchmarksArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


export type MutationUpdateVendorUserArgs = {
  input: UpdateVendorUserInput;
};


export type MutationUploadBasketFileArgs = {
  input: UploadBasketInput;
};


export type MutationUploadBulkUpdateOfferItemsArgs = {
  input: BulkUpdateOfferItemsUploadInput;
};


export type MutationUploadCatalogArgs = {
  input: UploadCatalogInput;
};


export type MutationUploadContractFileArgs = {
  input: UploadContractInput;
};


export type MutationUploadContractMembersFileArgs = {
  input: UploadBasketInput;
};


export type MutationUploadContractXrefFileArgs = {
  input: UploadContractInput;
};


export type MutationUploadCrossReferenceArgs = {
  input: UploadCrossRefInput;
};


export type MutationUploadOpportunityArgs = {
  input: OfferUploadInput;
};


export type MutationUploadSearchFileArgs = {
  input: UploadSearchFileInput;
};


export type MutationUploadSmartRuleFileArgs = {
  input: UploadBasketInput;
};


export type MutationUpsertContractPartTierHistoriesArgs = {
  contractId: Scalars['String']['input'];
  input: Array<UpdatePartTierHistoryInput>;
};


export type MutationUpsertMarkupRulesArgs = {
  input: Array<UpsertMarkupRuleInput>;
};


export type MutationUpsertOfferRebateArgs = {
  input: TierRebateInput;
};


export type MutationUpsertRebatePeriodActualArgs = {
  input: UpsertRebatePeriodActualInput;
};


export type MutationVerifyAccountArgs = {
  input: VerifyAccountInput;
};


export type MutationViewOfferArgs = {
  id: Scalars['String']['input'];
};

export type MyInitiativeNetworkExtra = {
  __typename?: 'MyInitiativeNetworkExtra';
  isAdmin: Scalars['Boolean']['output'];
  memberCount: Scalars['Int']['output'];
};

export type Network = {
  __typename?: 'Network';
  createdAt: Scalars['Date']['output'];
  extra: MyInitiativeNetworkExtra;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  members: Array<UserNetwork>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type NormalizedManufacturerList = {
  __typename?: 'NormalizedManufacturerList';
  data: Array<Scalars['String']['output']>;
};

export type NormalizedManufacturersSearchResult = {
  __typename?: 'NormalizedManufacturersSearchResult';
  data: Array<Scalars['String']['output']>;
};

export type NormalizedSupplier = {
  __typename?: 'NormalizedSupplier';
  inputSupplier: Scalars['String']['output'];
  normalizedCurvo?: Maybe<Scalars['String']['output']>;
  retry?: Maybe<Array<NormalizedSupplierRetry>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NormalizedSupplierRetry = {
  __typename?: 'NormalizedSupplierRetry';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NormalizedSupplierSearchItem = {
  __typename?: 'NormalizedSupplierSearchItem';
  normalizedCurvo: Scalars['String']['output'];
};

export type NormalizedSupplierSearchResult = {
  __typename?: 'NormalizedSupplierSearchResult';
  data: Array<NormalizedSupplierSearchItem>;
  total: Scalars['Int']['output'];
};

export type NormalizedSuppliersForUploadedFileColumn = {
  __typename?: 'NormalizedSuppliersForUploadedFileColumn';
  normalizedSuppliers: Array<NormalizedSupplier>;
  rawData: Array<Scalars['String']['output']>;
};

export type Offer = {
  __typename?: 'Offer';
  additionalInfo?: Maybe<AdditionalInfo>;
  attachment?: Maybe<OpportunityAttachment>;
  attachments: Array<OpportunityAttachment>;
  /** Get offer baskets */
  baskets?: Maybe<Array<Basket>>;
  createdAt: Scalars['Date']['output'];
  crossRefListId?: Maybe<Scalars['String']['output']>;
  crossReferenceList?: Maybe<CrossReferenceList>;
  crossReferenceListId?: Maybe<CrossReferenceList>;
  crossStats: CrossStats;
  customer: Customer;
  customerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Scalars['JSON']['output']>;
  facilities?: Maybe<Array<OfferItemFacilityInfo>>;
  facilityIds?: Maybe<Array<Scalars['Int']['output']>>;
  facilityInfo?: Maybe<FacilityInfo>;
  gmdns: Array<Scalars['String']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  goalThresholdMax?: Maybe<Scalars['Float']['output']>;
  goalThresholdMin?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invitingVendors?: Maybe<Array<OfferInvitingVendor>>;
  isArchivedOpportunity?: Maybe<Scalars['Boolean']['output']>;
  isCrossRequest?: Maybe<Scalars['Boolean']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  keyContact?: Maybe<User>;
  keyContactId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<MetricsType>;
  name?: Maybe<Scalars['String']['output']>;
  numberSKU?: Maybe<Scalars['Int']['output']>;
  offerBasketInsights?: Maybe<Array<OfferBasketInsightsResult>>;
  /** This resolve field is only meant to be called when the opportunity is being created, to get real time insights from the baskets */
  offerCreationInsights?: Maybe<BasketInsights>;
  /** Get the offer insights, based on the stored data in the offer */
  offerInsights: OfferInsights;
  offerItems: OfferItemResult;
  offerPricingItem: OfferPricingItem;
  offerPricingItems: OfferPricingItemResult;
  opportunityEmailSubjectTemplate?: Maybe<Scalars['String']['output']>;
  opportunityEmailTemplate?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Offer>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentStatus?: Maybe<OppotunityStatusEnum>;
  rebates: Array<TierRebate>;
  requestNumber?: Maybe<Scalars['String']['output']>;
  scenarios: Array<OfferScenario>;
  secretCode?: Maybe<Scalars['String']['output']>;
  sharedUsers: Array<SharedUserInfo>;
  skipZeroQuantityItems: Scalars['Boolean']['output'];
  spendDateFrom?: Maybe<Scalars['String']['output']>;
  spendDateRange?: Maybe<BasketSpendDateRanges>;
  spendDateTo?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status: OfferStatusEnum;
  tierSummary?: Maybe<Array<TierSummary>>;
  tiers?: Maybe<Array<Tier>>;
  timeline?: Maybe<OfferTimeline>;
  totalBasket?: Maybe<Scalars['Int']['output']>;
  totalOffer?: Maybe<Scalars['Int']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  totalVendor?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  vendorResponse?: Maybe<VendorResponsesEnum>;
};


export type OfferAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type OfferOfferCreationInsightsArgs = {
  basketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  spendDateRange?: InputMaybe<SpendDateRangeInput>;
};


export type OfferOfferInsightsArgs = {
  basketIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type OfferOfferItemsArgs = {
  crossed?: InputMaybe<CrossedStatus>;
  gmdn?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  itemCrossStatuses?: InputMaybe<Array<OfferItemCrossStatus>>;
  linked?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  offeredManufacturer?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  pricing?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<OfferItemsSortInput>>;
  submittedManufacturer?: InputMaybe<Scalars['String']['input']>;
};


export type OfferOfferPricingItemArgs = {
  id: Scalars['String']['input'];
};


export type OfferOfferPricingItemsArgs = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<Pagination>;
  priceFilter?: InputMaybe<TierPriceFilterInput>;
  quantityFilter?: InputMaybe<OfferPricingItemQuantityFilterInput>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<CatalogPartsSortInput>>;
  utilization?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferBasketInsightsResult = {
  __typename?: 'OfferBasketInsightsResult';
  offer: Offer;
  tiers: Array<OfferBasketInsightsResultTier>;
};

export type OfferBasketInsightsResultBasket = {
  __typename?: 'OfferBasketInsightsResultBasket';
  basket: Basket;
  coveredItems?: Maybe<Scalars['Int']['output']>;
  coveredPercentage?: Maybe<Scalars['Float']['output']>;
  incumbentTotalProjected?: Maybe<Scalars['Float']['output']>;
  offeredPriceScore?: Maybe<Scalars['Float']['output']>;
  offeredTotalProjected?: Maybe<Scalars['Float']['output']>;
  savingsPercentage?: Maybe<Scalars['Float']['output']>;
  savingsTotal?: Maybe<Scalars['Float']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type OfferBasketInsightsResultTier = {
  __typename?: 'OfferBasketInsightsResultTier';
  baskets: Array<OfferBasketInsightsResultBasket>;
  tier: Tier;
};

export type OfferBasketItemsCount = {
  __typename?: 'OfferBasketItemsCount';
  basketId: Scalars['String']['output'];
  itemsCount: Scalars['Float']['output'];
};

export type OfferCodeResult = {
  __typename?: 'OfferCodeResult';
  customer?: Maybe<CustomerView>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OfferCrossStats = {
  __typename?: 'OfferCrossStats';
  matchableTotal: Scalars['Float']['output'];
};

export type OfferFavorite = {
  __typename?: 'OfferFavorite';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type OfferFavoriteInput = {
  offerId: Scalars['String']['input'];
};

export type OfferHospitalSort = {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<OfferHospitalSortField>;
};

export enum OfferHospitalSortField {
  Name = 'name'
}

export type OfferInsights = {
  __typename?: 'OfferInsights';
  basketItemsCount: Array<OfferBasketItemsCount>;
  normalizedVendors: Array<Scalars['String']['output']>;
  numItems: Scalars['Int']['output'];
  projectedIqo25: Scalars['Float']['output'];
  projectedIqo50: Scalars['Float']['output'];
  projectedIqo75: Scalars['Float']['output'];
  projectedIqo90: Scalars['Float']['output'];
  projectedSpend: Scalars['Float']['output'];
  statsByVendor: Array<OfferItemStatsByVendor>;
};

export type OfferInvitingVendor = {
  __typename?: 'OfferInvitingVendor';
  createdAt?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<Customer>;
  customerId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinedVendorCustomer?: Maybe<Customer>;
  joinedVendorCustomerId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  offerId: Scalars['String']['output'];
  offers?: Maybe<Array<Offer>>;
  officer?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OfferItem = {
  __typename?: 'OfferItem';
  averagePrice?: Maybe<Scalars['Float']['output']>;
  basket?: Maybe<Basket>;
  comment?: Maybe<OfferItemComment>;
  createdAt: Scalars['Date']['output'];
  crossReferenceSuggestions?: Maybe<Array<CatalogPart>>;
  crossStatus?: Maybe<Scalars['Boolean']['output']>;
  curvo25?: Maybe<Scalars['Float']['output']>;
  curvo50?: Maybe<Scalars['Float']['output']>;
  curvo75?: Maybe<Scalars['Float']['output']>;
  curvo90?: Maybe<Scalars['Float']['output']>;
  customer?: Maybe<Customer>;
  customerId: Scalars['String']['output'];
  esId: Scalars['String']['output'];
  facilityId?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  /** A group ID for items with the same product */
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  item?: Maybe<CatalogPart>;
  itemConversion?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use itemCrossStatus instead */
  itemCrossStatus?: Maybe<OfferItemCrossStatus>;
  itemEnrichment?: Maybe<OfferItemEnrichment>;
  itemTsId: Scalars['String']['output'];
  itemUoM?: Maybe<Scalars['String']['output']>;
  markupAdjustedPrice?: Maybe<Scalars['Float']['output']>;
  masterCatalogData?: Maybe<MasterCatalogData>;
  matchedCrossRefVendorItems?: Maybe<Scalars['Int']['output']>;
  noCross?: Maybe<Scalars['Boolean']['output']>;
  noCrossComment?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<Offer>;
  offerId: Scalars['String']['output'];
  offerItem?: Maybe<CatalogPart>;
  offerTsId?: Maybe<Scalars['String']['output']>;
  percentiles?: Maybe<Array<Scalars['Float']['output']>>;
  priceTiers?: Maybe<Array<CatalogPartTier>>;
  pricingTarget?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  secondOfferItem?: Maybe<CatalogPart>;
  secondOfferTsId?: Maybe<Scalars['String']['output']>;
  submittedItem?: Maybe<CatalogPart>;
  submittedTsId: Scalars['String']['output'];
  suggestion?: Maybe<OfferItemSuggestion>;
  unitprice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum OfferItemComment {
  Instrument = 'Instrument',
  InvalidPartNumber = 'InvalidPartNumber',
  NoComparable = 'NoComparable',
  Other = 'Other',
  OutOfScope = 'OutOfScope'
}

export enum OfferItemCrossStatus {
  Crossed = 'Crossed',
  Instrument = 'Instrument',
  InvalidPartNumber = 'InvalidPartNumber',
  NoComparable = 'NoComparable',
  Other = 'Other',
  OutOfScope = 'OutOfScope',
  Uncrossed = 'Uncrossed'
}

export type OfferItemEnrichment = {
  __typename?: 'OfferItemEnrichment';
  description?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export enum OfferItemExportsFieldEnum {
  AveragePrice = 'averagePrice',
  Comment = 'comment',
  Conversion = 'conversion',
  CrossAveragePrice = 'crossAveragePrice',
  CrossConversion = 'crossConversion',
  CrossCurvo25 = 'crossCurvo25',
  CrossCurvo50 = 'crossCurvo50',
  CrossCurvo75 = 'crossCurvo75',
  CrossCurvo90 = 'crossCurvo90',
  CrossDescription = 'crossDescription',
  CrossGic = 'crossGic',
  CrossGmdn = 'crossGmdn',
  CrossGtin = 'crossGtin',
  CrossManufacturer = 'crossManufacturer',
  CrossManufacturerItem = 'crossManufacturerItem',
  CrossProductCategory = 'crossProductCategory',
  CrossProductSubCategory = 'crossProductSubCategory',
  CrossTypeOne = 'crossTypeOne',
  CrossTypeTwo = 'crossTypeTwo',
  CrossUom = 'crossUom',
  Curvo25 = 'curvo25',
  Curvo50 = 'curvo50',
  Curvo75 = 'curvo75',
  Curvo90 = 'curvo90',
  Description = 'description',
  EnrichedDescription = 'enrichedDescription',
  EnrichedManufacturer = 'enrichedManufacturer',
  EnrichedManufacturerItem = 'enrichedManufacturerItem',
  EnrichedVendor = 'enrichedVendor',
  EnrichedVendorItem = 'enrichedVendorItem',
  Gic = 'gic',
  Gmdn = 'gmdn',
  Gtin = 'gtin',
  Id = 'id',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  MatchType = 'matchType',
  Quantity = 'quantity',
  RebateAmount = 'rebateAmount',
  RebatesApplied = 'rebatesApplied',
  TierPricing = 'tierPricing',
  TypeOne = 'typeOne',
  TypeTwo = 'typeTwo',
  Uom = 'uom',
  Vendor = 'vendor',
  VendorItem = 'vendorItem'
}

export type OfferItemFacilityInfo = {
  __typename?: 'OfferItemFacilityInfo';
  facilityId: Scalars['Float']['output'];
  facilityName?: Maybe<Scalars['String']['output']>;
  spendDateFrom?: Maybe<Scalars['Date']['output']>;
  spendDateTo?: Maybe<Scalars['Date']['output']>;
};

export type OfferItemResult = {
  __typename?: 'OfferItemResult';
  crossStats?: Maybe<CrossStats>;
  hits: Array<ExtendedOfferItem>;
  totalHits: Scalars['Int']['output'];
};

export type OfferItemStatsByVendor = {
  __typename?: 'OfferItemStatsByVendor';
  totalSpend?: Maybe<Scalars['Float']['output']>;
  vendor: Scalars['String']['output'];
};

export type OfferItemSuggestion = {
  __typename?: 'OfferItemSuggestion';
  isMine: Scalars['Boolean']['output'];
  item: CatalogPartSuggestionItem;
};

export enum OfferItemsSortFieldEnum {
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  OfferManufacturer = 'offerManufacturer',
  OfferManufacturerItem = 'offerManufacturerItem',
  SubmittedManufacturer = 'submittedManufacturer',
  SubmittedManufacturerItem = 'submittedManufacturerItem'
}

export type OfferItemsSortInput = {
  direction?: InputMaybe<OrderDirection>;
  field: OfferItemsSortFieldEnum;
};

export type OfferPricingItem = {
  __typename?: 'OfferPricingItem';
  catalogPart: CatalogPart;
  catalogPartPack: Array<CatalogPartPack>;
  catalogPartTiers: Array<CatalogPartTier>;
  id: Scalars['String']['output'];
  offerItem: Array<OfferItem>;
  totalQuantity: Scalars['Int']['output'];
};

export type OfferPricingItemQuantityFilterInput = {
  operator: TierFilterOperatorEnum;
  quantityFirst?: InputMaybe<Scalars['Float']['input']>;
  quantitySecond?: InputMaybe<Scalars['Float']['input']>;
};

export type OfferPricingItemResult = {
  __typename?: 'OfferPricingItemResult';
  hits: Array<OfferPricingItem>;
  totalHits: Scalars['Int']['output'];
};

export enum OfferPricingTargetType {
  Benchmark = 'benchmark',
  Percentage = 'percentage',
  Value = 'value'
}

export type OfferRebateStats = {
  __typename?: 'OfferRebateStats';
  closeness: Scalars['Float']['output'];
  facilityId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  opportunityId: Scalars['String']['output'];
  rebate?: Maybe<TierRebate>;
  rebateId: Scalars['String']['output'];
  scenarioId?: Maybe<Scalars['String']['output']>;
  tierId: Scalars['String']['output'];
  totalRebate?: Maybe<Scalars['Float']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type OfferResult = {
  __typename?: 'OfferResult';
  hits: Array<Offer>;
  totalHits: Scalars['Int']['output'];
};

export type OfferScenario = {
  __typename?: 'OfferScenario';
  awardedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  enableCommitment: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isAwarded: Scalars['Boolean']['output'];
  isInvalid?: Maybe<Scalars['Boolean']['output']>;
  items: OfferScenarioItemResult;
  name: Scalars['String']['output'];
  offerRebateStats: Array<OfferRebateStats>;
  offers?: Maybe<Array<Offer>>;
  opportunity?: Maybe<Offer>;
  opportunityId: Scalars['String']['output'];
  priorities: Array<OfferScenarioPriorityUnion>;
  stats: ScenarioStats;
  tiers?: Maybe<Array<Tier>>;
  updatedAt: Scalars['Date']['output'];
};


export type OfferScenarioItemsArgs = {
  input?: InputMaybe<OfferScenarioItemsFilterInput>;
  pagination: Pagination;
};

export type OfferScenarioItem = {
  __typename?: 'OfferScenarioItem';
  createdAt: Scalars['Date']['output'];
  excluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  offerItem?: Maybe<OfferItem>;
  offerItemId?: Maybe<Scalars['String']['output']>;
  opportunityItem: OfferItem;
  opportunityItemId: Scalars['String']['output'];
  scenario?: Maybe<OfferScenario>;
  scenarioId: Scalars['String']['output'];
  tier?: Maybe<Tier>;
  tierId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type OfferScenarioItemResult = {
  __typename?: 'OfferScenarioItemResult';
  hits: Array<OfferScenarioItem>;
  totalHits: Scalars['Int']['output'];
};

export type OfferScenarioItemsFilterInput = {
  itemType?: Scalars['String']['input'];
};

export type OfferScenarioPriority = IOfferScenarioPriority & {
  __typename?: 'OfferScenarioPriority';
  basketPriority?: Maybe<BasketPriority>;
  isDisabled: Scalars['Boolean']['output'];
  isStrict: Scalars['Boolean']['output'];
  type: OfferScenarioPriorityType;
  vendorPriority?: Maybe<VendorPriority>;
};

export type OfferScenarioPriorityBasketSaving = IOfferScenarioPriority & {
  __typename?: 'OfferScenarioPriorityBasketSaving';
  /** Specify the priority of Basket Saving */
  basketPriority: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isStrict: Scalars['Boolean']['output'];
  type: OfferScenarioPriorityType;
};

export type OfferScenarioPriorityGreatestSaving = IOfferScenarioPriority & {
  __typename?: 'OfferScenarioPriorityGreatestSaving';
  isDisabled: Scalars['Boolean']['output'];
  isStrict: Scalars['Boolean']['output'];
  type: OfferScenarioPriorityType;
};

export type OfferScenarioPriorityInput = {
  /** Specify the priority of Basket Saving, only for BsketSaving */
  basketPriority?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: Scalars['Boolean']['input'];
  isStrict?: Scalars['Boolean']['input'];
  type: OfferScenarioPriorityType;
  /** Specify the priority of Vendors, only for VendorPriority */
  vendorPriority?: InputMaybe<Scalars['String']['input']>;
};

export enum OfferScenarioPriorityType {
  BasketSaving = 'BasketSaving',
  FewestVendorPossible = 'FewestVendorPossible',
  GreatestSaving = 'GreatestSaving',
  SwitchNoProduct = 'SwitchNoProduct',
  Vendor = 'Vendor'
}

export type OfferScenarioPriorityUnion = OfferScenarioPriority | OfferScenarioPriorityBasketSaving | OfferScenarioPriorityGreatestSaving | OfferScenarioPriorityVendor;

export type OfferScenarioPriorityVendor = IOfferScenarioPriority & {
  __typename?: 'OfferScenarioPriorityVendor';
  isDisabled: Scalars['Boolean']['output'];
  isStrict: Scalars['Boolean']['output'];
  type: OfferScenarioPriorityType;
  /** Specify the priority of Vendors */
  vendorPriority: Scalars['String']['output'];
};

export type OfferStats = {
  __typename?: 'OfferStats';
  opportunityGoal?: Maybe<Scalars['Float']['output']>;
  /** Opportunity's Total Spend from last purchase */
  opportunityTotalSpend?: Maybe<Scalars['Float']['output']>;
  tiers: Array<OfferTierSummary>;
};

export enum OfferStatusEnum {
  Archived = 'archived',
  Finished = 'finished',
  InProgress = 'inProgress',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected'
}

export type OfferTierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OfferTierRankItem = {
  __typename?: 'OfferTierRankItem';
  rank: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OfferTierSummary = {
  __typename?: 'OfferTierSummary';
  /** Rank among tiers which have coverage from 50% to 75% */
  coverage50pctRank?: Maybe<OfferTierRankItem>;
  /** Rank among tiers which have coverage from 75% to 90% */
  coverage75pctRank?: Maybe<OfferTierRankItem>;
  /** Rank among tiers which have more than 90% coverage */
  coverage90pctRank?: Maybe<OfferTierRankItem>;
  /** Rank by coverage percentage */
  coverageRank?: Maybe<OfferTierRankItem>;
  itemCoverage: Scalars['Float']['output'];
  /** Rank by pricing */
  pricingRank?: Maybe<OfferTierRankItem>;
  tier: Tier;
  totalIncumbentSpend: Scalars['Float']['output'];
  totalProjectedSpend: Scalars['Float']['output'];
};

export type OfferTimeline = {
  __typename?: 'OfferTimeline';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  offerId: Scalars['String']['output'];
  status: OfferTimelineStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum OfferTimelineStatus {
  Accepted = 'Accepted',
  Invited = 'Invited',
  Rejected = 'Rejected',
  Responded = 'Responded',
  Responding = 'Responding',
  Viewed = 'Viewed'
}

export type OfferUploadInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  fileName: Scalars['String']['input'];
  /** The header row index in Excel file, default value is the first row, starting at 1 */
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  keyContact?: InputMaybe<OfferUploadKeyContactInput>;
  mapping: UploadOfferMapping;
  name: Scalars['String']['input'];
  provider?: InputMaybe<OfferUploadProviderInput>;
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type OfferUploadKeyContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OfferUploadProviderInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type OffersInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  invitationStatus?: InputMaybe<InvitationStatusEnum>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isMissedDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  opportunityOnly?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityStatus?: InputMaybe<OppotunityStatusEnum>;
  owner?: InputMaybe<OpportunityOwnerEnum>;
  requestNumber?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferStatusEnum>;
};

export type OpportunityAttachment = {
  __typename?: 'OpportunityAttachment';
  base64: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Contains list of `userId`s, which have downloaded this document */
  downloadedBy?: Maybe<Array<Scalars['String']['output']>>;
  hidden: Scalars['Boolean']['output'];
  /** Contains list of `userId`, which this document will be hidden from documents grid */
  hiddenFor?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  /** For vendor specific attachments, if null then it is available for all vendors */
  invitingVendorIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Indicate that this user has never downloaded this file before */
  isNew: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** For Offer specific attachments */
  offerId?: Maybe<Scalars['String']['output']>;
  opportunityId: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  uploadedBy: AttachmentUploadedFrom;
  /** Uploaded by vendor */
  vendor?: Maybe<Customer>;
  /** Uploaded by vendor's customerId, if null then this attachment is uploaded by Hospital */
  vendorCustomerId?: Maybe<Scalars['String']['output']>;
};

export type OpportunityAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachment ID, null if you want to create new Attachment */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Inviting Vendor Ids, use this for Vendors specific attachments */
  invitingVendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};

export type OpportunityCustomizationInfoInput = {
  key: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type OpportunityCustomizationInfoResult = {
  __typename?: 'OpportunityCustomizationInfoResult';
  data: Scalars['String']['output'];
};

export type OpportunityCustomizationInput = {
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type OpportunityCustomizationResult = {
  __typename?: 'OpportunityCustomizationResult';
  taskId: Scalars['String']['output'];
};

export type OpportunityCustomizationSaveInput = {
  data: Scalars['String']['input'];
  key: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type OpportunityEmailTemplatePreviewInput = {
  isSubject?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type OpportunityInviteBaseInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officer?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityKeyContact = {
  __typename?: 'OpportunityKeyContact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum OpportunityOwnerEnum {
  Mine = 'Mine',
  Shared = 'Shared'
}

export type OpportunityProvider = {
  __typename?: 'OpportunityProvider';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum OpportunityStatBenchmark {
  Curvo25 = 'Curvo25',
  Curvo50 = 'Curvo50',
  Curvo75 = 'Curvo75',
  Curvo90 = 'Curvo90'
}

export type OpportunityStatValue = {
  __typename?: 'OpportunityStatValue';
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type OpportunityStats = {
  __typename?: 'OpportunityStats';
  benchmarkedQtyPerManufacturer: Array<OpportunityStatValue>;
  gicMarketShare: Array<OpportunityStatValue>;
  gmdnMarketShare: Array<OpportunityStatValue>;
  totalBenchmarkedQty: Scalars['Float']['output'];
  totalQtyPerManufacturer: Array<OpportunityStatValue>;
  vendorMarketShare: Array<OpportunityStatValue>;
};

export type OpportunityStatsQueryInput = {
  benchMarkType: OpportunityStatBenchmark;
  opportunityId: Scalars['String']['input'];
};

export enum OpportunitySupplierStatusEnum {
  Archived = 'archived',
  Completed = 'completed',
  Declined = 'declined',
  InProgress = 'inProgress',
  New = 'new'
}

export enum OppotunityStatusEnum {
  Active = 'active',
  Archived = 'archived',
  Complete = 'complete',
  Draft = 'draft'
}

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Organization = {
  __typename?: 'Organization';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  allParents: Array<Organization>;
  broadJumpId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  classOfTradeId?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customers: Array<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  geoCode?: Maybe<Scalars['String']['output']>;
  gpoFacilityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDshEligible?: Maybe<Scalars['Boolean']['output']>;
  medicareId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationType?: Maybe<OrganizationType>;
  organizationTypeId?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Organization>;
  parentId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subOrganizations: Array<Organization>;
  topParent?: Maybe<Organization>;
  topPowerUsers: Array<User>;
  topUsers: Array<User>;
  totalSubOrganizations: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  users: Array<UserOrganization>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMatch = {
  __typename?: 'OrganizationMatch';
  organization: Organization;
  /** Trigram similarity, 0 (nothing shared) to 1 (same name once normalized) */
  score: Scalars['Float']['output'];
};

export enum OrganizationMatchKindEnum {
  Facility = 'Facility',
  TopParent = 'TopParent'
}

export type OrganizationNameMatch = {
  __typename?: 'OrganizationNameMatch';
  /** Best match first */
  matches: Array<OrganizationMatch>;
  /** The name as sent */
  name: Scalars['String']['output'];
};

export type OrganizationPermission = {
  isPowerUser: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PaginatedSavedSearch = {
  __typename?: 'PaginatedSavedSearch';
  data: Array<SavedSearch>;
  total: Scalars['Int']['output'];
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Part = {
  __typename?: 'Part';
  active_part_tiers?: Maybe<Array<PartTier>>;
  brjId?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  commodityId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  createdAt: Scalars['Date']['output'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gtin?: Maybe<Scalars['String']['output']>;
  gudId?: Maybe<Scalars['String']['output']>;
  isImplantable?: Maybe<Scalars['Boolean']['output']>;
  manufacturer: Scalars['String']['output'];
  materialId?: Maybe<Scalars['String']['output']>;
  mfgitem: Scalars['String']['output'];
  normalizedManufacturer: Scalars['String']['output'];
  partTiers?: Maybe<Array<PartTier>>;
  segmentationId?: Maybe<Scalars['String']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  sizeOne: Scalars['Float']['output'];
  sizeThree: Scalars['Float']['output'];
  sizeTwo: Scalars['Float']['output'];
  stanId?: Maybe<Scalars['String']['output']>;
  strippedManufacturerItem: Scalars['String']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  tsId: Scalars['String']['output'];
  typeOneId?: Maybe<Scalars['String']['output']>;
  typeOneName?: Maybe<Scalars['String']['output']>;
  typeTwoId?: Maybe<Scalars['String']['output']>;
  typeTwoName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
  venitem?: Maybe<Scalars['String']['output']>;
};

export type PartTier = {
  __typename?: 'PartTier';
  cotId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  effectiveEndDate?: Maybe<Scalars['Date']['output']>;
  effectiveStartDate?: Maybe<Scalars['Date']['output']>;
  historyId?: Maybe<Scalars['String']['output']>;
  isDshEligible?: Maybe<Scalars['Boolean']['output']>;
  part: Part;
  partsTsId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  recognizedUom?: Maybe<Scalars['String']['output']>;
  recognizedUomQuantity?: Maybe<Scalars['Int']['output']>;
  tier: Tier;
  tiersId: Scalars['ID']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['Float']['output']>;
  uomConversionSecondary?: Maybe<Scalars['Float']['output']>;
  uomSecondary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type PartTierHistory = {
  __typename?: 'PartTierHistory';
  cotId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  effectiveEndDate?: Maybe<Scalars['Date']['output']>;
  effectiveStartDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isDshEligible?: Maybe<Scalars['Boolean']['output']>;
  partTier: PartTier;
  partsTiersId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['Float']['output']>;
  uomConversionSecondary?: Maybe<Scalars['Float']['output']>;
  uomSecondary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type PartTierInput = {
  cotId?: InputMaybe<Scalars['Int']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['Date']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['Date']['input']>;
  historyId?: InputMaybe<Scalars['ID']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  partsTsId: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  tiersId: Scalars['ID']['input'];
  uom?: InputMaybe<Scalars['String']['input']>;
  uomConversion?: InputMaybe<Scalars['Int']['input']>;
  uomConversionSecondary?: InputMaybe<Scalars['Int']['input']>;
  uomSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type PinSourcingPlanInput = {
  basketId: Scalars['String']['input'];
  pin: Scalars['Boolean']['input'];
  sourcingPlanId?: InputMaybe<Scalars['String']['input']>;
};

export type PlainCrossReferenceCrossItem = {
  __typename?: 'PlainCrossReferenceCrossItem';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<CrossReferenceType>;
  materialId?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<Array<CatalogPartPack>>;
  sizeOne: Scalars['Float']['output'];
  sizeThree: Scalars['Float']['output'];
  sizeTwo: Scalars['Float']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  tsId: Scalars['String']['output'];
  typeOneName?: Maybe<Scalars['String']['output']>;
  typeTwoName?: Maybe<Scalars['String']['output']>;
};

/** Plain cross-references by cross-reference list id */
export type PlainCrossReferenceList = {
  __typename?: 'PlainCrossReferenceList';
  hits: Array<PlainCrossReferenceMapping>;
  totalHits: Scalars['Int']['output'];
};

export type PlainCrossReferenceMapping = {
  __typename?: 'PlainCrossReferenceMapping';
  crossItem?: Maybe<PlainCrossReferenceCrossItem>;
  submittedItem: PlainCrossReferenceSubmittedItem;
};

export type PlainCrossReferenceSubmittedItem = {
  __typename?: 'PlainCrossReferenceSubmittedItem';
  category?: Maybe<Scalars['String']['output']>;
  /** No-Cross type */
  comment?: Maybe<OfferItemComment>;
  crossStatus?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['Int']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  /** No-Cross comment */
  noCrossComment?: Maybe<Scalars['String']['output']>;
  sizeOne: Scalars['Float']['output'];
  sizeThree: Scalars['Float']['output'];
  sizeTwo: Scalars['Float']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  tsId: Scalars['String']['output'];
  typeOneName?: Maybe<Scalars['String']['output']>;
  typeTwoName?: Maybe<Scalars['String']['output']>;
};

export type PlaneIssue = {
  __typename?: 'PlaneIssue';
  created_at: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  project: PlaneProject;
  sequence_id: Scalars['Int']['output'];
  state: PlaneState;
};

export type PlaneIssueArgs = {
  assignees?: InputMaybe<Scalars['String']['input']>;
  expand?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  subIssue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlaneIssueReponse = {
  __typename?: 'PlaneIssueReponse';
  results: Array<PlaneIssue>;
};

export type PlaneProject = {
  __typename?: 'PlaneProject';
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PlaneState = {
  __typename?: 'PlaneState';
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PowerUserListItem = {
  __typename?: 'PowerUserListItem';
  facilityId?: Maybe<Scalars['Int']['output']>;
  isPowerUser: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationParentId?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  userRank: Scalars['Int']['output'];
};

export type PriceSpray = {
  __typename?: 'PriceSpray';
  facilityId: Scalars['Float']['output'];
  priceSpray: Array<PriceSprayData>;
};

export type PriceSprayData = {
  __typename?: 'PriceSprayData';
  totalQtyPurchase: Scalars['Float']['output'];
  unitprice: Scalars['Float']['output'];
};

export type PriceTierInput = {
  cotId?: InputMaybe<Scalars['Int']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Tier ID */
  id: Scalars['String']['input'];
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Float']['input'];
  uom: Scalars['String']['input'];
  uomConversion: Scalars['Float']['input'];
  uomConversionSecondary?: InputMaybe<Scalars['Float']['input']>;
  uomSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessBasketUploadInput = {
  basketId?: InputMaybe<Scalars['String']['input']>;
  basketName: Scalars['String']['input'];
  mappedFacilities: Scalars['String']['input'];
  mappedFields: MappedFieldsType;
  mappedManufacturers: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessContractMembersUploadInput = {
  /** Preview again into this batch, replacing its rows; omit to start a new batch */
  batchId?: InputMaybe<Scalars['ID']['input']>;
  /** Facility Name value → organizations.id | null */
  facilityMappings?: InputMaybe<Scalars['JSON']['input']>;
  mappedFields: ContractMembersMappedFields;
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
  /** Top Parent value → organizations.id | null */
  topParentMappings?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProcessContractUploadInput = {
  autoCloseExistingPrices?: InputMaybe<Scalars['Boolean']['input']>;
  contractId: Scalars['String']['input'];
  mappedFields: ContractMappedFieldsType;
  replace?: Scalars['Boolean']['input'];
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessContractXrefUploadInput = {
  contractId: Scalars['String']['input'];
  mappedFields: ContractXrefMappedFieldsType;
  name: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessSmartRuleUploadInput = {
  basketId: Scalars['String']['input'];
  mappedFields: MappedFieldsType;
  replace?: Scalars['Boolean']['input'];
  s3Key: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessedBasketResult = {
  __typename?: 'ProcessedBasketResult';
  basketId: Scalars['String']['output'];
};

export type ProductCode = {
  __typename?: 'ProductCode';
  productcode: Scalars['String']['output'];
  productcodename?: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  createdAt: Scalars['Date']['output'];
  creator: User;
  customer: Customer;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  status: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  users: Array<User>;
};

export type ProjectApertureInvitationInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  networkId?: InputMaybe<Scalars['String']['input']>;
  /** Network role */
  role?: InputMaybe<UserNetworkRoleEnum>;
};

export type PublicVendorsResult = {
  __typename?: 'PublicVendorsResult';
  hits: Array<CustomerView>;
  totalHits: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Contract items the organization logged as having no equivalent, newest first. */
  contractItemNoCrosses: ContractItemNoCrossesPage;
  /** The No cross upload template, as a base64 xlsx (#8041). */
  contractItemNoCrossUploadTemplate: Scalars['String']['output'];
  /** Contract items on the organization's contracts that no list in the contract's scope crosses. */
  contractItemsNeedingCross: ContractItemsNeedingCrossPage;
  activate: Activate;
  adminGetString: Scalars['String']['output'];
  adminSupplierOpportunities: SupplierOpportunitiesResult;
  allowedGicTypeOnes: Array<GicTypeOne>;
  allowedGicTypeTwos: Array<GicTypeTwo>;
  awardPriorities: AwardPrioritiesResult;
  basket: SmartBasket;
  /** Contracts a basket is connected to. Fetched before archiving so the user can be warned which contracts lose the basket. */
  basketConnectedContracts: Array<Contract>;
  basketInsights: BasketInsights;
  basketLastPurchaseDate: LastPurchaseDateResult;
  basketProducts: Array<BasketProduct>;
  basketStakeholderSurveyPreview: Scalars['String']['output'];
  baskets: BasketsResult;
  basketsByACL: Array<Basket>;
  basketsFacilitiesStats: Array<BasketFacilityStat>;
  /** Returns optimized data to render the baskets list page */
  basketsList: BasketsListResult;
  catalogPart: CatalogPart;
  catalogPartTierInfo: CatalogPartTier;
  catalogParts: CatalogPartResult;
  catalogSearch: CatalogPartResult;
  catalogStats: CatalogStats;
  /** Get clinical Data Relevant Studies by Gudid */
  clinicalStudies: ClinicalStudiesResult;
  contactUsers: Array<ContactUserWrapper>;
  contract: Contract;
  contractAttachmentTypes: Array<Scalars['String']['output']>;
  contractBasket: Basket;
  contractCategories: Array<Scalars['String']['output']>;
  contractHistories: ContractHistoryResult;
  contractMember: ContractMember;
  contractMemberAnalysisLastUpdatedAt?: Maybe<Scalars['Date']['output']>;
  contractMemberTierHistories: Array<ContractOrganizationHistory>;
  contractMembers: Array<ContractMember>;
  /** The Facility Name and Top Parent values of an uploaded file, with row counts */
  contractMembersUploadNames: ContractMembersUploadNames;
  /** The customer's contract members uploads being applied or waiting, the running one first */
  contractMembersUploadApplyQueue: Array<ContractMembersApplyQueueEntry>;
  /** The caller's most recent contract members apply job, to resume or show its results */
  contractMembersUploadLatestApply?: Maybe<UploadJob>;
  /** One page of a contract members bulk upload preview, rows needing review first */
  contractMembersUploadPreview: ContractMembersUploadPreview;
  contractOrganizations: Array<ContractOrganization>;
  contractPartsCount: Scalars['Int']['output'];
  contractRebateTypes: Array<Scalars['String']['output']>;
  contractSubCategories: Array<Scalars['String']['output']>;
  contractTiers: Array<ContractTier>;
  contracts: ContractsResult;
  contractsByACL: Array<Contract>;
  createQuicksightGroup: CreateQuicksightGroupType;
  crossReferenceClusters: CrossReferenceClustersResult;
  crossReferenceList: CrossReferenceList;
  /** What deleting the list does, for its confirmation (#8015). Owner only. */
  crossReferenceListDeleteImpact: HospitalCrossReferenceListDeleteImpact;
  crossReferenceLists: CrossReferenceListResult;
  crossReferenceListsByACL: Array<CrossReferenceList>;
  crossReferenceMapStats: CrossReferenceMapStats;
  curvoErrors: Array<CurvoErrorCode>;
  customField: CustomField;
  customFields: Array<CustomField>;
  customer: Customer;
  customerContracts: Array<Contract>;
  customers: Array<Customer>;
  customersWithStats: Array<Customer>;
  dashboards: DashboardsResult;
  defaultPermissions: UserAbilities;
  detailedItem: ItemSpend;
  doBasketSearch: SearchBasketResult;
  /** Return Base64 XLSX file containing cross-references given cross-reference list id. */
  exportCrossReferences: Scalars['String']['output'];
  exportErrors: Scalars['String']['output'];
  exportHistories: ExportHistories;
  exportSupplierOpportunityItems: Scalars['String']['output'];
  externalAuthConnections: Array<ExternalAuthConnection>;
  featuredBaskets: Array<FeaturedBasket>;
  filterUploadedFileColumn: FilterColumnResult;
  getConsoleEmbedUrl: QuicksightDashboardEmbedUrlType;
  getContractsByCode: Array<Contract>;
  getDashboardById: Dashboard;
  getDashboardEmbedUrl: QuicksightDashboardEmbedUrlType;
  getDashboardNameById?: Maybe<Scalars['String']['output']>;
  getListOfDashboards: Array<QuicksightDashboardItemType>;
  getSpendDataForVendors: Array<SpendDataForVendorsResult>;
  getString: Scalars['String']['output'];
  getSupplierDashboards: Array<Dashboard>;
  gics: Array<Gic>;
  /** Filter master ids with existing Similar Products */
  hasSimilarProducts: Array<Scalars['String']['output']>;
  homepageFeaturedContents: Array<HomepageFeaturedContent>;
  /** One list the user's organization can read, as a row of the lists table (#8017 page header). */
  hospitalCrossReferenceList: HospitalCrossReferenceListRow;
  /** The cross-reference lists the user's organization can read, with cross counts (#8000). */
  hospitalCrossReferenceLists: Array<HospitalCrossReferenceListRow>;
  /** Whether the user's organization manages cross-reference lists the Epic 7954 way (#8014). */
  hospitalCrossReferenceManagementEnabled: Scalars['Boolean']['output'];
  /** Crosses as contract item ⇄ cross item pairs, in lists the organization can read (#8017). */
  hospitalCrossReferencePairs: HospitalCrossReferencePairPage;
  initiative: Initiative;
  initiativeNetwork: Network;
  initiativeSelectorsList: InitiativeSelectorsList;
  initiatives: InitiativesResult;
  /** Get transaction data by ts id and facility id */
  itemTransactions: ItemTransactionResult;
  keyContacts: Array<OpportunityKeyContact>;
  lastPurchaseDate: LastPurchaseDateResult;
  linkageSearch: MasterCatalogResult;
  listDashboardsForUser: Array<QuicksightDashboardItemType>;
  markupRules: MarkupRuleResult;
  /** Batch fuzzy match of names against the caller's facilities or their top parents, with scores */
  matchOrganizationNames: Array<OrganizationNameMatch>;
  me: UserContext;
  memberAnalysis: Array<MemberAnalysisOutput>;
  messageTemplates: MessageTemplateList;
  myInitiativeNetworks: Array<Network>;
  normalizedManufacturers: NormalizedManufacturerList;
  normalizedSupplierNamesForUploadedFileColumn: NormalizedSuppliersForUploadedFileColumn;
  normalizedSuppliers: Array<NormalizedSupplier>;
  offer: Offer;
  offerCode: OfferCodeResult;
  offerDetail: Offer;
  offerHospitals: Array<SupplierHospital>;
  offerItem?: Maybe<OfferItem>;
  offerManufacturers: Array<Scalars['String']['output']>;
  offerOfferedManufacturers: Array<Scalars['String']['output']>;
  offerRebateTypes: Array<Scalars['String']['output']>;
  offerScenario: OfferScenario;
  offerStats: OfferStats;
  offerSubmittedManufacturers: Array<Scalars['String']['output']>;
  offerTierRebate?: Maybe<TierRebate>;
  offerTierRebates: Array<TierRebate>;
  offers: OfferResult;
  opportunityCustomFields: Array<CustomField>;
  opportunityCustomization: OpportunityCustomizationResult;
  opportunityCustomizationInfo: OpportunityCustomizationInfoResult;
  opportunityInvitingVendors: Array<OfferInvitingVendor>;
  opportunityScenarios: Array<OfferScenario>;
  organization: Organization;
  organizationTreeByCustomer: Array<Organization>;
  organizationTypes: Array<OrganizationType>;
  organizationUsers: Array<UserOrganization>;
  organizations: Array<Organization>;
  organizationsWithTopParent: Array<Organization>;
  partTiers: Array<PartTier>;
  partTiersHistories: Array<PartTierHistory>;
  partTiersHistoriesByTsIds: Array<PartTierHistory>;
  partsByACL: Array<Part>;
  permissionTo: Scalars['String']['output'];
  ping: Scalars['String']['output'];
  pinnedSavedSearches: Array<SavedSearch>;
  planeIssues: PlaneIssueReponse;
  previewOpportunityEmailTemplate: Scalars['String']['output'];
  projects: Array<Project>;
  publicVendors: PublicVendorsResult;
  queryOpportunityStats: OpportunityStats;
  quickSightGetDashboards: Array<QuicksightDashboardItemType>;
  quickSightGetGroups: Array<Scalars['String']['output']>;
  rebateComplianceScorecardFilterTerms: RebateComplianceScorecardFilterTerms;
  rebateComplianceScorecardStats: RebateComplianceScorecardStats;
  rebateComplianceScorecards: RebateComplianceScorecardResult;
  rebateDetailRuleStats: RebateDetailRuleStats;
  rebateDetailVolumeStats: RebateDetailVolumeStats;
  /** Short-lived presigned download URL for a stored evidence doc. */
  rebateEvidenceDownloadUrl: Scalars['String']['output'];
  rebateOpportunityCards: RebateOpportunityCardResult;
  rebateOpportunityCardsFilterTerms: RebateOpportunityCardFilterTerms;
  rebateOpportunityStats: RebateOpportunityStats;
  rebateReconciliationStats: RebateReconciliationStats;
  rebateSpendItemFilterTerms: RebateSpendItemFilterTerms;
  rebateSpendItems: RebateSpendItemResult;
  relatedSearch: CatalogPartResult;
  savedMappings: SavedMappingList;
  savedSearch: SavedSearch;
  savedSearches: PaginatedSavedSearch;
  scenarioTierConversionBreakdown: Array<ScenarioTierConversionBreakdown>;
  searchGmdnNames: SearchGmdnNamesResponse;
  searchGudidBrands: SearchGudidBrandsResponse;
  searchMasterCatalog: MasterCatalogResult;
  searchNormalizedManufacturers: NormalizedManufacturersSearchResult;
  searchNormalizedSuppliers: NormalizedSupplierSearchResult;
  searchSubmittedCategories: SearchSubmittedCategoriesResponse;
  searchUnspscCommodity: SearchUnspscCommodityResponse;
  searchUnspscTitles: Array<Unspsc>;
  /** Get similar products by gudid */
  similarProducts: SimilarProductResult;
  /** Get similar products manufacturers list */
  similarProductsManufacturers: Array<Scalars['String']['output']>;
  smartRuleUploadJobs: Array<UploadJob>;
  /** Get sourcing plan by ID. */
  sourcingPlan: SourcingPlan;
  sourcingPlanBasketBase: SourcingPlanBasketBase;
  sourcingPlanBasketBases: Array<SourcingPlanBasketBase>;
  sourcingPlanSurveyEmailPreview: Scalars['String']['output'];
  /** Get all sourcing plans of particular user. */
  sourcingPlans: Array<SourcingPlan>;
  studiesGet: StudiesGetResult;
  studiesTransactionsGet: Array<QueuedTransaction>;
  studyLinkCount: Scalars['Int']['output'];
  studyLinks: Array<ExtendedQueuedLinkProcess>;
  studyTransactionsCount: Scalars['Int']['output'];
  suggestedVendors: SuggestedVendorsResult;
  supplierOfferCustomFields?: Maybe<Array<CustomField>>;
  supplierOpportunities: SupplierOpportunitiesResult;
  supplierOpportunity: SupplierOpportunity;
  syncCustomer: Customer;
  syncCustomers: Array<Customer>;
  syncOrganization: Organization;
  syncOrganizationTypes: Array<OrganizationType>;
  syncOrganizations: Array<Organization>;
  systems: Array<System>;
  tier: Tier;
  tierAggregatedByCustomerId: ContractMemberTierAggregatedInfo;
  tierStats: TierStats;
  tiers: TiersResult;
  uploadHistories: UploadHistories;
  uploadJob: UploadJob;
  uploadJobs: UploadJobsResult;
  uploadedFileKey: UploadedFileKeyResult;
  user: User;
  userActivities: Array<UserActivity>;
  userBaskets: Array<Basket>;
  userHomepageFeaturedContents: Array<HomepageFeaturedContent>;
  users: UsersResult;
  vendor: Customer;
  vendorUsers: VendorUsersResult;
  vendors: VendorsResult;
};


export type QueryAdminSupplierOpportunitiesArgs = {
  customerId: Scalars['String']['input'];
  input: SupplierOpportunitiesInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Array<Sort>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllowedGicTypeOnesArgs = {
  gicId: Scalars['Int']['input'];
};


export type QueryAllowedGicTypeTwosArgs = {
  typeOneId: Scalars['String']['input'];
};


export type QueryAwardPrioritiesArgs = {
  input: AwardPrioritiesInput;
};


export type QueryBasketArgs = {
  input: IdArgs;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBasketConnectedContractsArgs = {
  basketId: Scalars['String']['input'];
};


export type QueryBasketInsightsArgs = {
  input: IdArgs;
};


export type QueryBasketLastPurchaseDateArgs = {
  basketId: Scalars['String']['input'];
};


export type QueryBasketProductsArgs = {
  input: GetBasketProductsByCriteriaInput;
};


export type QueryBasketsArgs = {
  input: GetBasketsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBasketsByAclArgs = {
  input: GetBasketAclByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBasketsFacilitiesStatsArgs = {
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<BasketsFacilitiesChartFilter>;
  pagination: Pagination;
  sort?: InputMaybe<BasketSort>;
  targetPercentile?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBasketsListArgs = {
  input: GetBasketsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCatalogPartArgs = {
  input: IdArgs;
};


export type QueryCatalogPartTierInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryCatalogPartsArgs = {
  input: GetCatalogPartsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<CatalogPartsSortInput>>;
};


export type QueryCatalogSearchArgs = {
  input: CatalogSearchInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CatalogPartsSortInput>;
};


export type QueryClinicalStudiesArgs = {
  input: ClinicalStudiesInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryContactUsersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractArgs = {
  input: IdArgs;
};


export type QueryContractBasketArgs = {
  input: ContractBasketInput;
};


export type QueryContractHistoriesArgs = {
  input: ContractHistoryInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryContractItemNoCrossesArgs = {
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractItemsNeedingCrossArgs = {
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractMemberArgs = {
  input: GetContractMemberInput;
};


export type QueryContractMemberTierHistoriesArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryContractMembersArgs = {
  input: GetContractMembersInput;
};


export type QueryContractMembersUploadNamesArgs = {
  input: ContractMembersUploadNamesInput;
};


export type QueryContractMembersUploadPreviewArgs = {
  input: ContractMembersUploadPreviewInput;
};


export type QueryContractOrganizationsArgs = {
  input: GetContractOrganizationsByCriteriaInput;
};


export type QueryContractPartsCountArgs = {
  input: GetContractPartsInput;
};


export type QueryContractSubCategoriesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractTiersArgs = {
  input: ContractTierInput;
};


export type QueryContractsArgs = {
  input: GetContractsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryContractsByAclArgs = {
  input: GetContractAclByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCreateQuicksightGroupArgs = {
  input: CreateQuicksightGroupInput;
};


export type QueryCrossReferenceClustersArgs = {
  id: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrossReferenceListArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrossReferenceListDeleteImpactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCrossReferenceListsArgs = {
  input: GetCrossReferenceListsByCriteriaInput;
};


export type QueryCrossReferenceListsByAclArgs = {
  input: GetCrossReferenceListAclByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryCustomFieldArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomFieldsArgs = {
  filter?: InputMaybe<CustomFieldFilterInput>;
};


export type QueryCustomerArgs = {
  input: IdArgs;
};


export type QueryCustomerContractsArgs = {
  input: IdArgs;
};


export type QueryCustomersArgs = {
  input: GetCustomersByCriteriaInput;
};


export type QueryCustomersWithStatsArgs = {
  input: GetCustomersByCriteriaInput;
};


export type QueryDashboardsArgs = {
  input: GetDashboardsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryDetailedItemArgs = {
  input: IdArgs;
};


export type QueryDoBasketSearchArgs = {
  input: BasketSearchInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryExportCrossReferencesArgs = {
  id: Scalars['String']['input'];
  option?: InputMaybe<ExportCrossReferencesOption>;
};


export type QueryExportErrorsArgs = {
  input: IdArgs;
};


export type QueryExportSupplierOpportunityItemsArgs = {
  id: Scalars['String']['input'];
};


export type QueryFeaturedBasketsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryFilterUploadedFileColumnArgs = {
  input: FilterColumnInput;
};


export type QueryGetContractsByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetDashboardByIdArgs = {
  input: GetDashboardInput;
};


export type QueryGetDashboardEmbedUrlArgs = {
  input: GetDashboardEmbedUrlInput;
};


export type QueryGetDashboardNameByIdArgs = {
  input: GetDashboardInput;
};


export type QueryGetSpendDataForVendorsArgs = {
  dataset?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSupplierDashboardsArgs = {
  input: GetSupplierDashboardsInput;
};


export type QueryGicsArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHasSimilarProductsArgs = {
  input: HasSimilarProductsInput;
};


export type QueryHomepageFeaturedContentsArgs = {
  input: HomepageFeaturedContentQueryInput;
};


export type QueryHospitalCrossReferenceListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHospitalCrossReferenceListsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHospitalCrossReferencePairsArgs = {
  filter: HospitalCrossReferencePairFilter;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<HospitalCrossReferencePairSort>;
};


export type QueryInitiativeArgs = {
  id: Scalars['String']['input'];
};


export type QueryInitiativeNetworkArgs = {
  id: Scalars['String']['input'];
};


export type QueryInitiativesArgs = {
  input: GetInitiativesByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryItemTransactionsArgs = {
  input: DetailedSearchInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryLastPurchaseDateArgs = {
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLinkageSearchArgs = {
  input: LinkageSearchInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListDashboardsForUserArgs = {
  input: ListDashboardsForUserInput;
};


export type QueryMarkupRulesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryMatchOrganizationNamesArgs = {
  input: MatchOrganizationNamesInput;
};


export type QueryMemberAnalysisArgs = {
  input: MemberAnalysisInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryNormalizedSupplierNamesForUploadedFileColumnArgs = {
  input: FilterColumnInput;
};


export type QueryNormalizedSuppliersArgs = {
  input: Array<Scalars['String']['input']>;
};


export type QueryOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryOfferDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferHospitalsArgs = {
  sort?: InputMaybe<OfferHospitalSort>;
};


export type QueryOfferItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferManufacturersArgs = {
  id: Scalars['String']['input'];
  linked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOfferOfferedManufacturersArgs = {
  crossed?: InputMaybe<CrossedStatus>;
  id: Scalars['String']['input'];
  linked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOfferScenarioArgs = {
  id: Scalars['String']['input'];
};


export type QueryOfferStatsArgs = {
  input: IdArgs;
};


export type QueryOfferSubmittedManufacturersArgs = {
  crossed?: InputMaybe<CrossedStatus>;
  id: Scalars['String']['input'];
  linked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOfferTierRebateArgs = {
  rebateId: Scalars['String']['input'];
};


export type QueryOfferTierRebatesArgs = {
  offerId: Scalars['String']['input'];
};


export type QueryOffersArgs = {
  input: OffersInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryOpportunityCustomizationArgs = {
  input: OpportunityCustomizationInput;
};


export type QueryOpportunityCustomizationInfoArgs = {
  input: OpportunityCustomizationInfoInput;
};


export type QueryOpportunityInvitingVendorsArgs = {
  input: IdArgs;
};


export type QueryOpportunityScenariosArgs = {
  input: IdArgs;
};


export type QueryOrganizationArgs = {
  input: IdArgs;
};


export type QueryOrganizationTreeByCustomerArgs = {
  input: IdArgs;
};


export type QueryOrganizationTypesArgs = {
  input: GetOrganizationTypeByCriteriaInput;
};


export type QueryOrganizationUsersArgs = {
  input: IdArgs;
};


export type QueryOrganizationsArgs = {
  input: GetOrganizationsByCriteriaInput;
};


export type QueryPartTiersArgs = {
  input: GetPartsTiersByCriteriaInput;
};


export type QueryPartTiersHistoriesArgs = {
  tsId: Scalars['String']['input'];
};


export type QueryPartTiersHistoriesByTsIdsArgs = {
  tsIds: Array<Scalars['String']['input']>;
};


export type QueryPartsByAclArgs = {
  input: GetPartAclByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryPermissionToArgs = {
  input: CheckPermissionInput;
};


export type QueryPlaneIssuesArgs = {
  args: PlaneIssueArgs;
};


export type QueryPreviewOpportunityEmailTemplateArgs = {
  input: OpportunityEmailTemplatePreviewInput;
};


export type QueryProjectsArgs = {
  input: GetProjectsByCriteriaInput;
};


export type QueryPublicVendorsArgs = {
  input: GetVendorsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type QueryQueryOpportunityStatsArgs = {
  input: OpportunityStatsQueryInput;
};


export type QueryRebateComplianceScorecardStatsArgs = {
  input: RebateComplianceScorecardStatsInput;
};


export type QueryRebateComplianceScorecardsArgs = {
  input: RebateComplianceScorecardInput;
};


export type QueryRebateDetailRuleStatsArgs = {
  input: RebateSpendItemsInput;
};


export type QueryRebateDetailVolumeStatsArgs = {
  input: RebateSpendItemsInput;
};


export type QueryRebateEvidenceDownloadUrlArgs = {
  s3Url: Scalars['String']['input'];
};


export type QueryRebateOpportunityCardsArgs = {
  input: RebateOpportunityQueryInput;
};


export type QueryRebateOpportunityStatsArgs = {
  input: RebateOpportunityStatsInput;
};


export type QueryRebateReconciliationStatsArgs = {
  input: RebateReconciliationStatsInput;
};


export type QueryRebateSpendItemFilterTermsArgs = {
  input: RebateSpendItemsFilterTermsInput;
};


export type QueryRebateSpendItemsArgs = {
  input: RebateSpendItemsInput;
};


export type QueryRelatedSearchArgs = {
  input: GetRelatedSearchInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CatalogPartsSortInput>;
};


export type QuerySavedMappingsArgs = {
  input: GetSavedMappingInput;
};


export type QuerySavedSearchArgs = {
  input: IdArgs;
};


export type QuerySavedSearchesArgs = {
  input: SavedSearchesInput;
};


export type QueryScenarioTierConversionBreakdownArgs = {
  scenarioId: Scalars['String']['input'];
  tierId: Scalars['String']['input'];
};


export type QuerySearchGmdnNamesArgs = {
  input: SearchGmdnNameInput;
};


export type QuerySearchGudidBrandsArgs = {
  input: SearchGudidBrandInput;
};


export type QuerySearchMasterCatalogArgs = {
  input: SearchMasterCatalogByPartNumberInput;
};


export type QuerySearchNormalizedManufacturersArgs = {
  input: SearchNormalizedManufacturersInput;
};


export type QuerySearchNormalizedSuppliersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText: Scalars['String']['input'];
};


export type QuerySearchSubmittedCategoriesArgs = {
  input: SearchSubmittedCategoryInput;
};


export type QuerySearchUnspscCommodityArgs = {
  input: SearchUnspscInput;
};


export type QuerySearchUnspscTitlesArgs = {
  input: SearchUnspscInput;
};


export type QuerySimilarProductsArgs = {
  input: SimilarProductsInput;
  pagination?: InputMaybe<Pagination>;
};


export type QuerySimilarProductsManufacturersArgs = {
  input: SimilarProductsManufacturersInput;
};


export type QuerySmartRuleUploadJobsArgs = {
  basketId: Scalars['String']['input'];
};


export type QuerySourcingPlanArgs = {
  id: Scalars['String']['input'];
};


export type QuerySourcingPlanBasketBaseArgs = {
  id: Scalars['String']['input'];
  sourcingPlanId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySourcingPlanBasketBasesArgs = {
  input?: InputMaybe<SourcingPlanBasketsQueryInput>;
};


export type QuerySourcingPlansArgs = {
  input?: InputMaybe<GetSourcingPlansByCriteriaInput>;
};


export type QueryStudiesGetArgs = {
  input: StudiesGetInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryStudiesTransactionsGetArgs = {
  input: StudiesTransactionsGetInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryStudyLinkCountArgs = {
  input: StudyLinksQueryArgs;
};


export type QueryStudyLinksArgs = {
  input: StudyLinksQueryArgs;
};


export type QueryStudyTransactionsCountArgs = {
  input: StudiesTransactionsCountInput;
};


export type QuerySuggestedVendorsArgs = {
  input: GetSuggestedVendorsInput;
};


export type QuerySupplierOfferCustomFieldsArgs = {
  offerId: Scalars['String']['input'];
};


export type QuerySupplierOpportunitiesArgs = {
  input: SupplierOpportunitiesInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Array<Sort>>;
};


export type QuerySupplierOpportunityArgs = {
  input: IdArgs;
};


export type QuerySyncCustomerArgs = {
  input: IdArgs;
};


export type QuerySyncCustomersArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomerTypeEnum>;
};


export type QuerySyncOrganizationArgs = {
  input: IdArgs;
};


export type QuerySystemsArgs = {
  input: GetSystemByCriteriaInput;
};


export type QueryTierArgs = {
  id: Scalars['String']['input'];
};


export type QueryTiersArgs = {
  input: GetTiersByCriteriaInput;
  pagination: Pagination;
  sort?: InputMaybe<TiersSortInput>;
};


export type QueryUploadJobArgs = {
  id: IdArgs;
};


export type QueryUploadJobsArgs = {
  input: UploadJobsByCriteriaInput;
};


export type QueryUploadedFileKeyArgs = {
  input: UploadedFileKeyInput;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserActivitiesArgs = {
  input: GetUserActivitiesByCriteriaInput;
};


export type QueryUserBasketsArgs = {
  input: IdArgs;
};


export type QueryUsersArgs = {
  input: GetUsersByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
};


export type QueryVendorArgs = {
  input: IdArgs;
};


export type QueryVendorUsersArgs = {
  input: GetUsersByCriteriaInput;
};


export type QueryVendorsArgs = {
  input: GetVendorsByCriteriaInput;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};

export type QueuedLinkProcess = {
  __typename?: 'QueuedLinkProcess';
  aiGudidOverwrite?: Maybe<Scalars['Boolean']['output']>;
  aiMedOverwrite?: Maybe<Scalars['Boolean']['output']>;
  aiStanOverwrite?: Maybe<Scalars['Boolean']['output']>;
  asp?: Maybe<Scalars['Float']['output']>;
  bamfGudidId?: Maybe<Scalars['String']['output']>;
  bamfMedId?: Maybe<Scalars['String']['output']>;
  bamfStanId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionOrg?: Maybe<Scalars['String']['output']>;
  gmdn?: Maybe<Array<Scalars['String']['output']>>;
  gudidCatalogNumber?: Maybe<Scalars['String']['output']>;
  gudidCompanyName?: Maybe<Scalars['String']['output']>;
  gudidDescription?: Maybe<Scalars['String']['output']>;
  gudidManufacturer?: Maybe<Scalars['String']['output']>;
  gudidVersionModelNumber?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  ignoreManufacturer?: Maybe<Scalars['Boolean']['output']>;
  ignoreRow?: Maybe<Scalars['Boolean']['output']>;
  ignoreVendor?: Maybe<Scalars['Boolean']['output']>;
  isGudidApproved?: Maybe<Scalars['Boolean']['output']>;
  isGudidSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  isMedApproved?: Maybe<Scalars['Boolean']['output']>;
  isMedSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  isReprocessed?: Maybe<Scalars['Boolean']['output']>;
  isStanApproved?: Maybe<Scalars['Boolean']['output']>;
  isStanSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerGudidType?: Maybe<Scalars['String']['output']>;
  manufacturerMedType?: Maybe<Scalars['String']['output']>;
  manufacturerOrg?: Maybe<Scalars['String']['output']>;
  manufacturerStanType?: Maybe<Scalars['String']['output']>;
  matchGudidId?: Maybe<Scalars['String']['output']>;
  matchMedId?: Maybe<Scalars['String']['output']>;
  matchStanId?: Maybe<Scalars['String']['output']>;
  medDescription?: Maybe<Scalars['String']['output']>;
  medManufacturer?: Maybe<Scalars['String']['output']>;
  medMaterialCode?: Maybe<Scalars['String']['output']>;
  medSku?: Maybe<Scalars['String']['output']>;
  mfgitem?: Maybe<Scalars['String']['output']>;
  mfgitemOrg?: Maybe<Scalars['String']['output']>;
  priceTiers?: Maybe<Array<TransactionTier>>;
  qtypurchase?: Maybe<Scalars['Int']['output']>;
  stanManufacturer?: Maybe<Scalars['String']['output']>;
  stanManufacturerId?: Maybe<Scalars['String']['output']>;
  stanManufacturerOb?: Maybe<Manufacturer>;
  stanPartDescription?: Maybe<Scalars['String']['output']>;
  stanPartNumber?: Maybe<Scalars['String']['output']>;
  study: QueuedStudy;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  tsId: Scalars['String']['output'];
  uom?: Maybe<Scalars['String']['output']>;
  uomconversion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  vendorOrg?: Maybe<Scalars['String']['output']>;
  venitem?: Maybe<Scalars['String']['output']>;
  venitemOrg?: Maybe<Scalars['String']['output']>;
};

export type QueuedStudy = {
  __typename?: 'QueuedStudy';
  backupTrxJobId?: Maybe<Scalars['String']['output']>;
  backupTrxJobStatus?: Maybe<Scalars['String']['output']>;
  bamfMatchedCount?: Maybe<Scalars['Int']['output']>;
  checkConflictsJobId?: Maybe<Scalars['String']['output']>;
  checkConflictsJobStatus?: Maybe<Scalars['String']['output']>;
  committedStudyLink?: Maybe<Scalars['Boolean']['output']>;
  conflicts?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  customQuery?: Maybe<Scalars['String']['output']>;
  cxUserId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  errorLog?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  groomedPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  linkedTsId?: Maybe<Scalars['Int']['output']>;
  maxDatePurchase?: Maybe<Scalars['Date']['output']>;
  minDatePurchase?: Maybe<Scalars['Date']['output']>;
  recordCount?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<StudyStatusEnum>;
  totalUniqueTsId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type QueuedTransaction = {
  __typename?: 'QueuedTransaction';
  ageGroup?: Maybe<Scalars['String']['output']>;
  aiOverwrite?: Maybe<Scalars['Boolean']['output']>;
  bamfManufacturer?: Maybe<Scalars['String']['output']>;
  bamfPartDescription?: Maybe<Scalars['String']['output']>;
  bamfPartId?: Maybe<Scalars['String']['output']>;
  bamfPartNumber?: Maybe<Scalars['String']['output']>;
  blacklistManufacturer?: Maybe<Scalars['Boolean']['output']>;
  blacklistMfgItem?: Maybe<Scalars['Boolean']['output']>;
  blacklistVenItem?: Maybe<Scalars['Boolean']['output']>;
  blacklistVendor?: Maybe<Scalars['Boolean']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  curvoId?: Maybe<Scalars['Int']['output']>;
  customFieldsD1?: Maybe<Scalars['String']['output']>;
  customFieldsD2?: Maybe<Scalars['String']['output']>;
  customFieldsD3?: Maybe<Scalars['String']['output']>;
  customFieldsT1?: Maybe<Scalars['String']['output']>;
  customFieldsT2?: Maybe<Scalars['String']['output']>;
  customFieldsT3?: Maybe<Scalars['String']['output']>;
  datePurchase?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extPrice?: Maybe<Scalars['Float']['output']>;
  facItem?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['String']['output']>;
  gicName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignoreManufacturer?: Maybe<Scalars['Boolean']['output']>;
  ignoreVendor?: Maybe<Scalars['Boolean']['output']>;
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isSupplierVen?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  matchManufacturer?: Maybe<Manufacturer>;
  matchManufacturerId?: Maybe<Scalars['String']['output']>;
  matchPartId?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  materialName?: Maybe<Scalars['String']['output']>;
  mfgItem?: Maybe<Scalars['String']['output']>;
  nDescription?: Maybe<Scalars['String']['output']>;
  nManufacturer?: Maybe<Scalars['String']['output']>;
  nManufacturerCurvo?: Maybe<Scalars['String']['output']>;
  nMfgItem?: Maybe<Scalars['String']['output']>;
  nStrippedMfgItem?: Maybe<Scalars['String']['output']>;
  nStrippedVenItem?: Maybe<Scalars['String']['output']>;
  nVenItem?: Maybe<Scalars['String']['output']>;
  nVendor?: Maybe<Scalars['String']['output']>;
  nVendorCurvo?: Maybe<Scalars['String']['output']>;
  poNum?: Maybe<Scalars['String']['output']>;
  priceTiers?: Maybe<Array<TransactionTier>>;
  qtyPurchase?: Maybe<Scalars['Float']['output']>;
  segmentId?: Maybe<Scalars['String']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
  sizeOne?: Maybe<Scalars['Float']['output']>;
  sizeThree?: Maybe<Scalars['Float']['output']>;
  sizeTwo?: Maybe<Scalars['Float']['output']>;
  study?: Maybe<QueuedStudy>;
  studyId?: Maybe<Scalars['Int']['output']>;
  surgeon?: Maybe<Scalars['String']['output']>;
  tsId?: Maybe<Scalars['String']['output']>;
  typeOneId?: Maybe<Scalars['String']['output']>;
  typeOneName?: Maybe<Scalars['String']['output']>;
  typeTwoId?: Maybe<Scalars['String']['output']>;
  typeTwoName?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  unmatchedFields?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  venItem?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  waste?: Maybe<Scalars['Boolean']['output']>;
};

export type QuickCreateOrganizationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type QuicksightDashboardEmbedUrlType = {
  __typename?: 'QuicksightDashboardEmbedUrlType';
  EmbedUrl?: Maybe<Scalars['String']['output']>;
  cloakingUser?: Maybe<User>;
};

export type QuicksightDashboardItemType = {
  __typename?: 'QuicksightDashboardItemType';
  dashboardId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type QuicksightGroupType = {
  __typename?: 'QuicksightGroupType';
  GroupName?: Maybe<Scalars['String']['output']>;
};

export type RebateCardPreferenceInput = {
  contractId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  rebateId: Scalars['String']['input'];
  rebatePeriodOffset: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  tierId: Scalars['String']['input'];
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export enum RebateCollectionStatus {
  Collected = 'Collected',
  Discrepancy = 'Discrepancy',
  Missed = 'Missed',
  Pending = 'Pending'
}

export type RebateComplianceScorecard = {
  __typename?: 'RebateComplianceScorecard';
  actualReceived?: Maybe<RebatePeriodActual>;
  closeness: Scalars['Float']['output'];
  contractId: Scalars['String']['output'];
  contractInfo: RebateOpportunityContractInfo;
  customer?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  eligibleProjectedSpend: Scalars['Float']['output'];
  eligibleUnits: Scalars['Float']['output'];
  endDate: Scalars['Date']['output'];
  facility?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  mostImpactRuleStat?: Maybe<RebateRuleStatus>;
  rebateGroupName?: Maybe<Scalars['String']['output']>;
  rebateId: Scalars['String']['output'];
  rebateInfo: RebateOpportunityRebateInfo;
  rebatePeriodOffset: Scalars['Int']['output'];
  /**
   * The level this rebate is evaluated at: `facility` | `topParent` | `corporate` (ETL-written, so
   * typed as a string rather than an enum). Drives the scorecard's scope badge, which explains why
   * a multi-facility rebate shows under a single-facility filter.
   */
  rebateScope?: Maybe<Scalars['String']['output']>;
  rebateTierIndex?: Maybe<Scalars['Int']['output']>;
  rebateTiers: Array<RebateTierStat>;
  riskStatus: RebateRiskStatus;
  ruleStatuses: Array<RebateRuleStatus>;
  startDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
  topParent?: Maybe<Scalars['String']['output']>;
  topParentId?: Maybe<Scalars['String']['output']>;
  totalRebate: Scalars['Float']['output'];
};

export type RebateComplianceScorecardFilterTerms = {
  __typename?: 'RebateComplianceScorecardFilterTerms';
  contractCodes: Array<ContractCodeFilterTerms>;
  /**
   * Every facility of the authenticated customer — not only the ones that currently own a rebate
   * row, since a facility with no facility-scoped rebate is still covered by topParent- and
   * corporate-scoped ones.
   */
  facilities: Array<FacilityFilterTerms>;
  rebateTypes: Array<Scalars['String']['output']>;
  suppliers: Array<Scalars['String']['output']>;
  topParents: Array<TopParentFilterTerms>;
};

export type RebateComplianceScorecardInput = {
  collectionStatus?: InputMaybe<RebateCollectionStatus>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  /** Scope-aware facility filter: keeps facility-scoped rebates for these facilities, topParent-scoped rebates whose top parent owns one of them, and every corporate-scoped rebate in the tenant. OR across the set; omit or leave empty to not filter. */
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** When false, excludes rebate periods with no eligible spend (eligibleprojectedspend IS NULL or 0) — used by the Reconciliation tab */
  includeNoEligibleSpend?: InputMaybe<Scalars['Boolean']['input']>;
  /** When false, excludes rebates with no advanced rules (advancedrulesjsonlogic IS NULL) */
  includeNoRuleRebates?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RebateComplianceScorecardQueryOrderby>;
  /** Multi-column sort; takes precedence over orderBy/orderDirection when non-empty */
  orderBys?: InputMaybe<Array<RebateComplianceScorecardOrderBy>>;
  orderDirection?: InputMaybe<OrderDirection>;
  periodStatus: RebatePeriodStatus;
  /** Filters on rebateInfo.type */
  rebateType?: InputMaybe<Scalars['String']['input']>;
  riskStatus?: InputMaybe<RebateRiskStatus>;
  /** a.k.a manufacturer */
  supplier?: InputMaybe<Scalars['String']['input']>;
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export type RebateComplianceScorecardOrderBy = {
  orderBy: RebateComplianceScorecardQueryOrderby;
  orderDirection?: InputMaybe<OrderDirection>;
};

export enum RebateComplianceScorecardQueryOrderby {
  ActualComment = 'ActualComment',
  ActualDiscrepancy = 'ActualDiscrepancy',
  ActualPaymentType = 'ActualPaymentType',
  ActualReceived = 'ActualReceived',
  ActualReceivedDate = 'ActualReceivedDate',
  Contract = 'Contract',
  ContractRebate = 'ContractRebate',
  Earned = 'Earned',
  EndDate = 'EndDate',
  Manufacturer = 'Manufacturer',
  StartDate = 'StartDate'
}

export type RebateComplianceScorecardResult = {
  __typename?: 'RebateComplianceScorecardResult';
  hits: Array<RebateComplianceScorecard>;
  totalHits: Scalars['Int']['output'];
};

export type RebateComplianceScorecardStats = {
  __typename?: 'RebateComplianceScorecardStats';
  atRiskCount: Scalars['Float']['output'];
  atRiskTotalRebate: Scalars['Float']['output'];
  captureRate: Scalars['Float']['output'];
  contractCount: Scalars['Int']['output'];
  earnedCount: Scalars['Float']['output'];
  earnedTotalRebate: Scalars['Float']['output'];
  missedCount: Scalars['Float']['output'];
  missedTotalRebate: Scalars['Float']['output'];
  ontrackCount: Scalars['Float']['output'];
  ontrackTotalRebate: Scalars['Float']['output'];
  rebateCount: Scalars['Int']['output'];
};

export type RebateComplianceScorecardStatsInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** Scope-aware facility filter: keeps facility-scoped rebates for these facilities, topParent-scoped rebates whose top parent owns one of them, and every corporate-scoped rebate in the tenant. OR across the set; omit or leave empty to not filter. */
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** When false, excludes rebates with no advanced rules (advancedrulesjsonlogic IS NULL) */
  includeNoRuleRebates?: InputMaybe<Scalars['Boolean']['input']>;
  periodStatus: RebatePeriodStatus;
  /** Filters on rebateInfo.type */
  rebateType?: InputMaybe<Scalars['String']['input']>;
  riskStatus?: InputMaybe<RebateRiskStatus>;
  /** a.k.a manufacturer */
  supplier?: InputMaybe<Scalars['String']['input']>;
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export type RebateDetailFacilityMonthlyDistribution = {
  __typename?: 'RebateDetailFacilityMonthlyDistribution';
  facilityId: Scalars['String']['output'];
  facilityName: Scalars['String']['output'];
  isProjected: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  totalSpend: Scalars['String']['output'];
};

export type RebateDetailRuleStats = {
  __typename?: 'RebateDetailRuleStats';
  marketShareStats: Array<RebateMarketShareStat>;
  rebateGroupName?: Maybe<Scalars['String']['output']>;
  rebateInfo?: Maybe<RebateOpportunityRebateInfo>;
  rebateTiers: Array<RebateTierStat>;
  ruleStatuses: Array<RebateRuleStatus>;
};

export type RebateDetailVolumeStats = {
  __typename?: 'RebateDetailVolumeStats';
  rebateDetailFacilityMonthlyDistribution: Array<RebateDetailFacilityMonthlyDistribution>;
};

export type RebateFilterTerms = {
  __typename?: 'RebateFilterTerms';
  id: Scalars['String']['output'];
  isGroup: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type RebateGroup = {
  __typename?: 'RebateGroup';
  conditionalStartDate: ConditionalStartDate;
  contractsId?: Maybe<Scalars['ID']['output']>;
  contractsTiersRebates: Array<ContractTierRebate>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateOnly']['output']>;
  expirationDate?: Maybe<Scalars['DateOnly']['output']>;
  humanReadableRebate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGroup: Scalars['Boolean']['output'];
  isTiered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offerId?: Maybe<Scalars['ID']['output']>;
  payoutLevel: TierRuleScope;
  periodType: TierRulePeriodType;
  productTsIds?: Maybe<Array<Scalars['String']['output']>>;
  scope: TierRuleScope;
  tierCount: Scalars['Int']['output'];
  tiers: Array<TierRebate>;
  type: Scalars['String']['output'];
  vendors?: Maybe<Array<Scalars['String']['output']>>;
};

export type RebateGroupInput = {
  conditionalStartDate?: ConditionalStartDate;
  contractId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Existing group id when editing. Only honoured if the submitted tiers already belong to it, or it is reachable from this contract — a group header carries no contract of its own. */
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payoutLevel?: TierRuleScope;
  periodType: TierRulePeriodType;
  productTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: TierRuleScope;
  /** Pricing tiers this rebate applies to */
  tierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tiers: Array<RebateGroupTierInput>;
  /** Rebate type (e.g. rebate, admin fee, etc.) */
  type: Scalars['String']['input'];
  vendors?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RebateGroupTierInput = {
  advancedRulesJsonLogic?: InputMaybe<Scalars['String']['input']>;
  /** JSON object of advanced rules, interchangeable with advancedRulesJsonLogic */
  advancedRulesJsonLogicObject?: InputMaybe<Scalars['JSON']['input']>;
  growth: Array<RebateGrowthInput>;
  metricType?: TierRebateMetricType;
  /** Existing tiers_rebates id; null creates a new tier */
  rebateId?: InputMaybe<Scalars['String']['input']>;
  /** 1-based, ascending by threshold. Highest qualifying tier pays. */
  tierIndex: Scalars['Int']['input'];
  /** Display label for this tier, e.g. "Tier 2" */
  tierLabel?: InputMaybe<Scalars['String']['input']>;
  tierRules?: InputMaybe<TierRuleInput>;
};

export type RebateGrowthInput = {
  baselineSpend?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['Float']['input'];
};

export enum RebateLikelihoodStatus {
  IncreaseVolume = 'IncreaseVolume',
  LockedIn = 'LockedIn',
  Missed = 'Missed',
  OnTrack = 'OnTrack',
  VendorShift = 'VendorShift'
}

export type RebateMarketShareStat = {
  __typename?: 'RebateMarketShareStat';
  marketShare: Scalars['Float']['output'];
  ruleHumanReadable?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  totalSpend: Scalars['Float']['output'];
};

export type RebateOpportunityCardFilterTerms = {
  __typename?: 'RebateOpportunityCardFilterTerms';
  contractCategories: Array<Scalars['String']['output']>;
  curvoCategories: Array<Scalars['String']['output']>;
  rebateTypes: Array<Scalars['String']['output']>;
  suppliers: Array<Scalars['String']['output']>;
  topParents: Array<TopParentFilterTerms>;
};

export type RebateOpportunityCardItem = {
  __typename?: 'RebateOpportunityCardItem';
  contractId: Scalars['String']['output'];
  contractInfo: RebateOpportunityContractInfo;
  customer?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  eligibleProjectedSpend: Scalars['Float']['output'];
  eligibleUnits: Scalars['Float']['output'];
  endDate: Scalars['Date']['output'];
  facility?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  likelihoodScore: Scalars['Float']['output'];
  mostImpactRuleStat?: Maybe<RebateRuleStatus>;
  note?: Maybe<Scalars['String']['output']>;
  numberOfRules: Scalars['Int']['output'];
  rebateId: Scalars['String']['output'];
  rebateInfo: RebateOpportunityRebateInfo;
  rebateMetricType?: Maybe<TierRuleMetricType>;
  rebatePeriodOffset: Scalars['Int']['output'];
  rebateTiers: Array<RebateTierStat>;
  ruleStatuses: Array<RebateRuleStatus>;
  snoozeUntil?: Maybe<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
  topParent?: Maybe<Scalars['String']['output']>;
  topParentId?: Maybe<Scalars['String']['output']>;
  totalRebate: Scalars['Float']['output'];
};

export type RebateOpportunityCardPreference = {
  __typename?: 'RebateOpportunityCardPreference';
  contractId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
  isStarred: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  rebateId: Scalars['String']['output'];
  rebatePeriodOffset: Scalars['Int']['output'];
  snoozeUntil?: Maybe<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
  topParentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
};

export type RebateOpportunityCardResult = {
  __typename?: 'RebateOpportunityCardResult';
  hits: Array<RebateOpportunityCardItem>;
  totalHits: Scalars['Int']['output'];
};

export type RebateOpportunityContractInfo = {
  __typename?: 'RebateOpportunityContractInfo';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
};

export type RebateOpportunityQueryInput = {
  contractCategory?: InputMaybe<Scalars['String']['input']>;
  curvoCategory?: InputMaybe<Scalars['String']['input']>;
  likelihoodStatus?: InputMaybe<RebateLikelihoodStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** If set, use no limit and offset */
  noLimit?: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RebateOpportunityQueryOrderby>;
  /** Filters on rebateInfo.type */
  rebateType?: InputMaybe<Scalars['String']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showStarOnly?: InputMaybe<Scalars['Boolean']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export enum RebateOpportunityQueryOrderby {
  Impact = 'Impact',
  Likelihood = 'Likelihood'
}

export type RebateOpportunityRebateInfo = {
  __typename?: 'RebateOpportunityRebateInfo';
  baselineSpend?: Maybe<Array<Scalars['Float']['output']>>;
  metricType: TierRuleMetricType;
  name: Scalars['String']['output'];
  payoutLevel?: Maybe<Scalars['String']['output']>;
  rebateperiodlength?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<TierRuleScope>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Scalars['Float']['output']>>;
};

export type RebateOpportunityStats = {
  __typename?: 'RebateOpportunityStats';
  increaseVolumeTotalRebate: Scalars['Float']['output'];
  lockedInTotalRebate: Scalars['Float']['output'];
  onTrackTotalRebate: Scalars['Float']['output'];
  openTotalRebate: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  vendorShiftTotalRebate: Scalars['Float']['output'];
};

export type RebateOpportunityStatsInput = {
  contractCategory?: InputMaybe<Scalars['String']['input']>;
  curvoCategory?: InputMaybe<Scalars['String']['input']>;
  /** Filters on rebateInfo.type */
  rebateType?: InputMaybe<Scalars['String']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showStarOnly?: InputMaybe<Scalars['Boolean']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export type RebatePeriodActual = {
  __typename?: 'RebatePeriodActual';
  actualReceived: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  evidenceDocs?: Maybe<Scalars['JSON']['output']>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  paymentType: Scalars['String']['output'];
  rebateComplianceScorecard?: Maybe<RebateComplianceScorecard>;
  rebateId: Scalars['String']['output'];
  rebatePeriodOffset: Scalars['Int']['output'];
  receivedAt: Scalars['Date']['output'];
  startDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
  topParentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type RebatePeriodFilterTerms = {
  __typename?: 'RebatePeriodFilterTerms';
  endDate: Scalars['Date']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  rebateGroupId?: Maybe<Scalars['String']['output']>;
  rebateId: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
};

export enum RebatePeriodStatus {
  Closed = 'Closed',
  Open = 'Open'
}

export type RebateReconciliationItem = {
  __typename?: 'RebateReconciliationItem';
  contractId: Scalars['String']['output'];
  contractInfo: RebateOpportunityContractInfo;
  eligibleProjectedSpend: Scalars['Float']['output'];
  eligibleUnits: Scalars['Float']['output'];
  endDate: Scalars['Date']['output'];
  rebateId: Scalars['String']['output'];
  rebateInfo: RebateOpportunityRebateInfo;
  rebatePeriodOffset: Scalars['Int']['output'];
  rebateStatus: RebateRiskStatus;
  startDate: Scalars['Date']['output'];
  totalRebate: Scalars['Float']['output'];
};

export type RebateReconciliationStats = {
  __typename?: 'RebateReconciliationStats';
  /** Average Days to Collect */
  avgDTC?: Maybe<Scalars['Int']['output']>;
  collectionStatusBySupplier: Array<CollectionStatusBySupplier>;
  collectionStatusDistribution: Array<CollectionStatusDistribution>;
  collectionStatusMonthly: Array<CollectionStatusMonthly>;
  discrepancyCount: Scalars['Int']['output'];
  pendingCollectionCount: Scalars['Int']['output'];
  totalActualReceived: Scalars['Float']['output'];
  totalEarned: Scalars['Float']['output'];
};

export type RebateReconciliationStatsInput = {
  collectionStatus?: InputMaybe<RebateCollectionStatus>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  /** When false, excludes rebate periods with no eligible spend (eligibleprojectedspend IS NULL or 0) — keeps the KPIs in sync with the Reconciliation grid */
  includeNoEligibleSpend?: InputMaybe<Scalars['Boolean']['input']>;
  periodStatus: RebatePeriodStatus;
  /** Filters on rebateInfo.type */
  rebateType?: InputMaybe<Scalars['String']['input']>;
  riskStatus?: InputMaybe<RebateRiskStatus>;
  /** a.k.a manufacturer */
  supplier?: InputMaybe<Scalars['String']['input']>;
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export enum RebateRiskStatus {
  AtRisk = 'AtRisk',
  Earned = 'Earned',
  Missed = 'Missed',
  OnTrack = 'OnTrack'
}

export type RebateRuleStatus = {
  __typename?: 'RebateRuleStatus';
  basketIds?: Maybe<Array<Scalars['String']['output']>>;
  closeness?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  likelihoodScore?: Maybe<Scalars['Float']['output']>;
  likelihoodStatus: RebateLikelihoodStatus;
  metricType: TierRuleMetricType;
  operator: TierRuleOperator;
  periodType: TierRulePeriodType;
  projectedMarketShare?: Maybe<Scalars['Float']['output']>;
  projectedPurchaseVolume?: Maybe<Scalars['Float']['output']>;
  ruleHumanReadable?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
  ruleScope?: Maybe<TierRuleScope>;
  ruleType: TierRuleType;
  startDate?: Maybe<Scalars['Date']['output']>;
  valueFirst: Scalars['Float']['output'];
  valueSecond?: Maybe<Scalars['Float']['output']>;
  valueToValidate: Scalars['Float']['output'];
};

export type RebateRuleValidation = {
  __typename?: 'RebateRuleValidation';
  message: Scalars['String']['output'];
  rebateId: Scalars['String']['output'];
  rebateName: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type RebateSpendItem = {
  __typename?: 'RebateSpendItem';
  basketId?: Maybe<Scalars['String']['output']>;
  basketIds: Array<Scalars['String']['output']>;
  basketName?: Maybe<Scalars['String']['output']>;
  /** curvo_category */
  category?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  datepurchase: Scalars['Date']['output'];
  /** e_description */
  description?: Maybe<Scalars['String']['output']>;
  /** extprice */
  extprice?: Maybe<Scalars['Float']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  inRebateScope: Scalars['Boolean']['output'];
  /** e_manufacturer */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** e_mfgitem */
  mfgitem?: Maybe<Scalars['String']['output']>;
  offContract: Scalars['Boolean']['output'];
  qtypurchase: Scalars['Float']['output'];
  rebateEligible?: Maybe<Scalars['Boolean']['output']>;
  /** top_parent */
  topParentId?: Maybe<Scalars['String']['output']>;
  /** unitprice */
  unitprice?: Maybe<Scalars['Float']['output']>;
  /** e_vendor */
  vendor?: Maybe<Scalars['String']['output']>;
  /** e_venitem */
  venitem?: Maybe<Scalars['String']['output']>;
};

export type RebateSpendItemFilterTerms = {
  __typename?: 'RebateSpendItemFilterTerms';
  facilityFilterTerms?: Maybe<Array<FacilityFilterTerms>>;
  periods: Array<RebatePeriodFilterTerms>;
  rebateFilterTerms: Array<RebateFilterTerms>;
  tierFilterTerms: Array<RebateFilterTerms>;
  topParentFilterTerms?: Maybe<Array<TopParentFilterTerms>>;
};

export type RebateSpendItemResult = {
  __typename?: 'RebateSpendItemResult';
  hits: Array<RebateSpendItem>;
  totalHits: Scalars['Int']['output'];
};

export type RebateSpendItemsFilterTermsInput = {
  contractId: Scalars['String']['input'];
};

export type RebateSpendItemsInput = {
  contractId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rebateId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tierId: Scalars['String']['input'];
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export type RedeemOpportunityInput = {
  secretCode: Scalars['String']['input'];
};

export type RemoveBasketProductsInput = {
  addNegativeRule?: InputMaybe<Scalars['Boolean']['input']>;
  basketId: Scalars['String']['input'];
  products: Array<BasketProductInput>;
};

export type RemoveBasketProductsResponse = {
  __typename?: 'RemoveBasketProductsResponse';
  updateMetricsJobId: Scalars['String']['output'];
};

export type RemoveBasketSmartRulesInput = {
  basketId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};

export type RebateTierStat = {
  __typename?: 'RebateTierStat';
  /** Progress toward this tier as a ratio — uncapped, so an exceeded threshold reads above 1. */
  closeness?: Maybe<Scalars['Float']['output']>;
  /** True on the one tier that pays. */
  isSelectedTier: Scalars['Boolean']['output'];
  /** Plain string, not the enum: RebateLikelihoodStatus has no `Missed` member, and this array is ETL-written, so one unmapped status would fail serialisation for every card in the list. */
  likelihoodStatus?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
  rebateId: Scalars['String']['output'];
  riskStatus?: Maybe<Scalars['String']['output']>;
  ruleHumanReadable?: Maybe<Scalars['String']['output']>;
  /** This rung's own rules. Empty when the ETL wrote none, or wrote them unparseably. */
  ruleStats?: Maybe<Array<RebateTierRuleStat>>;
  tierIndex: Scalars['Int']['output'];
  tierLabel?: Maybe<Scalars['String']['output']>;
  /** Full payout at this tier, not the increment over the tier below. */
  totalRebate?: Maybe<Scalars['Float']['output']>;
  valid: Scalars['Boolean']['output'];
  value?: Maybe<Array<Scalars['Float']['output']>>;
};

export type RebateTierRuleStat = {
  __typename?: 'RebateTierRuleStat';
  closeness?: Maybe<Scalars['Float']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
  /** `TierRuleOperator` as a string: `greaterThan`, `between`, … */
  operator?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  ruleHumanReadable?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  /** The rule's first bound. For `between` this is the *lower* bound. */
  valueFirst?: Maybe<Scalars['Float']['output']>;
  /** Only set for `between` — the upper bound. */
  valueSecond?: Maybe<Scalars['Float']['output']>;
  valueToValidate?: Maybe<Scalars['Float']['output']>;
};

export type RemoveContractPartsInput = {
  tierIds: Array<Scalars['String']['input']>;
  tsIds: Array<Scalars['String']['input']>;
};

export type RemoveContractRebateGroupInput = {
  contractId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type RemoveContractTierInput = {
  contractsId: Scalars['String']['input'];
  tiersId: Scalars['String']['input'];
};

export type RemoveContractTierRebateInput = {
  contractsId: Scalars['String']['input'];
  rebateId: Scalars['String']['input'];
};

export type RemoveNetworkMemberInput = {
  id: Scalars['String']['input'];
};

export type RemoveOfferTierRebateInput = {
  /** List of rebate IDs to remove */
  rebateIds: Array<Scalars['String']['input']>;
};

export type RemoveOrganizationInput = {
  organizationsId: Scalars['String']['input'];
  usersId: Scalars['String']['input'];
};

export type RemoveOrganizationTypeInput = {
  id: Scalars['String']['input'];
};

export type RemoveRebateEvidenceDocInput = {
  contractId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  rebateId: Scalars['String']['input'];
  rebatePeriodOffset: Scalars['Int']['input'];
  /** The s3Url of the evidence doc to remove */
  s3Url: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
  tierId: Scalars['String']['input'];
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveSourcingPlanBasketInput = {
  id: Scalars['String']['input'];
  sourcingPlanId: Scalars['String']['input'];
};

export type RemoveSourcingPlanBasketStakeholderInput = {
  /** `SourcingPlanBasketStakeholders` ID */
  id: Scalars['String']['input'];
  /** Force to remove associated `Contact`, cannot remove associated `User` */
  removeContact?: InputMaybe<Scalars['Boolean']['input']>;
  sourcingPlanId: Scalars['String']['input'];
};

export type RemoveSourcingPlanStakeholderInput = {
  /** `SourcingPlanStakeholder` ID */
  id: Scalars['String']['input'];
  /** Force to remove associated `Contact`, cannot remove associated `User` */
  removeContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveUserInput = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ReopenOfferInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  offerId: Scalars['String']['input'];
};

export type RequestCategoryConsultInput = {
  id: Scalars['String']['input'];
  request: CategoryConsultRequestInput;
};

export type ResendInviteInput = {
  invitingVendorId: Scalars['String']['input'];
  opportunityId: Scalars['String']['input'];
};

export type RestoredCrossReferencePairs = {
  __typename?: 'RestoredCrossReferencePairs';
  /** No crosses removed because a restored contract item has a cross again (D11). */
  noCrossReversed: Scalars['Int']['output'];
  restored: Scalars['Int']['output'];
  /** Crosses not put back: their items are in the list again, or they weren't deleted by the organization. */
  skipped: Scalars['Int']['output'];
};

export type RetryOpportunityInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
};

export enum RuleSignEnum {
  Between = 'between',
  Equal = 'equal',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotEqual = 'notEqual'
}

export type S3UploadGeneratedUrl = {
  __typename?: 'S3UploadGeneratedUrl';
  /** Full https URL of the final object (set when uploading to a fixed path). */
  fileUrl?: Maybe<Scalars['String']['output']>;
  hiddenInputs: Scalars['JSON']['output'];
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type SaveCrossReferenceMaps = {
  /** If this parameter is null, the System will try to use the System Generated List */
  crossReferenceListId?: InputMaybe<Scalars['String']['input']>;
  /** If true, overwrite other conflicts, otherwise throw an error */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  pack?: InputMaybe<Array<CatalogPartPackInput>>;
  parts: Array<SaveCrossReferenceMapsPart>;
  vendorItemTsId?: InputMaybe<Scalars['String']['input']>;
};

/** The Part information, one of `masterId`, `tsId` or `raw` is required */
export type SaveCrossReferenceMapsPart = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Elasticsearch Id of the Part */
  masterId?: InputMaybe<Scalars['String']['input']>;
  noCross?: InputMaybe<OfferItemComment>;
  /** Raw Part information */
  raw?: InputMaybe<SaveCrossReferenceMapsPartRaw>;
  /** TsId of the input Part */
  tsId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CrossReferenceType>;
};

export type SaveCrossReferenceMapsPartRaw = {
  description?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerItem?: InputMaybe<Scalars['String']['input']>;
};

export type SavedMapping = {
  __typename?: 'SavedMapping';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  mappedFields: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: MappingTypesEnum;
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type SavedMappingList = {
  __typename?: 'SavedMappingList';
  data: Array<SavedMapping>;
};

export type SavedSearch = {
  __typename?: 'SavedSearch';
  advancedSearch?: Maybe<Array<AdvancedSearchGroupObj>>;
  createdAt: Scalars['Date']['output'];
  grouping?: Maybe<Array<GroupField>>;
  id: Scalars['ID']['output'];
  isRecent: Scalars['Boolean']['output'];
  jsonAdvancedSearch: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pin: Scalars['Boolean']['output'];
  resultCount: Scalars['Int']['output'];
  searchFields: Array<ColumnAttributes>;
  searchText: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type SavedSearchesInput = {
  isRecent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScenarioStats = {
  __typename?: 'ScenarioStats';
  basketTierStats: Array<ScenarioStatsTierBasket>;
  convertedItems: Scalars['Int']['output'];
  coveredItems: Scalars['Int']['output'];
  estimatedRebate: Scalars['Float']['output'];
  excludedItems: Scalars['Int']['output'];
  excludedSpend: Scalars['Float']['output'];
  pricingTarget: Scalars['Float']['output'];
  savings: Scalars['Float']['output'];
  tierStats: Array<ScenarioStatsTier>;
  totalIncumbentSpend: Scalars['Float']['output'];
  totalIncumbentUnits: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalProjectedSpend: Scalars['Float']['output'];
  totalSpendAfterRebate: Scalars['Float']['output'];
  uncoveredItems: Scalars['Int']['output'];
  validateTiers: Array<TierValidation>;
};

export type ScenarioStatsTier = {
  __typename?: 'ScenarioStatsTier';
  /** Total Spend from the opportunity for items which this tier covers */
  coveredIncumbentSpend: Scalars['Float']['output'];
  coveredItems: Scalars['Int']['output'];
  coveredUnits: Scalars['Int']['output'];
  excludedItems: Scalars['Int']['output'];
  pricingScore?: Maybe<Scalars['Float']['output']>;
  rebateStats: Array<TierRebateStats>;
  remainingCoveredUnits: Scalars['Float']['output'];
  remainingCurrentSpend: Scalars['Float']['output'];
  remainingIncumbentSavings: Scalars['Float']['output'];
  remainingIncumbentSpend: Scalars['Float']['output'];
  remainingIncumbentUnits: Scalars['Float']['output'];
  remainingTotalProjectedSavings: Scalars['Float']['output'];
  remainingTotalProjectedSpend: Scalars['Float']['output'];
  tierId: Scalars['String']['output'];
  /** Total offered price from this tier */
  totalProjectedSpend: Scalars['Float']['output'];
};

export type ScenarioStatsTierBasket = {
  __typename?: 'ScenarioStatsTierBasket';
  basketId: Scalars['String']['output'];
  /** Total Spend from the opportunity for items which this tier covers */
  coveredIncumbentSpend: Scalars['Float']['output'];
  coveredItems: Scalars['Int']['output'];
  coveredUnits: Scalars['Int']['output'];
  pricingScore?: Maybe<Scalars['Float']['output']>;
  tierId: Scalars['String']['output'];
  totalItems: Scalars['Float']['output'];
  /** Total offered price from this tier */
  totalProjectedSpend: Scalars['Float']['output'];
};

export type ScenarioTierConversionBreakdown = {
  __typename?: 'ScenarioTierConversionBreakdown';
  /** Current total spend in opportunity items */
  currentIncumbentSpend: Scalars['Float']['output'];
  /** Amount of savings compare to Projected Spend from opportunity items */
  projectedSavings: Scalars['Float']['output'];
  scenarioId: Scalars['String']['output'];
  tierId: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
};

export enum ScenarioTierType {
  Converted = 'Converted',
  Covered = 'Covered',
  Incumbent = 'Incumbent'
}

export type SearchBasket = {
  __typename?: 'SearchBasket';
  name: Scalars['String']['output'];
  numItems: Scalars['Float']['output'];
};

export type SearchBasketResult = {
  __typename?: 'SearchBasketResult';
  hits: Array<SearchBasket>;
  totalHits: Scalars['Int']['output'];
};

export type SearchByUploadedSearchIdInput = {
  includeAggs?: InputMaybe<IncludeAggsEnum>;
  searchFields: Array<ColumnAttributesInput>;
  uploadedSearchId: Scalars['String']['input'];
};

export type SearchByUploadedSearchIdResult = {
  __typename?: 'SearchByUploadedSearchIdResult';
  hits: Array<AggregatedItemSpend>;
  searchFieldsFilterTerms: Array<SearchFieldFilterTerms>;
  totalHits: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
};

export enum SearchField {
  ActualImpact = 'actualImpact',
  Benchmarks = 'benchmarks',
  ContactDate = 'contactDate',
  Contract = 'contract',
  CurrentPrice = 'currentPrice',
  CurvoCategory = 'curvoCategory',
  Description = 'description',
  EsDescription = 'esDescription',
  EsProductNormalized = 'esProductNormalized',
  EsSupplierNormalized = 'esSupplierNormalized',
  EsUoM = 'esUoM',
  EsVendorItemNormalized = 'esVendorItemNormalized',
  EsVendorNormalized = 'esVendorNormalized',
  Facility = 'facility',
  FacilityItem = 'facilityItem',
  FacilityName = 'facilityName',
  FdaCodeName = 'fdaCodeName',
  GicId = 'gicId',
  Gmdn = 'gmdn',
  Impact3m = 'impact3m',
  Impact12m = 'impact12m',
  L12mBenchmarks = 'l12mBenchmarks',
  LastPurchase = 'lastPurchase',
  LastPurchaseDate = 'lastPurchaseDate',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  MarketTrends = 'marketTrends',
  MarkupAdjusted12MSpend = 'markupAdjusted12MSpend',
  MarkupAdjustedPrice = 'markupAdjustedPrice',
  MasterMatched = 'masterMatched',
  MatchId = 'matchId',
  Month = 'month',
  Opportunities = 'opportunities',
  Organization = 'organization',
  OrganizationItem = 'organizationItem',
  PoNums = 'poNums',
  PricingTrends = 'pricingTrends',
  SubmittedCategory = 'submittedCategory',
  SubmittedSubcategory = 'submittedSubcategory',
  ToLastPurchaseDays = 'toLastPurchaseDays',
  TopOpportunity = 'topOpportunity',
  TopParentName = 'topParentName',
  TotalQuantity = 'totalQuantity',
  TotalSpend = 'totalSpend',
  Trend = 'trend',
  TypeOne = 'typeOne',
  TypeTwo = 'typeTwo',
  Unspsc = 'unspsc',
  UnspscClass = 'unspscClass',
  UnspscClassCode = 'unspscClassCode',
  UnspscCommodity = 'unspscCommodity',
  UnspscCommodityCode = 'unspscCommodityCode',
  UnspscFamily = 'unspscFamily',
  UnspscFamilyCode = 'unspscFamilyCode',
  Uom = 'uom',
  UomConversion = 'uomConversion',
  Utilization = 'utilization',
  Vendor = 'vendor',
  VendorItem = 'vendorItem',
  Venitem = 'venitem'
}

export type SearchFieldFilterTerms = {
  __typename?: 'SearchFieldFilterTerms';
  field: SearchField;
  terms: Array<SearchFieldSuggestion>;
};

export type SearchFieldSuggestion = {
  __typename?: 'SearchFieldSuggestion';
  term: Scalars['String']['output'];
  totalHits: Scalars['Int']['output'];
};

export type SearchGmdnNameInput = {
  search: Scalars['String']['input'];
};

export type SearchGmdnNamesResponse = {
  __typename?: 'SearchGmdnNamesResponse';
  data: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SearchGudidBrandInput = {
  search: Scalars['String']['input'];
};

export type SearchGudidBrandsResponse = {
  __typename?: 'SearchGudidBrandsResponse';
  data: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SearchMasterCatalogByPartNumberInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerItem?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendorItem?: InputMaybe<Scalars['String']['input']>;
};

export type SearchNormalizedManufacturersInput = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  fullResponse: Scalars['Boolean']['output'];
  hits: Array<ItemSpend>;
  savedSearch?: Maybe<SavedSearch>;
  searchFieldsFilterTerms: Array<SearchFieldFilterTerms>;
  totalHits: Scalars['Int']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type SearchSubmittedCategoriesResponse = {
  __typename?: 'SearchSubmittedCategoriesResponse';
  data: Array<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SearchSubmittedCategoryInput = {
  search: Scalars['String']['input'];
};

export type SearchUnspscCommodityResponse = {
  __typename?: 'SearchUnspscCommodityResponse';
  data: Array<UnspscCommodity>;
  total: Scalars['Int']['output'];
};

export type SearchUnspscInput = {
  search: Scalars['String']['input'];
};

export type SendBasketStakeholdersSurveyInput = {
  basketId: Scalars['String']['input'];
  /** `SourcingPlan`'s ID */
  sourcingPlanId: Scalars['String']['input'];
  /** Stakeholder IDs */
  stakeholderIds: Array<Scalars['String']['input']>;
};

export type SendSourcingPlanStakeholdersSurveyInput = {
  /** `SourcingPlan`'s ID */
  sourcingPlanId: Scalars['String']['input'];
  /** Stakeholder IDs */
  stakeholderIds: Array<Scalars['String']['input']>;
};

export type SetContractCrossReferenceListsInput = {
  contractId: Scalars['ID']['input'];
  /** Required, non-empty, for specific mode; ignored otherwise. */
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode: ContractCrossReferenceMode;
};

export type SetNormalizedManufacturerInput = {
  customerId: Scalars['String']['input'];
  normalizedManufacturer: Scalars['String']['input'];
};

export type SharedSupplierUser = {
  __typename?: 'SharedSupplierUser';
  appianId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type SharedSupplierUserInfo = {
  __typename?: 'SharedSupplierUserInfo';
  type: AcTypeEnum;
  user: SharedSupplierUser;
};

export type SharedUser = {
  __typename?: 'SharedUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type SharedUserInfo = {
  __typename?: 'SharedUserInfo';
  type: AcTypeEnum;
  user: SharedUser;
  validationError?: Maybe<Scalars['String']['output']>;
};

export type SimilarProduct = {
  __typename?: 'SimilarProduct';
  benchmarks?: Maybe<Benchmark>;
  description?: Maybe<Scalars['String']['output']>;
  gicId?: Maybe<Scalars['String']['output']>;
  gudid?: Maybe<Scalars['String']['output']>;
  gudidBrand?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  purchasedByFacilities: Array<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  submissionNumber?: Maybe<Scalars['String']['output']>;
  totalSpend?: Maybe<Scalars['Float']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  uomConversion?: Maybe<Scalars['String']['output']>;
};

export type SimilarProductResult = {
  __typename?: 'SimilarProductResult';
  hits: Array<SimilarProduct>;
  suggestions?: Maybe<Scalars['String']['output']>;
  totalHit: Scalars['Int']['output'];
};

export type SimilarProductsInput = {
  /** Extended use graph clustered 510k data to cross with not only direct 510k items but all 510k items connected in the cluster */
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  gudid: Scalars['String']['input'];
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Use OpenAI to select the 10 best suggestions */
  useAI?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SimilarProductsManufacturersInput = {
  gudid: Scalars['String']['input'];
};

export type SingleOpportunityAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachment ID */
  id: Scalars['String']['input'];
  /** Inviting Vendor Ids, use this for Vendors specific attachments */
  invitingVendorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};

export type SmartBasket = {
  __typename?: 'SmartBasket';
  basket: Basket;
  hits: Array<ItemSpend>;
  updateMetricsJobId?: Maybe<Scalars['String']['output']>;
};

export type SmartBasketConfig = {
  __typename?: 'SmartBasketConfig';
  allowOverwrite?: Maybe<Scalars['Boolean']['output']>;
  excludedFacilityIds?: Maybe<Array<Scalars['Int']['output']>>;
  excludedFacilityTopParentIds?: Maybe<Array<Scalars['String']['output']>>;
  facilityIds?: Maybe<Array<Scalars['Int']['output']>>;
  facilityTopParentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Glue Job Run Id that running the refresh basket products job. */
  glueJobId?: Maybe<Scalars['String']['output']>;
  glueJobRunFinishedAt?: Maybe<Scalars['Date']['output']>;
  glueJobRunStatus?: Maybe<Scalars['String']['output']>;
  skipAddingSimilarProducts?: Maybe<Scalars['Boolean']['output']>;
};

export type SmartBasketConfigInput = {
  allowOverwrite?: InputMaybe<Scalars['Boolean']['input']>;
  excludedFacilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludedFacilityTopParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  facilityTopParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  skipAddingSimilarProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmartBasketRule = {
  __typename?: 'SmartBasketRule';
  field: SearchField;
  secondValue?: Maybe<Scalars['String']['output']>;
  sign: RuleSignEnum;
  value: Scalars['String']['output'];
};

export type SmartBasketRuleInput = {
  field: SearchField;
  secondValue?: InputMaybe<Scalars['String']['input']>;
  sign: RuleSignEnum;
  value: Scalars['String']['input'];
};

export type SmartRule = {
  __typename?: 'SmartRule';
  basket?: Maybe<Basket>;
  basketId: Scalars['String']['output'];
  commodityId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  customer?: Maybe<Customer>;
  customerId: Scalars['String']['output'];
  gic?: Maybe<Gic>;
  gicTypeOneTypeTwo?: Maybe<Scalars['String']['output']>;
  gmdnName?: Maybe<Scalars['String']['output']>;
  gudidBrand?: Maybe<Scalars['String']['output']>;
  gudidId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerItem?: Maybe<Scalars['String']['output']>;
  negative: Scalars['Boolean']['output'];
  stanId?: Maybe<Scalars['String']['output']>;
  submittedCategory?: Maybe<Scalars['String']['output']>;
  submittedSubcategory?: Maybe<Scalars['String']['output']>;
  tsId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  typeOne?: Maybe<GicTypeOne>;
  typeTwo?: Maybe<GicTypeOne>;
  unspscClassTitle?: Maybe<Scalars['String']['output']>;
  unspscClassTitleDesc?: Maybe<Scalars['String']['output']>;
  unspscCommodityCode?: Maybe<Scalars['String']['output']>;
  unspscCommodityTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
  vendorItem?: Maybe<Scalars['String']['output']>;
};

export enum SmartRuleField {
  CommodityId = 'commodityId',
  GicTypeOneTypeTwo = 'gicTypeOneTypeTwo',
  GmdnName = 'gmdnName',
  GudidBrand = 'gudidBrand',
  GudidId = 'gudidId',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  StanId = 'stanId',
  SubmittedCategory = 'submittedCategory',
  SubmittedSubcategory = 'submittedSubcategory',
  TsId = 'tsId',
  UnspscClassTitle = 'unspscClassTitle',
  UnspscCommodityCode = 'unspscCommodityCode',
  Vendor = 'vendor',
  VendorItem = 'vendorItem'
}

export type SnoozeSourcingPlanInput = {
  basketId: Scalars['String']['input'];
  /** Specify number of days that the Sourcing Plan should not be available, Unit: day, set it to null to disable snooze */
  snoozeDateCount?: InputMaybe<Scalars['Int']['input']>;
  sourcingPlanId?: InputMaybe<Scalars['String']['input']>;
};

export type Sort = {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type SourcingPlan = {
  __typename?: 'SourcingPlan';
  author?: Maybe<User>;
  authorId: Scalars['String']['output'];
  /** Get sourcing plan baskets by sourcing plan ID. */
  baskets: Array<SourcingPlanBasket>;
  customer?: Maybe<Customer>;
  customerId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  savingsGoal?: Maybe<Scalars['Float']['output']>;
  sharedUsers: Array<Acl>;
  /** Get all stakeholders by sourcing plan ID. */
  stakeholders: Array<SourcingPlanStakeHolder>;
  status: SourcingPlanStatus;
  support?: Maybe<SourcingPlanSupport>;
  targetCompletion?: Maybe<Scalars['Date']['output']>;
  targetStart?: Maybe<Scalars['Date']['output']>;
};


export type SourcingPlanBasketsArgs = {
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represent a `SourcingPlan`'s `Category`. Basically a `Basket` wrapper with `targetSpend` and `targetSavings` */
export type SourcingPlanBasket = {
  __typename?: 'SourcingPlanBasket';
  basket: Basket;
  basketId: Scalars['String']['output'];
  creator?: Maybe<User>;
  customer?: Maybe<Customer>;
  /** Hide this Category in Recommendation list (Top Savings Categories) */
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  pin?: Maybe<Scalars['Boolean']['output']>;
  /** Snooze this Category in Recommendation list (Top Savings Categories) */
  snoozeToDate?: Maybe<Scalars['Date']['output']>;
  sourcingPlan?: Maybe<SourcingPlan>;
  sourcingPlanId?: Maybe<Scalars['String']['output']>;
  support: SourcingPlanBasketSupport;
  targetSavings?: Maybe<Scalars['Float']['output']>;
  targetSpend?: Maybe<Scalars['Float']['output']>;
  /** Total spend of basket's products in last 12 months */
  totalSpend?: Maybe<Scalars['Float']['output']>;
  type: SourcingPlanBasketType;
};

/** A wrapper Object type represents either a `Basket` or a `SourcingPlanBasket`, if it' a `Basket` then the `sourcingPlanBasket` field is null, if it' a `SourcingPlanBasket`, the `basket` field will contains basket information from `SourcingPlanBasket` */
export type SourcingPlanBasketBase = {
  __typename?: 'SourcingPlanBasketBase';
  /** Get the `active` `CategoryConsultRequest`. */
  activeConsultRequest?: Maybe<CategoryConsultRequest>;
  basket: Basket;
  inProgressSourcingPlan?: Maybe<SourcingPlan>;
  sourcingPlanBasket?: Maybe<SourcingPlanBasket>;
  /** Draft and InProgress Sourcing Plans are using this Basket */
  sourcingPlans?: Maybe<Array<SourcingPlan>>;
  stakeholders: Array<SourcingPlanBasketsStakeholders>;
};

export type SourcingPlanBasketSort = {
  direction?: OrderDirection;
  field: BasketSortEnum;
};

export enum SourcingPlanBasketSupport {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Unverified = 'Unverified'
}

export enum SourcingPlanBasketType {
  Contract = 'contract',
  Curvo = 'curvo',
  Custom = 'custom'
}

export type SourcingPlanBasketsQueryInput = {
  basketType?: InputMaybe<BasketType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set this to false to hide categories already enrolled in active sourcing plans */
  showInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  showSnooze?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SourcingPlanBasketSort>;
};

export type SourcingPlanBasketsStakeholders = {
  __typename?: 'SourcingPlanBasketsStakeholders';
  contact?: Maybe<Contact>;
  id: Scalars['ID']['output'];
  role: SourcingPlanStakeholderRole;
  sourcingPlanBasket?: Maybe<SourcingPlanBasket>;
  sourcingPlanBasketId: Scalars['String']['output'];
  support?: Maybe<Scalars['Boolean']['output']>;
  supportDate?: Maybe<Scalars['Date']['output']>;
  supportSurveyDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
};

export enum SourcingPlanOwnerEnum {
  Mine = 'Mine',
  Shared = 'Shared'
}

/** Contain stakeholder information of a `SourcingPlan`, the contact information comes from either a `Contact` or a `User`, not both */
export type SourcingPlanStakeHolder = {
  __typename?: 'SourcingPlanStakeHolder';
  /** Return the associated `Contact` if available, if not return associated `User` information instead */
  contact: Contact;
  id: Scalars['ID']['output'];
  role: SourcingPlanStakeholderRole;
  sourcingPlan?: Maybe<SourcingPlan>;
  sourcingPlanId?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['Boolean']['output']>;
  supportDate?: Maybe<Scalars['Date']['output']>;
  supportSurveyDate?: Maybe<Scalars['Date']['output']>;
  /** Return the associated `User` if available */
  user?: Maybe<User>;
};

export enum SourcingPlanStakeholderRole {
  DepartmentLeader = 'departmentLeader',
  ExecutiveLeader = 'executiveLeader',
  Other = 'other',
  PhysicianLeader = 'physicianLeader',
  SubjectMatterExpert = 'subjectMatterExpert'
}

export enum SourcingPlanStatus {
  Archived = 'archived',
  Draft = 'draft',
  Finished = 'finished',
  InProgress = 'inProgress'
}

export type SourcingPlanSupplier = {
  __typename?: 'SourcingPlanSupplier';
  coverage?: Maybe<Scalars['Float']['output']>;
  estSavings: Scalars['Float']['output'];
  isIncumbent: Scalars['Boolean']['output'];
  isSuggested: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numItems: Scalars['Float']['output'];
  spend: Scalars['Float']['output'];
  totalQty: Scalars['Float']['output'];
};

export type SourcingPlanSuppliers = {
  __typename?: 'SourcingPlanSuppliers';
  suppliers?: Maybe<Array<SourcingPlanSupplier>>;
  targetPercentile?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SourcingPlanSupport {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Unverified = 'Unverified'
}

export type SourcingPlanTopIncumbent = {
  __typename?: 'SourcingPlanTopIncumbent';
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type SpendDataForVendorsResult = {
  __typename?: 'SpendDataForVendorsResult';
  case_id?: Maybe<Scalars['String']['output']>;
  construct_group?: Maybe<Scalars['String']['output']>;
  construct_name?: Maybe<Scalars['String']['output']>;
  curvo_category?: Maybe<Scalars['String']['output']>;
  customer_id: Scalars['String']['output'];
  customer_name: Scalars['String']['output'];
  facility_id: Scalars['String']['output'];
  facility_name: Scalars['String']['output'];
  gudid_brand_name?: Maybe<Scalars['String']['output']>;
  gudid_gmdn_name?: Maybe<Scalars['String']['output']>;
  iqo25?: Maybe<Scalars['Float']['output']>;
  iqo50?: Maybe<Scalars['Float']['output']>;
  iqo75?: Maybe<Scalars['Float']['output']>;
  iqo90?: Maybe<Scalars['Float']['output']>;
  manufacturer: Scalars['String']['output'];
  manufacturer_item: Scalars['String']['output'];
  procedure_type?: Maybe<Scalars['String']['output']>;
  qtypurchase: Scalars['Float']['output'];
  stan_brand?: Maybe<Scalars['String']['output']>;
  stan_gic_id?: Maybe<Scalars['String']['output']>;
  stan_gic_name?: Maybe<Scalars['String']['output']>;
  stan_product_line?: Maybe<Scalars['String']['output']>;
  stan_type_one?: Maybe<Scalars['String']['output']>;
  stan_type_two?: Maybe<Scalars['String']['output']>;
  surgeon?: Maybe<Scalars['String']['output']>;
  uom: Scalars['String']['output'];
  uom_conversion: Scalars['String']['output'];
};

export type SpendDateRange = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};

export type SpendDateRangeInput = {
  dateRange?: InputMaybe<BasketSpendDateRanges>;
  spendDateRange?: InputMaybe<SpendDateRange>;
};

export type SpendDateRangeSearch = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
};

export type SpendDateRangeSearchInput = {
  spendDateRange?: InputMaybe<SpendDateRangeSearch>;
};

export type StanBaseData = {
  __typename?: 'StanBaseData';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StanPart = {
  __typename?: 'StanPart';
  id?: Maybe<Scalars['String']['output']>;
  partName?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
};

export type StartSourcingPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  savingsGoal: Scalars['Float']['input'];
  sharedUsers?: InputMaybe<Array<BaseAclRecordInput>>;
  targetCompletion: Scalars['Date']['input'];
  targetStart: Scalars['Date']['input'];
};

export type StudiesGetInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Array<StudyFileTypeEnum>>;
  importedFrom?: InputMaybe<Scalars['Date']['input']>;
  importedTo?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<StudyStatusEnum>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type StudiesGetResult = {
  __typename?: 'StudiesGetResult';
  hits: Array<QueuedStudy>;
  totalHits: Scalars['Int']['output'];
};

export type StudiesTransactionsCountInput = {
  masterGroup?: InputMaybe<ConstructMasterGroup>;
  studyId: Scalars['Int']['input'];
};

export type StudiesTransactionsGetInput = {
  datePurchaseFrom?: InputMaybe<Scalars['Date']['input']>;
  datePurchaseTo?: InputMaybe<Scalars['Date']['input']>;
  manufacturerType?: InputMaybe<ManufacturerType>;
  poNum?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StudyTransactionState>;
  studyId: Scalars['Int']['input'];
};

export enum StudyFileTypeEnum {
  Contract = 'Contract',
  Epic = 'EPIC',
  Other = 'Other',
  XRef = 'XRef'
}

/** Study Catalog Enum */
export enum StudyLinkCatalogEnum {
  Gudid = 'gudid',
  Medline = 'medline',
  Stan = 'stan'
}

export type StudyLinksQueryArgs = {
  catalog?: InputMaybe<StudyLinkCatalogEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  manufacturerType?: InputMaybe<ManufacturerType>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<StudyTransactionState>;
  studyId: Scalars['Int']['input'];
};

export enum StudyStatusEnum {
  Archived = 'Archived',
  Archiving = 'Archiving',
  AutoLinking = 'AutoLinking',
  AutoMatching = 'AutoMatching',
  CaseReview = 'CaseReview',
  Committing = 'Committing',
  CommittingCase = 'CommittingCase',
  Completed = 'Completed',
  Failed = 'Failed',
  Grooming = 'Grooming',
  Linking = 'Linking',
  New = 'New',
  QueuedAutoMatching = 'QueuedAutoMatching',
  QueuedForCommitting = 'QueuedForCommitting',
  QueuedForGrooming2 = 'QueuedForGrooming2',
  QueuedForPushingToGrooming1 = 'QueuedForPushingToGrooming1',
  Submitted = 'Submitted'
}

/** Study Transaction processing state */
export enum StudyTransactionState {
  BamfMatching = 'bamfMatching',
  BlacklistStrippedItem = 'blacklistStrippedItem',
  BlacklistSupplier = 'blacklistSupplier',
  CaseReview = 'caseReview',
  CaseReviewDetail = 'caseReviewDetail',
  Conflict = 'conflict',
  FinalReview = 'finalReview',
  Hidden = 'hidden',
  IgnoreRow = 'ignoreRow',
  IgnoreSupplier = 'ignoreSupplier',
  SupplierMatching = 'supplierMatching',
  TwinApproved = 'twinApproved',
  TwinMatch = 'twinMatch'
}

export type SubmitContractInput = {
  id: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  exportedSearch: ExportEventResultType;
  studyUpdated: QueuedStudy;
  updatedJob: UploadJob;
  uploadSearch: DoUploadSearchResult;
  uploadedBasket: ProcessedBasketResult;
};


export type SubscriptionExportedSearchArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionStudyUpdatedArgs = {
  id: Scalars['Int']['input'];
};


export type SubscriptionUpdatedJobArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionUploadSearchArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionUploadedBasketArgs = {
  id: Scalars['String']['input'];
};

export type SuggestedVendorsResult = {
  __typename?: 'SuggestedVendorsResult';
  hits: Array<CustomerView>;
  totalHits: Scalars['Int']['output'];
};

/** Cross Reference Maps grouped by a vendor Product TsId (`xrefTsId`) */
export type SupplierCrossReference = {
  __typename?: 'SupplierCrossReference';
  /** No-Cross type */
  comment?: Maybe<OfferItemComment>;
  crossReferenceListId: Scalars['String']['output'];
  crossStatus: Scalars['Boolean']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  /** List of mappings, might be sliced if `mappingsLimit` is set */
  mappings: Array<CrossReferenceMap>;
  /** Mappings count in case `mappingsLimit` is set and not returning all mappings */
  mappingsCount: Scalars['Int']['output'];
  /** No-Cross comment */
  noCrossComment?: Maybe<Scalars['String']['output']>;
  xrefCatalogPart?: Maybe<CatalogPart>;
  xrefTsId?: Maybe<Scalars['String']['output']>;
};

export type SupplierCrossReferenceResult = {
  __typename?: 'SupplierCrossReferenceResult';
  hits: Array<SupplierCrossReference>;
  totalHits: Scalars['Int']['output'];
};

export enum SupplierCrossReferenceSearchField {
  CrossDescription = 'crossDescription',
  CrossManufacturer = 'crossManufacturer',
  CrossManufacturerItem = 'crossManufacturerItem',
  Description = 'description',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem'
}

export type SupplierCrossReferenceSearchOnField = {
  searchOnField: SupplierCrossReferenceSearchField;
  searchText: Scalars['String']['input'];
};

export enum SupplierCrossReferenceSortField {
  Category = 'category',
  CrossCategory = 'crossCategory',
  CrossDescription = 'crossDescription',
  CrossGicId = 'crossGicId',
  CrossGicName = 'crossGicName',
  CrossGmdn = 'crossGmdn',
  CrossManufacturer = 'crossManufacturer',
  CrossManufacturerItem = 'crossManufacturerItem',
  CrossMaterialId = 'crossMaterialId',
  CrossSizeOne = 'crossSizeOne',
  CrossSizeThree = 'crossSizeThree',
  CrossSizeTwo = 'crossSizeTwo',
  CrossSubCategory = 'crossSubCategory',
  CrossTypeOneName = 'crossTypeOneName',
  CrossTypeTwoName = 'crossTypeTwoName',
  Description = 'description',
  GicId = 'gicId',
  GicName = 'gicName',
  Gmdn = 'gmdn',
  Manufacturer = 'manufacturer',
  ManufacturerItem = 'manufacturerItem',
  MaterialId = 'materialId',
  SizeOne = 'sizeOne',
  SizeThree = 'sizeThree',
  SizeTwo = 'sizeTwo',
  SubCategory = 'subCategory',
  Type = 'type',
  TypeOneName = 'typeOneName',
  TypeTwoName = 'typeTwoName',
  UpdatedAt = 'updatedAt'
}

export type SupplierCrossReferencesSortInput = {
  direction?: InputMaybe<OrderDirection>;
  field: SupplierCrossReferenceSortField;
};

/** In case the hospital is provided by the customer (i.e., the hospital shares the same customerId), the customerId field is an empty string */
export type SupplierHospital = {
  __typename?: 'SupplierHospital';
  customerId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<OpportunityProvider>;
};

/** A hospital could consist of both customerId and name or just name (in which case customerId is an empty string) */
export type SupplierHospitalInput = {
  customerId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierOpportunitiesInput = {
  hospital?: InputMaybe<SupplierHospitalInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossRequest?: InputMaybe<Scalars['Boolean']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  isMissedDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  opportunityStatus?: InputMaybe<OppotunityStatusEnum>;
  requestNumber?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  supplierStatus?: InputMaybe<OpportunitySupplierStatusEnum>;
};

export type SupplierOpportunitiesResult = {
  __typename?: 'SupplierOpportunitiesResult';
  hits: Array<SupplierOpportunity>;
  totalHits: Scalars['Float']['output'];
};

export type SupplierOpportunity = {
  __typename?: 'SupplierOpportunity';
  acl: Array<SharedSupplierUserInfo>;
  adminSupplierStatus: OpportunitySupplierStatusEnum;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  export: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchivedOpportunity: Scalars['Boolean']['output'];
  isManual: Scalars['Boolean']['output'];
  keyContact?: Maybe<OpportunityKeyContact>;
  name?: Maybe<Scalars['String']['output']>;
  numberSKU?: Maybe<Scalars['Int']['output']>;
  offers: OfferResult;
  opportunityAttachment: OpportunityAttachment;
  opportunityAttachments: Array<OpportunityAttachment>;
  parentStatus?: Maybe<OppotunityStatusEnum>;
  provider?: Maybe<OpportunityProvider>;
  status: OfferStatusEnum;
  supplierStatus: OpportunitySupplierStatusEnum;
  uniqueNumberSku: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  vendorCustomerId: Scalars['String']['output'];
};


export type SupplierOpportunityAdminSupplierStatusArgs = {
  customerId: Scalars['String']['input'];
};


export type SupplierOpportunityExportArgs = {
  selectedFields: Array<OfferItemExportsFieldEnum>;
};


export type SupplierOpportunityOffersArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Sort>;
};


export type SupplierOpportunityOpportunityAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type SupplierOpportunityOpportunityAttachmentsArgs = {
  uploadedBy?: InputMaybe<AttachmentUploadedFrom>;
};

export enum SupplierSectionEnum {
  Catalog = 'catalog',
  Crosses = 'crosses',
  Offer = 'offer'
}

export type SupportTicketInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SyncContractEnrichmentsInput = {
  enrichments: Array<ContractEnrichmentInput>;
};

export type SyncContractEnrichmentsResult = {
  __typename?: 'SyncContractEnrichmentsResult';
  applied: Scalars['Int']['output'];
  errors: Array<ContractEnrichmentError>;
  received: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type SyncCreateCustomerInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  broadJumpId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxUser: Scalars['Int']['input'];
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SyncCreateOrganizationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  broadJumpId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  classOfTradeId?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  customerIds: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  gpoFacilityId?: InputMaybe<Scalars['String']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationTypeId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SyncCurvoNormalization = {
  deleted: Scalars['Boolean']['input'];
  inputSupplier: Scalars['String']['input'];
  normalizedCurvo: Scalars['String']['input'];
};

export type SyncUpdateCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  broadJumpId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxUser?: InputMaybe<Scalars['Int']['input']>;
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SyncUpdateOrganizationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  broadJumpId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  classOfTradeId?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  gpoFacilityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationTypeId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type System = {
  __typename?: 'System';
  createdAt: Scalars['Date']['output'];
  creator: User;
  customer: Customer;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  parent?: Maybe<System>;
  updatedAt: Scalars['Date']['output'];
};

export type Tier = {
  __typename?: 'Tier';
  advancedRulesJsonLogic?: Maybe<Scalars['String']['output']>;
  /** Tier Rule Boolean operator, default to and */
  booleanOperator?: Maybe<TierRuleBooleanOperator>;
  catalogPartTiers: CatalogPartTierResult;
  catalogPartTiersPaginated: CatalogPartTierResult;
  children?: Maybe<Array<Tier>>;
  contracts: Array<ContractTier>;
  createdAt: Scalars['Date']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountMetric?: Maybe<TierRuleMetricType>;
  discountPeriod?: Maybe<TierRulePeriodType>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  effectiveDate?: Maybe<Scalars['DateOnly']['output']>;
  expirationDate?: Maybe<Scalars['DateOnly']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  offerId?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Tier>;
  parentId?: Maybe<Scalars['String']['output']>;
  readableRules: Scalars['String']['output'];
  /** @deprecated Migrated to dedicated rebate */
  rebate?: Maybe<TierRule>;
  rules?: Maybe<Array<TierRule>>;
  updatedAt: Scalars['Date']['output'];
};


export type TierCatalogPartTiersArgs = {
  pagination: Pagination;
};


export type TierCatalogPartTiersPaginatedArgs = {
  input?: InputMaybe<CatalogPartTiersFilterInput>;
  pagination: Pagination;
  sorts?: InputMaybe<Array<CatalogPartsSortInput>>;
};


export type TierReadableRulesArgs = {
  skipParent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TierRulesArgs = {
  skipParent?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TierFilterOperatorEnum {
  Between = 'between',
  Equal = 'equal',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  IsEmpty = 'isEmpty',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual'
}

export type TierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['Date']['input'];
  expirationDate: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TierMapping = {
  field: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type TierPriceFilterInput = {
  operator: TierFilterOperatorEnum;
  priceFirst?: InputMaybe<Scalars['Float']['input']>;
  priceSecond?: InputMaybe<Scalars['Float']['input']>;
  tierId: Scalars['String']['input'];
};

export type TierRebate = {
  __typename?: 'TierRebate';
  advancedRulesJsonLogic?: Maybe<Scalars['String']['output']>;
  advancedRulesJsonLogicAppian?: Maybe<Scalars['JSON']['output']>;
  advancedRulesJsonLogicObject?: Maybe<Scalars['JSON']['output']>;
  baselineSpend: Array<Scalars['Float']['output']>;
  conditionalStartDate: ConditionalStartDate;
  contract?: Maybe<Contract>;
  contractsId?: Maybe<Scalars['ID']['output']>;
  contractsTiersRebates: Array<ContractTierRebate>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateOnly']['output']>;
  expirationDate?: Maybe<Scalars['DateOnly']['output']>;
  humanReadableRebate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metricType: TierRebateMetricType;
  name: Scalars['String']['output'];
  offer?: Maybe<Offer>;
  offerId?: Maybe<Scalars['ID']['output']>;
  payoutLevel: TierRuleScope;
  periodType: TierRulePeriodType;
  productTsIds?: Maybe<Array<Scalars['String']['output']>>;
  rebateGroup?: Maybe<TierRebate>;
  rebateGroupId?: Maybe<Scalars['ID']['output']>;
  rebateTierIndex?: Maybe<Scalars['Int']['output']>;
  rules?: Maybe<Array<TierRule>>;
  scope: TierRuleScope;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  value: Array<Scalars['Float']['output']>;
  vendors?: Maybe<Array<Scalars['String']['output']>>;
};

export type TierRebateInput = {
  advancedRulesJsonLogic?: InputMaybe<Scalars['String']['input']>;
  /** JSON object of advanced rules, interchangeable with advancedRulesJsonLogic */
  advancedRulesJsonLogicObject?: InputMaybe<Scalars['JSON']['input']>;
  conditionalStartDate?: ConditionalStartDate;
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  growth: Array<RebateGrowthInput>;
  metricType?: TierRebateMetricType;
  name: Scalars['String']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  payoutLevel?: TierRuleScope;
  periodType: TierRulePeriodType;
  productTsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If this rebateId is not null, then this will update existing tier rebate */
  rebateId?: InputMaybe<Scalars['String']['input']>;
  scope: TierRuleScope;
  tierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tierRules?: InputMaybe<TierRuleInput>;
  /** Rebate type (e.g. rebate, admin fee, etc.) */
  type: Scalars['String']['input'];
  vendors?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum TierRebateMetricType {
  DollarsPerUnit = 'dollarsPerUnit',
  FixedDollars = 'fixedDollars',
  PercentPerUnit = 'percentPerUnit'
}

export type TierRebateStats = {
  __typename?: 'TierRebateStats';
  message: Scalars['String']['output'];
  rebateId: Scalars['String']['output'];
  rebateName: Scalars['String']['output'];
  tierId: Scalars['String']['output'];
  totalRebate: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
};

export type TierRule = {
  __typename?: 'TierRule';
  basketIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Date']['output'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metricType: TierRuleMetricType;
  name?: Maybe<Scalars['String']['output']>;
  operator: TierRuleOperator;
  periodType: TierRulePeriodType;
  productTsIds?: Maybe<Array<Scalars['String']['output']>>;
  ruleType: TierRuleType;
  scope?: Maybe<TierRuleScope>;
  tier?: Maybe<Tier>;
  tierId?: Maybe<Scalars['String']['output']>;
  tierRebate?: Maybe<TierRebate>;
  tierRebateId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** value for the requirement, which can be a range, can be paired with valueSecond */
  valueFirst: Scalars['Float']['output'];
  /** value for the requirement, which can be a range, paired with valueFirst */
  valueSecond?: Maybe<Scalars['Float']['output']>;
  vendors?: Maybe<Array<Scalars['String']['output']>>;
};

export enum TierRuleBooleanOperator {
  And = 'and',
  Or = 'or'
}

export type TierRuleInput = {
  /** Advanced Rules JsonLogic based config */
  advancedJsonLogic?: InputMaybe<Scalars['String']['input']>;
  /** JSON object of advanced rules, interchangeable with advancedRulesJsonLogic */
  advancedRulesJsonLogicObject?: InputMaybe<Scalars['JSON']['input']>;
  booleanOperator?: TierRuleBooleanOperator;
  rules: Array<BaseTierRuleInput>;
};

export enum TierRuleMetricType {
  Dollar = 'dollar',
  DollarsPerUnit = 'dollarsPerUnit',
  PercentByDollar = 'percentByDollar',
  PercentByUnit = 'percentByUnit',
  PercentPerUnit = 'percentPerUnit',
  Unit = 'unit'
}

export enum TierRuleOperator {
  Between = 'between',
  Equal = 'equal',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual'
}

export enum TierRulePeriodType {
  Annually = 'annually',
  Monthly = 'monthly',
  OneTime = 'oneTime',
  Quarterly = 'quarterly',
  Semianually = 'semianually'
}

export enum TierRuleScope {
  Corporate = 'corporate',
  Facility = 'facility',
  TopParent = 'topParent'
}

export enum TierRuleType {
  MarketShare = 'marketShare',
  PurchaseVolume = 'purchaseVolume'
}

export type TierRuleValidation = {
  __typename?: 'TierRuleValidation';
  message: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum TierSortFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type TierStats = {
  __typename?: 'TierStats';
  lastUpdatedAt?: Maybe<Scalars['Date']['output']>;
};

export type TierSummary = {
  __typename?: 'TierSummary';
  itemCoverage: Scalars['Float']['output'];
  tier: Tier;
  totalIncumbentSpend: Scalars['Float']['output'];
  totalProjectedSpend: Scalars['Float']['output'];
};

export type TierValidation = {
  __typename?: 'TierValidation';
  message: Scalars['String']['output'];
  tier: Tier;
  validation: Scalars['Boolean']['output'];
};

export type TiersResult = {
  __typename?: 'TiersResult';
  hits: Array<Tier>;
  totalHits: Scalars['Int']['output'];
};

export type TiersSortInput = {
  direction?: InputMaybe<OrderDirection>;
  field: TierSortFieldEnum;
};

export type ToggleUserActivationInput = {
  userId: Scalars['String']['input'];
};

export type TopParentFilterTerms = {
  __typename?: 'TopParentFilterTerms';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TransactionTier = {
  __typename?: 'TransactionTier';
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type Trend = {
  __typename?: 'Trend';
  marketTrend?: Maybe<MarketTrend>;
  metrics?: Maybe<TrendMetrics>;
  pricing: Array<TrendPoint>;
  spend: Array<TrendPoint>;
  utilization: Array<TrendPoint>;
};

export type TrendMetrics = {
  __typename?: 'TrendMetrics';
  priceDelta: Scalars['Float']['output'];
  priceDeltaPercentage: Scalars['Float']['output'];
};

export type TrendPoint = {
  __typename?: 'TrendPoint';
  x: Scalars['String']['output'];
  y: Scalars['Float']['output'];
};

export type Unspsc = {
  __typename?: 'Unspsc';
  class: Scalars['String']['output'];
  classTitle: Scalars['String']['output'];
};

export type UnspscCommodity = {
  __typename?: 'UnspscCommodity';
  commodity: Scalars['String']['output'];
  commodityTitle: Scalars['String']['output'];
};

export type UpdateBasketSmartRulesConfigInput = {
  id: Scalars['ID']['input'];
  smartBasketConfig?: InputMaybe<SmartBasketConfigInput>;
};

export type UpdateBasketVisibilityInput = {
  id: Scalars['ID']['input'];
  visibility: BasketVisibilityEnum;
};

export type UpdateCatalogItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partTiers: Array<CatalogItemTierInput>;
  tsId: Scalars['String']['input'];
};

export type UpdateCatalogPartInput = {
  commodityId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gudId?: InputMaybe<Scalars['String']['input']>;
  linkedTsId?: InputMaybe<Scalars['String']['input']>;
  partTiers?: InputMaybe<Array<PriceTierInput>>;
  stanId?: InputMaybe<Scalars['String']['input']>;
  tsId: Scalars['String']['input'];
};

export type UpdateCatalogPartWithMasterTsIdInput = {
  masterCatalogTsId?: InputMaybe<Scalars['String']['input']>;
  tsId: Scalars['String']['input'];
};

export type UpdateCloakInput = {
  cloakCustomerId?: InputMaybe<Scalars['String']['input']>;
  cloakUserId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractBasketsInput = {
  basketIds: Array<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
};

export type UpdateContractInput = {
  activeDue: Scalars['Date']['input'];
  activeSince: Scalars['Date']['input'];
  /** Pull tiers the new window would leave outside back into it, with their parts and members */
  forceOutOfWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Move tiers that were sitting on the contract's old dates along with it */
  forceSticky?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  sourcingOfficer?: InputMaybe<Scalars['String']['input']>;
  subCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  supplier: Scalars['String']['input'];
};

export type TierDateImpact = {
  __typename?: 'TierDateImpact';
  effectiveDate?: Maybe<Scalars['DateOnly']['output']>;
  expirationDate?: Maybe<Scalars['DateOnly']['output']>;
  /** Facility activations this tier change would pull in */
  facilityActivations: Scalars['Int']['output'];
  /** The tier's expiration date was sitting on the contract's old end */
  matchedContractEnd: Scalars['Boolean']['output'];
  /** The tier's effective date was sitting on the contract's old start */
  matchedContractStart: Scalars['Boolean']['output'];
  newEffectiveDate?: Maybe<Scalars['DateOnly']['output']>;
  newExpirationDate?: Maybe<Scalars['DateOnly']['output']>;
  /** Part price ranges this tier change would pull in */
  partPriceRanges: Scalars['Int']['output'];
  tierId: Scalars['String']['output'];
  tierName: Scalars['String']['output'];
};

export type TierDateRowImpact = {
  __typename?: 'TierDateRowImpact';
  /** Facility activations affected */
  facilityActivations: Scalars['Int']['output'];
  /** Part price ranges affected */
  partPriceRanges: Scalars['Int']['output'];
};

export type CollapsingPartPriceRange = {
  __typename?: 'CollapsingPartPriceRange';
  effectiveEndDate?: Maybe<Scalars['DateOnly']['output']>;
  effectiveStartDate?: Maybe<Scalars['DateOnly']['output']>;
  partsTsId: Scalars['String']['output'];
};

export type UpdateContractTierResult = {
  __typename?: 'UpdateContractTierResult';
  /** Price ranges the change would erase — the change is refused while any of these exist */
  collapsingPartPriceRanges: Array<CollapsingPartPriceRange>;
  /** Rows the new period would leave outside — answer with `forceOutOfWindow`, or abandon the change */
  outOfWindow: TierDateRowImpact;
  /** Rows sitting on the tier's old dates — answer with `forceSticky` */
  sticky: TierDateRowImpact;
  /** The tier that was created or updated, when `updated` is true */
  tiersId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Boolean']['output'];
};

export type UpdateDraftContractResult = {
  __typename?: 'UpdateDraftContractResult';
  /** The saved contract, when `updated` is true */
  contract?: Maybe<Contract>;
  /** Tiers the new window would leave outside — answer with `forceOutOfWindow`, or abandon the change */
  outOfWindowTiers: Array<TierDateImpact>;
  /** Tiers sitting on the contract's old dates — answer with `forceSticky` */
  stickyTiers: Array<TierDateImpact>;
  updated: Scalars['Boolean']['output'];
};

export type UpdateContractMembersInput = {
  contractId: Scalars['String']['input'];
  members: Array<ContractMemberInput>;
  tierIds: Array<Scalars['String']['input']>;
};

export type UpdateContractPartInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  manufacturer: Scalars['String']['input'];
  mfgitem: Scalars['String']['input'];
  partTiers?: InputMaybe<Array<PartTierInput>>;
  rowId: Scalars['String']['input'];
  subCategory?: InputMaybe<Scalars['String']['input']>;
  tsId: Scalars['String']['input'];
  vendor?: InputMaybe<Scalars['String']['input']>;
  venitem?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractPartsInput = {
  parts: Array<UpdateContractPartInput>;
  tierIds: Array<Scalars['String']['input']>;
};

export type UpdateContractPartsOutput = {
  __typename?: 'UpdateContractPartsOutput';
  category?: Maybe<Scalars['String']['output']>;
  part: Part;
  rowId: Scalars['String']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
};

export type UpdateCrossReferenceListInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** #8023: a cross edited in place. A side left out stays as it is. */
export type UpdateCrossReferencePairInput = {
  contractItem?: InputMaybe<CrossReferencePairItemInput>;
  crossItem?: InputMaybe<CrossReferencePairItemInput>;
  id: Scalars['ID']['input'];
};

export type UpdateCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  broadJumpId?: InputMaybe<Scalars['String']['input']>;
  bypassEditableCheck?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxUser?: InputMaybe<Scalars['Int']['input']>;
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorFeatures?: InputMaybe<VendorFeaturesInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDashboardInput = {
  angleTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  arnValue?: InputMaybe<Scalars['String']['input']>;
  /** Valid CSS color value */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  basketList?: InputMaybe<Array<Scalars['String']['input']>>;
  contractList?: InputMaybe<Array<Scalars['String']['input']>>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of Ant Design Icons e.g DashboardOutlined */
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHistoriesInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  priceActivationDate?: InputMaybe<Scalars['Date']['input']>;
  priceDeactivationDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateMeInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Re-authentication token, required for updating sensitivity information like email */
  token?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMessageTemplateInput = {
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNetworkMemberRoleInput = {
  networkId: Scalars['String']['input'];
  role: UserNetworkRoleEnum;
  userId: Scalars['String']['input'];
};

export type UpdateOfferCustomFieldsInput = {
  extras: Scalars['JSON']['input'];
  offerId: Scalars['String']['input'];
};

export type UpdateOfferInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferStatusEnum>;
};

export type UpdateOfferResult = {
  __typename?: 'UpdateOfferResult';
  offer: Offer;
  validationError?: Maybe<Scalars['String']['output']>;
  validationPassed: Scalars['Boolean']['output'];
};

export type UpdateOfferTierInput = {
  add?: InputMaybe<Array<OfferTierInput>>;
  id: Scalars['String']['input'];
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOfferUploadKeyContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOfferUploadProviderInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOpportunityInput = {
  attachmentsUpdate?: InputMaybe<Array<OpportunityAttachmentInput>>;
  basketIds?: InputMaybe<Array<Scalars['String']['input']>>;
  basketSpendDateRange?: InputMaybe<BasketSpendDateRangeInput>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimateDueDate?: InputMaybe<Scalars['Date']['input']>;
  estimateStartDate?: InputMaybe<Scalars['Date']['input']>;
  goal?: InputMaybe<Scalars['Float']['input']>;
  goalThresholdMax?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  keyContactId?: InputMaybe<Scalars['String']['input']>;
  metrics?: InputMaybe<MetricsVendorType>;
  name?: InputMaybe<Scalars['String']['input']>;
  opportunityEmailSubjectTemplate?: InputMaybe<Scalars['String']['input']>;
  opportunityEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  sharedUsers?: InputMaybe<Array<BaseAclRecordInput>>;
  skipZeroQuantityItems?: InputMaybe<Scalars['Boolean']['input']>;
  vendors?: InputMaybe<Array<OpportunityInviteBaseInput>>;
};

export type UpdateOpportunityItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  manufacturerItem: Scalars['String']['input'];
  pricingTarget?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  uom: Scalars['String']['input'];
  uomConversion: Scalars['Int']['input'];
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendorItem?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  bypassEditableCheck?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  classOfTradeId?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  gpoFacilityId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  medicareId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationTypeId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartTierHistoryInput = {
  cotId?: InputMaybe<Scalars['Int']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['Date']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDshEligible?: InputMaybe<Scalars['Boolean']['input']>;
  partsTsId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  tiersId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedMappingInput = {
  id: Scalars['String']['input'];
  mappedFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateSavedSearchInput = {
  grouping?: InputMaybe<Array<GroupField>>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  pin?: InputMaybe<Scalars['Boolean']['input']>;
  searchFields?: InputMaybe<Array<ColumnAttributesInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScenarioByOfferInput = {
  award?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  /** A.k.a uncovered */
  remaining: Scalars['Boolean']['input'];
  scenarioId: Scalars['String']['input'];
  tierId: Scalars['String']['input'];
  type: ScenarioTierType;
  /** Scenario Opportunity item vendor */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScenarioCommitmentInput = {
  enableCommitment: Scalars['Boolean']['input'];
  scenarioId: Scalars['String']['input'];
};

export type UpdateSmartBasketInput = {
  addTsIds?: InputMaybe<Array<BasketProductInput>>;
  id: Scalars['ID']['input'];
  isSearchAll?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<SmartBasketRuleInput>>;
  smartBasketConfig?: InputMaybe<SmartBasketConfigInput>;
  visibility?: InputMaybe<BasketVisibilityEnum>;
};

export type UpdateSourcingPlanBasketInput = {
  /** SourcingPlanBasket's ID */
  id: Scalars['String']['input'];
  targetSavings?: InputMaybe<Scalars['Float']['input']>;
  targetSpend?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSourcingPlanBasketStakeholderInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  role: SourcingPlanStakeholderRole;
  sourcingPlanId: Scalars['String']['input'];
  support?: InputMaybe<Scalars['Boolean']['input']>;
  supportDate?: InputMaybe<Scalars['Date']['input']>;
  supportSurveyDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateSourcingPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facilities?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  savingsGoal: Scalars['Float']['input'];
  sharedUsers?: InputMaybe<Array<BaseAclRecordInput>>;
  targetCompletion: Scalars['Date']['input'];
  targetStart: Scalars['Date']['input'];
};

export type UpdateSourcingPlanStakeholderInput = {
  contactId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  role: SourcingPlanStakeholderRole;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  supportDate?: InputMaybe<Scalars['Date']['input']>;
  supportSurveyDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateSupplierOpportunityAclInput = {
  appianIds: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateSupplierOpportunityAttachmentsInput = {
  attachmentsUpdate: Array<OpportunityAttachmentInput>;
  id: Scalars['String']['input'];
};

export type UpdateSupplierOpportunityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  keyContact?: InputMaybe<UpdateOfferUploadKeyContactInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<UpdateOfferUploadProviderInput>;
};

export type UpdateTierCatalogPartPriceInput = {
  originalUom: Scalars['String']['input'];
  originalUomConversion: Scalars['Int']['input'];
  partsTsId: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  tierId: Scalars['String']['input'];
  uom: Scalars['String']['input'];
  uomConversion: Scalars['Int']['input'];
};

export type UpdateTierInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTierRuleInput = {
  /** Advanced Rules JsonLogic based config */
  advancedJsonLogic?: InputMaybe<Scalars['String']['input']>;
  /** JSON object of advanced rules, interchangeable with advancedRulesJsonLogic */
  advancedRulesJsonLogicObject?: InputMaybe<Scalars['JSON']['input']>;
  booleanOperator?: TierRuleBooleanOperator;
  rules: Array<BaseTierRuleInput>;
  tierId: Scalars['String']['input'];
};

export type UpdateUserInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalAuthConnectionId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isTopPowerUser?: InputMaybe<Scalars['Boolean']['input']>;
  isTopUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<Array<OrganizationPermission>>;
  permissions?: InputMaybe<Array<UserPermissionFeature>>;
  qsGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateVendorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  geoCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  maxUser?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vendorFeatures?: InputMaybe<VendorFeaturesInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBasketInput = {
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  selectedSheet?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBasketResult = {
  __typename?: 'UploadBasketResult';
  data: Array<MapField>;
  s3Key: Scalars['String']['output'];
};

export type UploadCatalogInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  /** The header row index in Excel file, default value is the first row, starting at 1 */
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  mapping: UploadCatalogMapping;
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type UploadCatalogMapping = {
  category?: InputMaybe<FieldLiteralMapping>;
  description?: InputMaybe<FieldLiteralMapping>;
  gtin?: InputMaybe<FieldLiteralMapping>;
  manufacturer: FieldLiteralMapping;
  manufacturerItem: FieldLiteralMapping;
  subCategory?: InputMaybe<FieldLiteralMapping>;
  tiers?: InputMaybe<Array<TierMapping>>;
  uom?: InputMaybe<FieldLiteralMapping>;
  uomConversion?: InputMaybe<FieldLiteralMapping>;
  vendor?: InputMaybe<FieldLiteralMapping>;
  vendorItem?: InputMaybe<FieldLiteralMapping>;
};

export type UploadContractInput = {
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  selectedSheet?: InputMaybe<Scalars['String']['input']>;
};

export type UploadContractResult = {
  __typename?: 'UploadContractResult';
  data: Array<MapField>;
  s3Key: Scalars['String']['output'];
};

export type UploadCrossRefInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  /** The header row index in Excel file, default value is the first row, starting at 1 */
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  mapping: UploadCrossRefMapping;
  /** New cross reference list's name */
  name: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type UploadCrossRefMapping = {
  competitorDescription?: InputMaybe<FieldLiteralMapping>;
  competitorGtin?: InputMaybe<FieldLiteralMapping>;
  competitorManufacturer: FieldLiteralMapping;
  competitorManufacturerItem: FieldLiteralMapping;
  competitorVendor?: InputMaybe<FieldLiteralMapping>;
  competitorVendorItem?: InputMaybe<FieldLiteralMapping>;
  description?: InputMaybe<FieldLiteralMapping>;
  gtin?: InputMaybe<FieldLiteralMapping>;
  manufacturer: FieldLiteralMapping;
  manufacturerItem: FieldLiteralMapping;
  matchType?: InputMaybe<FieldLiteralMapping>;
  vendor?: InputMaybe<FieldLiteralMapping>;
  vendorItem?: InputMaybe<FieldLiteralMapping>;
};

export type UploadHistories = {
  __typename?: 'UploadHistories';
  data: Array<UploadJob>;
};

export type UploadInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

export type UploadJob = {
  __typename?: 'UploadJob';
  callbackUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  currentProgress?: Maybe<JobProgressEvent>;
  errors?: Maybe<Scalars['JSON']['output']>;
  hasErrors: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** id of EC2 instance that processes the job */
  instance?: Maybe<Scalars['String']['output']>;
  jobType: Scalars['String']['output'];
  mappings?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  overrideCustomer?: Maybe<Customer>;
  parameters?: Maybe<Scalars['JSON']['output']>;
  queryString?: Maybe<Scalars['String']['output']>;
  result_stats?: Maybe<Scalars['JSON']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  selectedExcelSheet?: Maybe<Scalars['String']['output']>;
  status: UploadJobStatusEnum;
  updatedAt: Scalars['Date']['output'];
  uploaded_search_id?: Maybe<Scalars['String']['output']>;
  user: User;
};

export enum UploadJobStatusEnum {
  Failed = 'failed',
  Finished = 'finished',
  Processing = 'processing',
  Queue = 'queue'
}

export type UploadJobsByCriteriaInput = {
  jobType?: InputMaybe<JobTypeEnum>;
  jobTypes?: InputMaybe<Array<JobTypeEnum>>;
  pagination?: InputMaybe<Pagination>;
  statuses?: InputMaybe<Array<UploadJobStatusEnum>>;
};

export type UploadJobsResult = {
  __typename?: 'UploadJobsResult';
  data: Array<UploadJob>;
  totalHits?: Maybe<Scalars['Int']['output']>;
};

export type UploadOfferMapping = {
  conversion?: InputMaybe<FieldLiteralMapping>;
  description?: InputMaybe<FieldLiteralMapping>;
  manufacturer: FieldLiteralMapping;
  manufacturerItem: FieldLiteralMapping;
  quantity?: InputMaybe<FieldLiteralMapping>;
  uom?: InputMaybe<FieldLiteralMapping>;
  vendor?: InputMaybe<FieldLiteralMapping>;
  vendorItem?: InputMaybe<FieldLiteralMapping>;
};

export type UploadSearchFileInput = {
  data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  selectedExcelSheet?: InputMaybe<Scalars['String']['input']>;
};

export type UploadSearchResult = {
  __typename?: 'UploadSearchResult';
  data: Array<MapField>;
  s3Key: Scalars['String']['output'];
};

export type UploadedFileKeyInput = {
  uploadedSearchId: Scalars['String']['input'];
};

export type UploadedFileKeyResult = {
  __typename?: 'UploadedFileKeyResult';
  s3Key: Scalars['String']['output'];
};

export type UpsertContractPartTierHistoriesResult = {
  __typename?: 'UpsertContractPartTierHistoriesResult';
  partTierHistories: Array<PartTierHistory>;
  parts: Array<Part>;
};

export type UpsertMarkupRuleInput = {
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Array<Scalars['String']['input']>>;
  marketBasket?: InputMaybe<Array<Scalars['String']['input']>>;
  markupPercent: Scalars['Float']['input'];
  topParentId?: InputMaybe<Scalars['ID']['input']>;
  unspsc?: InputMaybe<Array<Scalars['String']['input']>>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertRebatePeriodActualInput = {
  actualReceived: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['String']['input']>;
  evidenceDocs?: InputMaybe<Array<EvidenceDocInput>>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  paymentType: Scalars['String']['input'];
  rebateId: Scalars['String']['input'];
  rebatePeriodOffset: Scalars['Int']['input'];
  receivedAt: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  tierId: Scalars['String']['input'];
  topParentId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  appianId?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  cloakCustomerId?: Maybe<Scalars['String']['output']>;
  cloakOrganizationIds?: Maybe<Array<Scalars['String']['output']>>;
  cloakUserId?: Maybe<Scalars['String']['output']>;
  cognitoId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  entraId?: Maybe<Scalars['String']['output']>;
  externalAuthConnectionId?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurvoAdmin: Scalars['Boolean']['output'];
  isManageable: Scalars['Boolean']['output'];
  isSupplierUser: Scalars['Boolean']['output'];
  isTopPowerUser: Scalars['Boolean']['output'];
  isTopUser: Scalars['Boolean']['output'];
  lastActionAt?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  linkedIn?: Maybe<Scalars['String']['output']>;
  organizations: Array<Organization>;
  permissions: UserAbilities;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  powerUserList: Array<PowerUserListItem>;
  projects: Array<Project>;
  provider?: Maybe<Scalars['String']['output']>;
  qsGroups?: Maybe<Array<Scalars['String']['output']>>;
  quicksightId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  title?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  userOrganizations: Array<UserOrganization>;
  username: Scalars['String']['output'];
};

/** For CASL, contains 2 lists of user abilities, can and cannot */
export type UserAbilities = {
  __typename?: 'UserAbilities';
  can: Array<UserCaslAbility>;
  cannot: Array<UserCaslAbility>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

/** For CASL, user ability */
export type UserCaslAbility = {
  __typename?: 'UserCASLAbility';
  permissionType: Scalars['String']['output'];
  value: UserPermissionFeature;
};

export type UserContext = {
  __typename?: 'UserContext';
  isAdmin: Scalars['Boolean']['output'];
  powerUserList: Array<PowerUserListItem>;
  user: User;
};

export type UserNetwork = {
  __typename?: 'UserNetwork';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invitationMeta?: Maybe<InvitationMeta>;
  networkId: Scalars['ID']['output'];
  role: UserNetworkRoleEnum;
  status: UserNetworkStatusEnum;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<UserNetworkMemberInfo>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserNetworkMemberInfo = {
  __typename?: 'UserNetworkMemberInfo';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum UserNetworkRoleEnum {
  Admin = 'admin',
  User = 'user'
}

export enum UserNetworkStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending'
}

export type UserOrganization = {
  __typename?: 'UserOrganization';
  addedByTopUser: Scalars['Boolean']['output'];
  isPowerUser: Scalars['Boolean']['output'];
  organizationsId: Scalars['ID']['output'];
  user: User;
  usersId: Scalars['ID']['output'];
};

export type UserOrganizationInput = {
  isPowerUser?: InputMaybe<Scalars['Boolean']['input']>;
  organizationsId: Scalars['String']['input'];
  usersId: Scalars['String']['input'];
};

export type UserOrganizationPermissionInput = {
  isPowerUser: Scalars['Boolean']['input'];
  organizationsId: Scalars['String']['input'];
  usersId: Scalars['String']['input'];
};

export type UserOrganizationRoleUpdateInputBase = {
  isPowerUser: Scalars['Boolean']['input'];
  usersId: Scalars['String']['input'];
};

export enum UserPermissionFeature {
  Activate = 'Activate',
  Analyze = 'Analyze',
  Enrich = 'Enrich',
  Null = 'Null',
  ProjectAperture = 'ProjectAperture',
  RebateOptimizer = 'RebateOptimizer',
  Baskets = 'baskets',
  BasketsReadonly = 'basketsReadonly',
  Catalog = 'catalog',
  Contracts = 'contracts',
  CxProjectTracker = 'cxProjectTracker',
  ImportStudy = 'importStudy',
  Initiatives = 'initiatives',
  Opportunities = 'opportunities',
  ProjectTracker = 'projectTracker',
  Reports = 'reports',
  SourcingPlans = 'sourcingPlans',
  Spending = 'spending',
  TeamQueue = 'teamQueue'
}

export enum UserStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending'
}

export type UsersResult = {
  __typename?: 'UsersResult';
  hits: Array<User>;
  totalHits: Scalars['Int']['output'];
};

export type VendorFeatures = {
  __typename?: 'VendorFeatures';
  opportunityUpload?: Maybe<Scalars['Boolean']['output']>;
  premiumFields?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorFeaturesInput = {
  opportunityUpload?: InputMaybe<Scalars['Boolean']['input']>;
  premiumFields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorPriority = {
  __typename?: 'VendorPriority';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum VendorResponsesEnum {
  Awaiting = 'Awaiting',
  Finished = 'Finished',
  Receiving = 'Receiving',
  Rejected = 'Rejected',
  Responding = 'Responding'
}

export type VendorUsersResult = {
  __typename?: 'VendorUsersResult';
  hits: Array<User>;
  totalHits: Scalars['Int']['output'];
};

export type VendorsResult = {
  __typename?: 'VendorsResult';
  hits: Array<Customer>;
  totalHits: Scalars['Int']['output'];
};

export type VerifyAccountInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export enum CrossReferenceCrossStatus {
  Crossed = 'Crossed',
  Instrument = 'Instrument',
  InvalidPartNumber = 'InvalidPartNumber',
  NoComparable = 'NoComparable',
  Other = 'Other',
  OutOfScope = 'OutOfScope',
  Uncrossed = 'Uncrossed'
}
